/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * Sklls API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessLevel,
  AddDialogStatisticCommand,
  AddScenarioCommand,
  AddUsersToGroupCommand,
  ApplyExerciseScheduleChangeDto,
  ApplyExerciseScheduleChangeResponseDto,
  ApplyPlaybookItemTimeChangeDto,
  ApplyPlaybookItemTimeChangeResponseDto,
  AttachmentDto,
  AudioResponseDto,
  Avatar,
  BulkRescheduleStoreProvisionalDialogStatisticRequest,
  CloneExerciseResponseDto,
  CompanyDepartmentDto,
  CompanyDto,
  ConversationExportFilterDto,
  ConversationFeedback,
  ConvertFromSharedScenarioCommand,
  CopyScenarioCommand,
  CourseDto,
  CourseGetParams,
  CourseGetUserScheduledCourseResultsParams,
  CreateCompanyCommand,
  CreateCompanyDepartmentCommand,
  CreateCourseCommand,
  CreateEvaluationProtocolCategoryCommand,
  CreateEvaluationProtocolCommand,
  CreateEvaluationProtocolElementCommand,
  CreateExerciseContactDto,
  CreateExerciseDto,
  CreateGlobalAssetCategoryCommand,
  CreateGlobalAssetIntentCommand,
  CreateLicenseAgreementDto,
  CreateOrganizationInvitationCommand,
  CreatePersonaDto,
  CreatePlaybookItemDto,
  CreateRoleDto,
  CreateScheduledCallCommand,
  CreateScheduledCourseCommand,
  CreateScheduledCourseNotificationCommand,
  CreateUserGroupCommand,
  DecisionSupportRequest,
  DecisionSupportResponse,
  DecisionSupportStructuredResponseDto,
  DeleteCompanyCommand,
  DeleteGlobalAssetCategoriesCommand,
  DeleteGlobalAssetIntentCommand,
  DeleteScheduledCallsCommand,
  DeleteUserGroupCommand,
  DeleteUsersFromGroupCommand,
  DepartmentInvitationDto,
  DialogFeedbackDto,
  DialogSessionInitSessionParams,
  DialogStatisticDto,
  DialogStatisticKpiDetailsDto,
  DialogStatisticsListDialogStatisticsServiceParams,
  EditUserAudioSettingsCommand,
  EditUserCommand,
  EditUserProfileCommand,
  EndCallCommand,
  EvaluationDto,
  EvaluationProtocolCategoryDto,
  EvaluationProtocolDto,
  EvaluationProtocolElementDto,
  EvaluationProtocolUsageDto,
  ExerciseContactDto,
  ExerciseDto,
  Gender,
  GenerateMagicPersonaPromptCommand,
  GenerateMagicRolePromptCommand,
  GeneratePersonaSentenceRequestDto,
  GeneratePersonaSentenceResponseDto,
  GetLicenseUsageBatchRequest,
  GlobalAssetCategoryDto,
  GlobalAssetConnection,
  GlobalAssetFullDto,
  GlobalAssetIntentDto,
  GlobalAssetsCopyIntentToCompanyParams,
  GlobalAssetsImportDataBodyOne,
  GlobalAssetsImportDataBodyTwo,
  InitPersonaSessionCommand,
  InviteMultipleUsersCommand,
  JobStatusDto,
  JobStatusGetRecentJobsPagedParams,
  JobStatusGetRecentJobsParams,
  LicenseAgreementDto,
  LicenseAgreementsGetUsageParams,
  LicenseUsageDto,
  PagedResultDtoJobStatusDto,
  PartialListCourseDto,
  PartialListDialogStatisticDto,
  PartialListScheduledCallDto,
  PartialListUserGroupDto,
  PersonaAudioResponse,
  PersonaCompanyAccessDto,
  PersonaCompanyAccessInfoDto,
  PersonaCompanyDto,
  PersonaDeletionValidationDto,
  PersonaDto,
  PersonaSessionInitResult,
  PlaybookItemDto,
  ProblemDetails,
  ProcessDialogCommand,
  ProcessResultDto,
  ProcessStartInboundCallBodyOne,
  ProcessStartInboundCallBodyTwo,
  RespondWithPersonaAudioCommand,
  RestoreScenarioVersionCommand,
  RoleCompanyDto,
  RoleDto,
  RolesGetRolesParams,
  ScenarioDialogStatisticDto,
  ScenarioDto,
  ScenarioGroupAddScenarioToGroupParams,
  ScenarioGroupCreateGroupParams,
  ScenarioGroupDto,
  ScenarioGroupRemoveScenesFromGroupParams,
  ScenarioNoteDto,
  ScenarioNoteRequest,
  ScenarioUpdateDto,
  ScenariosUpdateScenarioPdfBodyOne,
  ScenariosUpdateScenarioPdfBodyTwo,
  ScheduledCallDto,
  ScheduledCallsGetParams,
  ScheduledCallsUpdateStatusParams,
  ScheduledCourseAssignmentCommand,
  ScheduledCourseDto,
  ScheduledCourseNotificationDto,
  ScheduledCourseScenarioResultDto,
  ShareEvaluationProtocolCommand,
  ShareRoleDto,
  SimpleScenarioDto,
  Speaker,
  SpeechRecognizeSpeechBodyOne,
  SpeechRecognizeSpeechBodyTwo,
  SpeechRecognizeSpeechParams,
  SynthesizeSpeechCommand,
  TaskTemplateDto,
  TenantDto,
  TestExceptionRequest,
  TextToSpeechCommand,
  TrendingScenariosCommand,
  TriggerJobRequest,
  TwilioPhoneNumberDto,
  UnshareEvaluationProtocolCommand,
  UnshareRoleDto,
  UpdateCompanyCommand,
  UpdateCourseCommand,
  UpdateEvaluationProtocolCategoryCommand,
  UpdateEvaluationProtocolCommand,
  UpdateEvaluationProtocolCompanyAccessCommand,
  UpdateEvaluationProtocolElementCommand,
  UpdateExerciseContactDto,
  UpdateExerciseDto,
  UpdateGlobalAssetCategoryCommand,
  UpdateGlobalAssetIntentCommand,
  UpdateLicenseAgreementDto,
  UpdatePersonaDto,
  UpdatePlaybookItemDto,
  UpdateRoleDto,
  UpdateScenarioContentCommand,
  UpdateScenarioGroupCommand,
  UpdateScenarioSettingsCommand,
  UpdateScheduledCallCommand,
  UpdateScheduledCourseNotificationCommand,
  UpdateScheduledCourseRequestCommand,
  UpdateUserGroupCommand,
  UpdateUsersAdvancedSettingsCommand,
  UpdateUsersDepartmentCommand,
  UpdateUsersLicenseFeaturesCommand,
  UsageStatistic,
  UsageStatisticsDto,
  UsageStatisticsQuery,
  UserDto,
  UserGroupDto,
  UserGroupGetParams
} from './api.schemas';

import { customAxiosInstance } from '../api/mutator';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

export const accountEditUser = (editUserCommand: EditUserCommand) => {
  return customAxiosInstance<UserDto>({
    url: `/api/Account/EditUser`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editUserCommand
  });
};

export const getAccountEditUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUser>>,
    TError,
    { data: EditUserCommand },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof accountEditUser>>, TError, { data: EditUserCommand }, TContext> => {
  const mutationKey = ['accountEditUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountEditUser>>, { data: EditUserCommand }> = (
    props
  ) => {
    const { data } = props ?? {};

    return accountEditUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountEditUserMutationResult = NonNullable<Awaited<ReturnType<typeof accountEditUser>>>;
export type AccountEditUserMutationBody = EditUserCommand;
export type AccountEditUserMutationError = unknown;

export const useAccountEditUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUser>>,
    TError,
    { data: EditUserCommand },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof accountEditUser>>, TError, { data: EditUserCommand }, TContext> => {
  const mutationOptions = getAccountEditUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountEditUserProfile = (editUserProfileCommand: EditUserProfileCommand) => {
  return customAxiosInstance<UserDto>({
    url: `/api/Account/EditUserProfile`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editUserProfileCommand
  });
};

export const getAccountEditUserProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserProfile>>,
    TError,
    { data: EditUserProfileCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEditUserProfile>>,
  TError,
  { data: EditUserProfileCommand },
  TContext
> => {
  const mutationKey = ['accountEditUserProfile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEditUserProfile>>,
    { data: EditUserProfileCommand }
  > = (props) => {
    const { data } = props ?? {};

    return accountEditUserProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountEditUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof accountEditUserProfile>>>;
export type AccountEditUserProfileMutationBody = EditUserProfileCommand;
export type AccountEditUserProfileMutationError = unknown;

export const useAccountEditUserProfile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserProfile>>,
    TError,
    { data: EditUserProfileCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEditUserProfile>>,
  TError,
  { data: EditUserProfileCommand },
  TContext
> => {
  const mutationOptions = getAccountEditUserProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountEditUserAudioSettings = (editUserAudioSettingsCommand: EditUserAudioSettingsCommand) => {
  return customAxiosInstance<UserDto>({
    url: `/api/Account/EditUserAudioSettings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editUserAudioSettingsCommand
  });
};

export const getAccountEditUserAudioSettingsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
    TError,
    { data: EditUserAudioSettingsCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
  TError,
  { data: EditUserAudioSettingsCommand },
  TContext
> => {
  const mutationKey = ['accountEditUserAudioSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
    { data: EditUserAudioSettingsCommand }
  > = (props) => {
    const { data } = props ?? {};

    return accountEditUserAudioSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountEditUserAudioSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountEditUserAudioSettings>>
>;
export type AccountEditUserAudioSettingsMutationBody = EditUserAudioSettingsCommand;
export type AccountEditUserAudioSettingsMutationError = unknown;

export const useAccountEditUserAudioSettings = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
    TError,
    { data: EditUserAudioSettingsCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
  TError,
  { data: EditUserAudioSettingsCommand },
  TContext
> => {
  const mutationOptions = getAccountEditUserAudioSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountUpdateUsersDepartment = (updateUsersDepartmentCommand: UpdateUsersDepartmentCommand) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Account/UpdateUsersDepartment/updateUsersDepartment`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUsersDepartmentCommand
  });
};

export const getAccountUpdateUsersDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
    TError,
    { data: UpdateUsersDepartmentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
  TError,
  { data: UpdateUsersDepartmentCommand },
  TContext
> => {
  const mutationKey = ['accountUpdateUsersDepartment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
    { data: UpdateUsersDepartmentCommand }
  > = (props) => {
    const { data } = props ?? {};

    return accountUpdateUsersDepartment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountUpdateUsersDepartmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountUpdateUsersDepartment>>
>;
export type AccountUpdateUsersDepartmentMutationBody = UpdateUsersDepartmentCommand;
export type AccountUpdateUsersDepartmentMutationError = unknown;

export const useAccountUpdateUsersDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
    TError,
    { data: UpdateUsersDepartmentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
  TError,
  { data: UpdateUsersDepartmentCommand },
  TContext
> => {
  const mutationOptions = getAccountUpdateUsersDepartmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountUpdateUsersAdvancedSettings = (
  updateUsersAdvancedSettingsCommand: UpdateUsersAdvancedSettingsCommand
) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Account/UpdateUsersAdvancedSettings/updateUsersAdvancedSettings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUsersAdvancedSettingsCommand
  });
};

export const getAccountUpdateUsersAdvancedSettingsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
    TError,
    { data: UpdateUsersAdvancedSettingsCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
  TError,
  { data: UpdateUsersAdvancedSettingsCommand },
  TContext
> => {
  const mutationKey = ['accountUpdateUsersAdvancedSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
    { data: UpdateUsersAdvancedSettingsCommand }
  > = (props) => {
    const { data } = props ?? {};

    return accountUpdateUsersAdvancedSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountUpdateUsersAdvancedSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>
>;
export type AccountUpdateUsersAdvancedSettingsMutationBody = UpdateUsersAdvancedSettingsCommand;
export type AccountUpdateUsersAdvancedSettingsMutationError = unknown;

export const useAccountUpdateUsersAdvancedSettings = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
    TError,
    { data: UpdateUsersAdvancedSettingsCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
  TError,
  { data: UpdateUsersAdvancedSettingsCommand },
  TContext
> => {
  const mutationOptions = getAccountUpdateUsersAdvancedSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountUpdateUsersLicenseFeatures = (
  updateUsersLicenseFeaturesCommand: UpdateUsersLicenseFeaturesCommand
) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Account/UpdateUsersLicenseFeatures/updateUsersLicenseFeatures`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUsersLicenseFeaturesCommand
  });
};

export const getAccountUpdateUsersLicenseFeaturesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
    TError,
    { data: UpdateUsersLicenseFeaturesCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
  TError,
  { data: UpdateUsersLicenseFeaturesCommand },
  TContext
> => {
  const mutationKey = ['accountUpdateUsersLicenseFeatures'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
    { data: UpdateUsersLicenseFeaturesCommand }
  > = (props) => {
    const { data } = props ?? {};

    return accountUpdateUsersLicenseFeatures(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountUpdateUsersLicenseFeaturesMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>
>;
export type AccountUpdateUsersLicenseFeaturesMutationBody = UpdateUsersLicenseFeaturesCommand;
export type AccountUpdateUsersLicenseFeaturesMutationError = unknown;

export const useAccountUpdateUsersLicenseFeatures = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
    TError,
    { data: UpdateUsersLicenseFeaturesCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
  TError,
  { data: UpdateUsersLicenseFeaturesCommand },
  TContext
> => {
  const mutationOptions = getAccountUpdateUsersLicenseFeaturesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountAllowRecord = () => {
  return customAxiosInstance<UserDto>({ url: `/api/Account/AllowRecord/allowRecord`, method: 'PUT' });
};

export const getAccountAllowRecordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext> => {
  const mutationKey = ['accountAllowRecord'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountAllowRecord>>, void> = () => {
    return accountAllowRecord();
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountAllowRecordMutationResult = NonNullable<Awaited<ReturnType<typeof accountAllowRecord>>>;

export type AccountAllowRecordMutationError = unknown;

export const useAccountAllowRecord = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext> => {
  const mutationOptions = getAccountAllowRecordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const avatarGetAllAvatars = (signal?: AbortSignal) => {
  return customAxiosInstance<Avatar[]>({ url: `/api/Avatar/GetAllAvatars`, method: 'GET', signal });
};

export const getAvatarGetAllAvatarsQueryKey = () => {
  return [`/api/Avatar/GetAllAvatars`] as const;
};

export const getAvatarGetAllAvatarsQueryOptions = <
  TData = Awaited<ReturnType<typeof avatarGetAllAvatars>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof avatarGetAllAvatars>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAvatarGetAllAvatarsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarGetAllAvatars>>> = ({ signal }) =>
    avatarGetAllAvatars(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof avatarGetAllAvatars>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvatarGetAllAvatarsQueryResult = NonNullable<Awaited<ReturnType<typeof avatarGetAllAvatars>>>;
export type AvatarGetAllAvatarsQueryError = unknown;

export function useAvatarGetAllAvatars<
  TData = Awaited<ReturnType<typeof avatarGetAllAvatars>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof avatarGetAllAvatars>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvatarGetAllAvatarsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const companiesFilterCompanies = (signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto[]>({ url: `/api/Companies/FilterCompanies`, method: 'GET', signal });
};

export const getCompaniesFilterCompaniesQueryKey = () => {
  return [`/api/Companies/FilterCompanies`] as const;
};

export const getCompaniesFilterCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof companiesFilterCompanies>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companiesFilterCompanies>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompaniesFilterCompaniesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesFilterCompanies>>> = ({ signal }) =>
    companiesFilterCompanies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companiesFilterCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompaniesFilterCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof companiesFilterCompanies>>>;
export type CompaniesFilterCompaniesQueryError = unknown;

export function useCompaniesFilterCompanies<
  TData = Awaited<ReturnType<typeof companiesFilterCompanies>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companiesFilterCompanies>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompaniesFilterCompaniesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const companiesGetCompany = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto>({ url: `/api/Companies/GetCompany/${id}`, method: 'GET', signal });
};

export const getCompaniesGetCompanyQueryKey = (id?: number) => {
  return [`/api/Companies/GetCompany/${id}`] as const;
};

export const getCompaniesGetCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof companiesGetCompany>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesGetCompany>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompaniesGetCompanyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesGetCompany>>> = ({ signal }) =>
    companiesGetCompany(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companiesGetCompany>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompaniesGetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof companiesGetCompany>>>;
export type CompaniesGetCompanyQueryError = unknown;

export function useCompaniesGetCompany<TData = Awaited<ReturnType<typeof companiesGetCompany>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesGetCompany>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompaniesGetCompanyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const companiesAddCompany = (createCompanyCommand: CreateCompanyCommand, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto>({
    url: `/api/Companies/AddCompany`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyCommand,
    signal
  });
};

export const getCompaniesAddCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesAddCompany>>,
    TError,
    { data: CreateCompanyCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companiesAddCompany>>,
  TError,
  { data: CreateCompanyCommand },
  TContext
> => {
  const mutationKey = ['companiesAddCompany'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companiesAddCompany>>,
    { data: CreateCompanyCommand }
  > = (props) => {
    const { data } = props ?? {};

    return companiesAddCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompaniesAddCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesAddCompany>>>;
export type CompaniesAddCompanyMutationBody = CreateCompanyCommand;
export type CompaniesAddCompanyMutationError = unknown;

export const useCompaniesAddCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesAddCompany>>,
    TError,
    { data: CreateCompanyCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companiesAddCompany>>,
  TError,
  { data: CreateCompanyCommand },
  TContext
> => {
  const mutationOptions = getCompaniesAddCompanyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const companiesEditCompany = (updateCompanyCommand: NonReadonly<UpdateCompanyCommand>) => {
  return customAxiosInstance<CompanyDto>({
    url: `/api/Companies/EditCompany`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateCompanyCommand
  });
};

export const getCompaniesEditCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesEditCompany>>,
    TError,
    { data: NonReadonly<UpdateCompanyCommand> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companiesEditCompany>>,
  TError,
  { data: NonReadonly<UpdateCompanyCommand> },
  TContext
> => {
  const mutationKey = ['companiesEditCompany'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companiesEditCompany>>,
    { data: NonReadonly<UpdateCompanyCommand> }
  > = (props) => {
    const { data } = props ?? {};

    return companiesEditCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompaniesEditCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesEditCompany>>>;
export type CompaniesEditCompanyMutationBody = NonReadonly<UpdateCompanyCommand>;
export type CompaniesEditCompanyMutationError = unknown;

export const useCompaniesEditCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesEditCompany>>,
    TError,
    { data: NonReadonly<UpdateCompanyCommand> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companiesEditCompany>>,
  TError,
  { data: NonReadonly<UpdateCompanyCommand> },
  TContext
> => {
  const mutationOptions = getCompaniesEditCompanyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const companiesDeleteCompany = (deleteCompanyCommand: DeleteCompanyCommand) => {
  return customAxiosInstance<void>({
    url: `/api/Companies/DeleteCompany`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteCompanyCommand
  });
};

export const getCompaniesDeleteCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesDeleteCompany>>,
    TError,
    { data: DeleteCompanyCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companiesDeleteCompany>>,
  TError,
  { data: DeleteCompanyCommand },
  TContext
> => {
  const mutationKey = ['companiesDeleteCompany'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companiesDeleteCompany>>,
    { data: DeleteCompanyCommand }
  > = (props) => {
    const { data } = props ?? {};

    return companiesDeleteCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompaniesDeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesDeleteCompany>>>;
export type CompaniesDeleteCompanyMutationBody = DeleteCompanyCommand;
export type CompaniesDeleteCompanyMutationError = unknown;

export const useCompaniesDeleteCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesDeleteCompany>>,
    TError,
    { data: DeleteCompanyCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companiesDeleteCompany>>,
  TError,
  { data: DeleteCompanyCommand },
  TContext
> => {
  const mutationOptions = getCompaniesDeleteCompanyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const companyGetAllDepartments = (signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDepartmentDto[]>({
    url: `/api/Company/GetAllDepartments/departments`,
    method: 'GET',
    signal
  });
};

export const getCompanyGetAllDepartmentsQueryKey = () => {
  return [`/api/Company/GetAllDepartments/departments`] as const;
};

export const getCompanyGetAllDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof companyGetAllDepartments>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetAllDepartments>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompanyGetAllDepartmentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetAllDepartments>>> = ({ signal }) =>
    companyGetAllDepartments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companyGetAllDepartments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompanyGetAllDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetAllDepartments>>>;
export type CompanyGetAllDepartmentsQueryError = unknown;

export function useCompanyGetAllDepartments<
  TData = Awaited<ReturnType<typeof companyGetAllDepartments>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetAllDepartments>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompanyGetAllDepartmentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const companyGetDepartments = (companyId: number, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDepartmentDto[]>({
    url: `/api/Company/GetDepartments/${companyId}/departments`,
    method: 'GET',
    signal
  });
};

export const getCompanyGetDepartmentsQueryKey = (companyId?: number) => {
  return [`/api/Company/GetDepartments/${companyId}/departments`] as const;
};

export const getCompanyGetDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof companyGetDepartments>>,
  TError = unknown
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetDepartments>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompanyGetDepartmentsQueryKey(companyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetDepartments>>> = ({ signal }) =>
    companyGetDepartments(companyId, signal);

  return { queryKey, queryFn, enabled: !!companyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companyGetDepartments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompanyGetDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetDepartments>>>;
export type CompanyGetDepartmentsQueryError = unknown;

export function useCompanyGetDepartments<TData = Awaited<ReturnType<typeof companyGetDepartments>>, TError = unknown>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetDepartments>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompanyGetDepartmentsQueryOptions(companyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const companyCreateDepartment = (
  companyId: number,
  createCompanyDepartmentCommand: CreateCompanyDepartmentCommand
) => {
  return customAxiosInstance<CompanyDepartmentDto>({
    url: `/api/Company/CreateDepartment/${companyId}/departments`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyDepartmentCommand
  });
};

export const getCompanyCreateDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyCreateDepartment>>,
    TError,
    { companyId: number; data: CreateCompanyDepartmentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companyCreateDepartment>>,
  TError,
  { companyId: number; data: CreateCompanyDepartmentCommand },
  TContext
> => {
  const mutationKey = ['companyCreateDepartment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companyCreateDepartment>>,
    { companyId: number; data: CreateCompanyDepartmentCommand }
  > = (props) => {
    const { companyId, data } = props ?? {};

    return companyCreateDepartment(companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompanyCreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof companyCreateDepartment>>>;
export type CompanyCreateDepartmentMutationBody = CreateCompanyDepartmentCommand;
export type CompanyCreateDepartmentMutationError = unknown;

export const useCompanyCreateDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyCreateDepartment>>,
    TError,
    { companyId: number; data: CreateCompanyDepartmentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companyCreateDepartment>>,
  TError,
  { companyId: number; data: CreateCompanyDepartmentCommand },
  TContext
> => {
  const mutationOptions = getCompanyCreateDepartmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const companyUpdateDepartment = (
  departmentId: number,
  createCompanyDepartmentCommand: CreateCompanyDepartmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<CompanyDepartmentDto>({
    url: `/api/Company/UpdateDepartment/departments/${departmentId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyDepartmentCommand,
    signal
  });
};

export const getCompanyUpdateDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyUpdateDepartment>>,
    TError,
    { departmentId: number; data: CreateCompanyDepartmentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companyUpdateDepartment>>,
  TError,
  { departmentId: number; data: CreateCompanyDepartmentCommand },
  TContext
> => {
  const mutationKey = ['companyUpdateDepartment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companyUpdateDepartment>>,
    { departmentId: number; data: CreateCompanyDepartmentCommand }
  > = (props) => {
    const { departmentId, data } = props ?? {};

    return companyUpdateDepartment(departmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompanyUpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof companyUpdateDepartment>>>;
export type CompanyUpdateDepartmentMutationBody = CreateCompanyDepartmentCommand;
export type CompanyUpdateDepartmentMutationError = unknown;

export const useCompanyUpdateDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyUpdateDepartment>>,
    TError,
    { departmentId: number; data: CreateCompanyDepartmentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companyUpdateDepartment>>,
  TError,
  { departmentId: number; data: CreateCompanyDepartmentCommand },
  TContext
> => {
  const mutationOptions = getCompanyUpdateDepartmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const companyDeleteDepartment = (departmentId: number) => {
  return customAxiosInstance<void>({
    url: `/api/Company/DeleteDepartment/departments/${departmentId}`,
    method: 'DELETE'
  });
};

export const getCompanyDeleteDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyDeleteDepartment>>,
    TError,
    { departmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companyDeleteDepartment>>,
  TError,
  { departmentId: number },
  TContext
> => {
  const mutationKey = ['companyDeleteDepartment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyDeleteDepartment>>, { departmentId: number }> = (
    props
  ) => {
    const { departmentId } = props ?? {};

    return companyDeleteDepartment(departmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompanyDeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof companyDeleteDepartment>>>;

export type CompanyDeleteDepartmentMutationError = unknown;

export const useCompanyDeleteDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyDeleteDepartment>>,
    TError,
    { departmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companyDeleteDepartment>>,
  TError,
  { departmentId: number },
  TContext
> => {
  const mutationOptions = getCompanyDeleteDepartmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const companyGetInvitations = (signal?: AbortSignal) => {
  return customAxiosInstance<DepartmentInvitationDto[]>({
    url: `/api/Company/GetInvitations/invitations`,
    method: 'GET',
    signal
  });
};

export const getCompanyGetInvitationsQueryKey = () => {
  return [`/api/Company/GetInvitations/invitations`] as const;
};

export const getCompanyGetInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof companyGetInvitations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetInvitations>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompanyGetInvitationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetInvitations>>> = ({ signal }) =>
    companyGetInvitations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companyGetInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompanyGetInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetInvitations>>>;
export type CompanyGetInvitationsQueryError = unknown;

export function useCompanyGetInvitations<
  TData = Awaited<ReturnType<typeof companyGetInvitations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetInvitations>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompanyGetInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationCreateEvaluationProtocol = (
  createEvaluationProtocolCommand: CreateEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationCreateEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
    TError,
    { data: CreateEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
  TError,
  { data: CreateEvaluationProtocolCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationCreateEvaluationProtocol'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
    { data: CreateEvaluationProtocolCommand }
  > = (props) => {
    const { data } = props ?? {};

    return conversationEvaluationCreateEvaluationProtocol(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationCreateEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>
>;
export type ConversationEvaluationCreateEvaluationProtocolMutationBody = CreateEvaluationProtocolCommand;
export type ConversationEvaluationCreateEvaluationProtocolMutationError = unknown;

export const useConversationEvaluationCreateEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
    TError,
    { data: CreateEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
  TError,
  { data: CreateEvaluationProtocolCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationCreateEvaluationProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationGetEvaluationProtocols = (signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolDto[]>({ url: `/api/evaluation/protocols`, method: 'GET', signal });
};

export const getConversationEvaluationGetEvaluationProtocolsQueryKey = () => {
  return [`/api/evaluation/protocols`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolsQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocols(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>
>;
export type ConversationEvaluationGetEvaluationProtocolsQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocols<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationGetEvaluationProtocol = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolDto>({ url: `/api/evaluation/protocols/${id}`, method: 'GET', signal });
};

export const getConversationEvaluationGetEvaluationProtocolQueryKey = (id?: number) => {
  return [`/api/evaluation/protocols/${id}`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocol(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>
>;
export type ConversationEvaluationGetEvaluationProtocolQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocol<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationUpdateEvaluationProtocol = (
  id: number,
  updateEvaluationProtocolCommand: UpdateEvaluationProtocolCommand
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolCommand
  });
};

export const getConversationEvaluationUpdateEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
    TError,
    { id: number; data: UpdateEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
  TError,
  { id: number; data: UpdateEvaluationProtocolCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationUpdateEvaluationProtocol'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
    { id: number; data: UpdateEvaluationProtocolCommand }
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationProtocol(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>
>;
export type ConversationEvaluationUpdateEvaluationProtocolMutationBody = UpdateEvaluationProtocolCommand;
export type ConversationEvaluationUpdateEvaluationProtocolMutationError = unknown;

export const useConversationEvaluationUpdateEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
    TError,
    { id: number; data: UpdateEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
  TError,
  { id: number; data: UpdateEvaluationProtocolCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationUpdateEvaluationProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationDeleteEvaluationProtocol = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/protocols/${id}`, method: 'DELETE' });
};

export const getConversationEvaluationDeleteEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['conversationEvaluationDeleteEvaluationProtocol'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return conversationEvaluationDeleteEvaluationProtocol(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>
>;

export type ConversationEvaluationDeleteEvaluationProtocolMutationError = unknown;

export const useConversationEvaluationDeleteEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getConversationEvaluationDeleteEvaluationProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationShareEvaluationProtocol = (
  id: number,
  shareEvaluationProtocolCommand: ShareEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shareEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationShareEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
    TError,
    { id: number; data: ShareEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
  TError,
  { id: number; data: ShareEvaluationProtocolCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationShareEvaluationProtocol'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
    { id: number; data: ShareEvaluationProtocolCommand }
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationShareEvaluationProtocol(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationShareEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>
>;
export type ConversationEvaluationShareEvaluationProtocolMutationBody = ShareEvaluationProtocolCommand;
export type ConversationEvaluationShareEvaluationProtocolMutationError = unknown;

export const useConversationEvaluationShareEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
    TError,
    { id: number; data: ShareEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
  TError,
  { id: number; data: ShareEvaluationProtocolCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationShareEvaluationProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationUnshareEvaluationProtocol = (
  id: number,
  unshareEvaluationProtocolCommand: UnshareEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}/unshare`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unshareEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationUnshareEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
    TError,
    { id: number; data: UnshareEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
  TError,
  { id: number; data: UnshareEvaluationProtocolCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationUnshareEvaluationProtocol'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
    { id: number; data: UnshareEvaluationProtocolCommand }
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationUnshareEvaluationProtocol(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUnshareEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>
>;
export type ConversationEvaluationUnshareEvaluationProtocolMutationBody = UnshareEvaluationProtocolCommand;
export type ConversationEvaluationUnshareEvaluationProtocolMutationError = unknown;

export const useConversationEvaluationUnshareEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
    TError,
    { id: number; data: UnshareEvaluationProtocolCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
  TError,
  { id: number; data: UnshareEvaluationProtocolCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationUnshareEvaluationProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationGetProtocolUsage = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolUsageDto[]>({
    url: `/api/evaluation/protocols/${id}/usage`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetProtocolUsageQueryKey = (id?: number) => {
  return [`/api/evaluation/protocols/${id}/usage`] as const;
};

export const getConversationEvaluationGetProtocolUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetProtocolUsageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>> = ({ signal }) =>
    conversationEvaluationGetProtocolUsage(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetProtocolUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>
>;
export type ConversationEvaluationGetProtocolUsageQueryError = unknown;

export function useConversationEvaluationGetProtocolUsage<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetProtocolUsageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationCreateEvaluationProtocolCategory = (
  protocolId: number,
  createEvaluationProtocolCategoryCommand: CreateEvaluationProtocolCategoryCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto>({
    url: `/api/evaluation/protocols/${protocolId}/categories`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationProtocolCategoryCommand,
    signal
  });
};

export const getConversationEvaluationCreateEvaluationProtocolCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
    TError,
    { protocolId: number; data: CreateEvaluationProtocolCategoryCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
  TError,
  { protocolId: number; data: CreateEvaluationProtocolCategoryCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationCreateEvaluationProtocolCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
    { protocolId: number; data: CreateEvaluationProtocolCategoryCommand }
  > = (props) => {
    const { protocolId, data } = props ?? {};

    return conversationEvaluationCreateEvaluationProtocolCategory(protocolId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>
>;
export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationBody =
  CreateEvaluationProtocolCategoryCommand;
export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationError = unknown;

export const useConversationEvaluationCreateEvaluationProtocolCategory = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
    TError,
    { protocolId: number; data: CreateEvaluationProtocolCategoryCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
  TError,
  { protocolId: number; data: CreateEvaluationProtocolCategoryCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationCreateEvaluationProtocolCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationGetEvaluationProtocolCategories = (protocolId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto[]>({
    url: `/api/evaluation/protocols/${protocolId}/categories`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolCategoriesQueryKey = (protocolId?: number) => {
  return [`/api/evaluation/protocols/${protocolId}/categories`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
  TError = unknown
>(
  protocolId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolCategoriesQueryKey(protocolId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolCategories(protocolId, signal);

  return { queryKey, queryFn, enabled: !!protocolId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>
>;
export type ConversationEvaluationGetEvaluationProtocolCategoriesQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolCategories<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
  TError = unknown
>(
  protocolId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolCategoriesQueryOptions(protocolId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationGetEvaluationProtocolCategory = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto>({
    url: `/api/evaluation/categories/${categoryId}`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolCategoryQueryKey = (categoryId?: number) => {
  return [`/api/evaluation/categories/${categoryId}`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolCategoryQueryKey(categoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolCategory(categoryId, signal);

  return { queryKey, queryFn, enabled: !!categoryId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>
>;
export type ConversationEvaluationGetEvaluationProtocolCategoryQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolCategory<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolCategoryQueryOptions(categoryId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationUpdateEvaluationProtocolCategory = (
  categoryId: number,
  updateEvaluationProtocolCategoryCommand: UpdateEvaluationProtocolCategoryCommand
) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto>({
    url: `/api/evaluation/categories/${categoryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolCategoryCommand
  });
};

export const getConversationEvaluationUpdateEvaluationProtocolCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
    TError,
    { categoryId: number; data: UpdateEvaluationProtocolCategoryCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
  TError,
  { categoryId: number; data: UpdateEvaluationProtocolCategoryCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationUpdateEvaluationProtocolCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
    { categoryId: number; data: UpdateEvaluationProtocolCategoryCommand }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationProtocolCategory(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>
>;
export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationBody =
  UpdateEvaluationProtocolCategoryCommand;
export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationError = unknown;

export const useConversationEvaluationUpdateEvaluationProtocolCategory = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
    TError,
    { categoryId: number; data: UpdateEvaluationProtocolCategoryCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
  TError,
  { categoryId: number; data: UpdateEvaluationProtocolCategoryCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationUpdateEvaluationProtocolCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationDeleteEvaluationProtocolCategory = (categoryId: number) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/categories/${categoryId}`, method: 'DELETE' });
};

export const getConversationEvaluationDeleteEvaluationProtocolCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
    TError,
    { categoryId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
  TError,
  { categoryId: number },
  TContext
> => {
  const mutationKey = ['conversationEvaluationDeleteEvaluationProtocolCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
    { categoryId: number }
  > = (props) => {
    const { categoryId } = props ?? {};

    return conversationEvaluationDeleteEvaluationProtocolCategory(categoryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationProtocolCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>
>;

export type ConversationEvaluationDeleteEvaluationProtocolCategoryMutationError = unknown;

export const useConversationEvaluationDeleteEvaluationProtocolCategory = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
    TError,
    { categoryId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
  TError,
  { categoryId: number },
  TContext
> => {
  const mutationOptions = getConversationEvaluationDeleteEvaluationProtocolCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationReorderEvaluationProtocolCategories = (
  protocolId: number,
  conversationEvaluationReorderEvaluationProtocolCategoriesBody: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/evaluation/protocols/${protocolId}/categories/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationEvaluationReorderEvaluationProtocolCategoriesBody,
    signal
  });
};

export const getConversationEvaluationReorderEvaluationProtocolCategoriesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
    TError,
    { protocolId: number; data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
  TError,
  { protocolId: number; data: number[] },
  TContext
> => {
  const mutationKey = ['conversationEvaluationReorderEvaluationProtocolCategories'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
    { protocolId: number; data: number[] }
  > = (props) => {
    const { protocolId, data } = props ?? {};

    return conversationEvaluationReorderEvaluationProtocolCategories(protocolId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>
>;
export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationBody = number[];
export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationError = unknown;

export const useConversationEvaluationReorderEvaluationProtocolCategories = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
    TError,
    { protocolId: number; data: number[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
  TError,
  { protocolId: number; data: number[] },
  TContext
> => {
  const mutationOptions = getConversationEvaluationReorderEvaluationProtocolCategoriesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationCreateEvaluationProtocolElement = (
  categoryId: number,
  createEvaluationProtocolElementCommand: CreateEvaluationProtocolElementCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolElementDto>({
    url: `/api/evaluation/categories/${categoryId}/elements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationProtocolElementCommand,
    signal
  });
};

export const getConversationEvaluationCreateEvaluationProtocolElementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
    TError,
    { categoryId: number; data: CreateEvaluationProtocolElementCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
  TError,
  { categoryId: number; data: CreateEvaluationProtocolElementCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationCreateEvaluationProtocolElement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
    { categoryId: number; data: CreateEvaluationProtocolElementCommand }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return conversationEvaluationCreateEvaluationProtocolElement(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationCreateEvaluationProtocolElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>
>;
export type ConversationEvaluationCreateEvaluationProtocolElementMutationBody = CreateEvaluationProtocolElementCommand;
export type ConversationEvaluationCreateEvaluationProtocolElementMutationError = unknown;

export const useConversationEvaluationCreateEvaluationProtocolElement = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
    TError,
    { categoryId: number; data: CreateEvaluationProtocolElementCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
  TError,
  { categoryId: number; data: CreateEvaluationProtocolElementCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationCreateEvaluationProtocolElementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationGetEvaluationProtocolElements = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolElementDto[]>({
    url: `/api/evaluation/categories/${categoryId}/elements`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolElementsQueryKey = (categoryId?: number) => {
  return [`/api/evaluation/categories/${categoryId}/elements`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolElementsQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolElementsQueryKey(categoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolElements(categoryId, signal);

  return { queryKey, queryFn, enabled: !!categoryId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolElementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>
>;
export type ConversationEvaluationGetEvaluationProtocolElementsQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolElements<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolElementsQueryOptions(categoryId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationGetEvaluationProtocolElement = (elementId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolElementDto>({
    url: `/api/evaluation/elements/${elementId}`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolElementQueryKey = (elementId?: number) => {
  return [`/api/evaluation/elements/${elementId}`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolElementQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
  TError = unknown
>(
  elementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolElementQueryKey(elementId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolElement(elementId, signal);

  return { queryKey, queryFn, enabled: !!elementId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolElementQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>
>;
export type ConversationEvaluationGetEvaluationProtocolElementQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolElement<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
  TError = unknown
>(
  elementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolElementQueryOptions(elementId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationUpdateEvaluationProtocolElement = (
  elementId: number,
  updateEvaluationProtocolElementCommand: UpdateEvaluationProtocolElementCommand
) => {
  return customAxiosInstance<EvaluationProtocolElementDto>({
    url: `/api/evaluation/elements/${elementId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolElementCommand
  });
};

export const getConversationEvaluationUpdateEvaluationProtocolElementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
    TError,
    { elementId: number; data: UpdateEvaluationProtocolElementCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
  TError,
  { elementId: number; data: UpdateEvaluationProtocolElementCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationUpdateEvaluationProtocolElement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
    { elementId: number; data: UpdateEvaluationProtocolElementCommand }
  > = (props) => {
    const { elementId, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationProtocolElement(elementId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationProtocolElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>
>;
export type ConversationEvaluationUpdateEvaluationProtocolElementMutationBody = UpdateEvaluationProtocolElementCommand;
export type ConversationEvaluationUpdateEvaluationProtocolElementMutationError = unknown;

export const useConversationEvaluationUpdateEvaluationProtocolElement = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
    TError,
    { elementId: number; data: UpdateEvaluationProtocolElementCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
  TError,
  { elementId: number; data: UpdateEvaluationProtocolElementCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationUpdateEvaluationProtocolElementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationDeleteEvaluationProtocolElement = (elementId: number) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/elements/${elementId}`, method: 'DELETE' });
};

export const getConversationEvaluationDeleteEvaluationProtocolElementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
    TError,
    { elementId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
  TError,
  { elementId: number },
  TContext
> => {
  const mutationKey = ['conversationEvaluationDeleteEvaluationProtocolElement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
    { elementId: number }
  > = (props) => {
    const { elementId } = props ?? {};

    return conversationEvaluationDeleteEvaluationProtocolElement(elementId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationProtocolElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>
>;

export type ConversationEvaluationDeleteEvaluationProtocolElementMutationError = unknown;

export const useConversationEvaluationDeleteEvaluationProtocolElement = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
    TError,
    { elementId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
  TError,
  { elementId: number },
  TContext
> => {
  const mutationOptions = getConversationEvaluationDeleteEvaluationProtocolElementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationReorderEvaluationProtocolElements = (
  categoryId: number,
  conversationEvaluationReorderEvaluationProtocolElementsBody: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/evaluation/categories/${categoryId}/elements/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationEvaluationReorderEvaluationProtocolElementsBody,
    signal
  });
};

export const getConversationEvaluationReorderEvaluationProtocolElementsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
    TError,
    { categoryId: number; data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
  TError,
  { categoryId: number; data: number[] },
  TContext
> => {
  const mutationKey = ['conversationEvaluationReorderEvaluationProtocolElements'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
    { categoryId: number; data: number[] }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return conversationEvaluationReorderEvaluationProtocolElements(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationReorderEvaluationProtocolElementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>
>;
export type ConversationEvaluationReorderEvaluationProtocolElementsMutationBody = number[];
export type ConversationEvaluationReorderEvaluationProtocolElementsMutationError = unknown;

export const useConversationEvaluationReorderEvaluationProtocolElements = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
    TError,
    { categoryId: number; data: number[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
  TError,
  { categoryId: number; data: number[] },
  TContext
> => {
  const mutationOptions = getConversationEvaluationReorderEvaluationProtocolElementsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationUpdateProtocolCompanyAccess = (
  id: number,
  companyId: number,
  updateEvaluationProtocolCompanyAccessCommand: UpdateEvaluationProtocolCompanyAccessCommand
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}/companies/${companyId}/access`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolCompanyAccessCommand
  });
};

export const getConversationEvaluationUpdateProtocolCompanyAccessMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
    TError,
    { id: number; companyId: number; data: UpdateEvaluationProtocolCompanyAccessCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
  TError,
  { id: number; companyId: number; data: UpdateEvaluationProtocolCompanyAccessCommand },
  TContext
> => {
  const mutationKey = ['conversationEvaluationUpdateProtocolCompanyAccess'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
    { id: number; companyId: number; data: UpdateEvaluationProtocolCompanyAccessCommand }
  > = (props) => {
    const { id, companyId, data } = props ?? {};

    return conversationEvaluationUpdateProtocolCompanyAccess(id, companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateProtocolCompanyAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>
>;
export type ConversationEvaluationUpdateProtocolCompanyAccessMutationBody =
  UpdateEvaluationProtocolCompanyAccessCommand;
export type ConversationEvaluationUpdateProtocolCompanyAccessMutationError = unknown;

export const useConversationEvaluationUpdateProtocolCompanyAccess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
    TError,
    { id: number; companyId: number; data: UpdateEvaluationProtocolCompanyAccessCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
  TError,
  { id: number; companyId: number; data: UpdateEvaluationProtocolCompanyAccessCommand },
  TContext
> => {
  const mutationOptions = getConversationEvaluationUpdateProtocolCompanyAccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const conversationEvaluationGetEvaluations = (signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationDto[]>({ url: `/api/evaluation/evaluations`, method: 'GET', signal });
};

export const getConversationEvaluationGetEvaluationsQueryKey = () => {
  return [`/api/evaluation/evaluations`] as const;
};

export const getConversationEvaluationGetEvaluationsQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>> = ({ signal }) =>
    conversationEvaluationGetEvaluations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>
>;
export type ConversationEvaluationGetEvaluationsQueryError = unknown;

export function useConversationEvaluationGetEvaluations<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const conversationEvaluationDeleteEvaluation = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/DeleteEvaluation/${id}`, method: 'DELETE' });
};

export const getConversationEvaluationDeleteEvaluationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['conversationEvaluationDeleteEvaluation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return conversationEvaluationDeleteEvaluation(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>
>;

export type ConversationEvaluationDeleteEvaluationMutationError = unknown;

export const useConversationEvaluationDeleteEvaluation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getConversationEvaluationDeleteEvaluationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseGet = (params?: CourseGetParams, signal?: AbortSignal) => {
  return customAxiosInstance<PartialListCourseDto>({ url: `/api/Course/Get`, method: 'GET', params, signal });
};

export const getCourseGetQueryKey = (params?: CourseGetParams) => {
  return [`/api/Course/Get`, ...(params ? [params] : [])] as const;
};

export const getCourseGetQueryOptions = <TData = Awaited<ReturnType<typeof courseGet>>, TError = unknown>(
  params?: CourseGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGet>>> = ({ signal }) => courseGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetQueryResult = NonNullable<Awaited<ReturnType<typeof courseGet>>>;
export type CourseGetQueryError = unknown;

export function useCourseGet<TData = Awaited<ReturnType<typeof courseGet>>, TError = unknown>(
  params?: CourseGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetCourse = (courseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({ url: `/api/Course/GetCourse/${courseId}`, method: 'GET', signal });
};

export const getCourseGetCourseQueryKey = (courseId?: number) => {
  return [`/api/Course/GetCourse/${courseId}`] as const;
};

export const getCourseGetCourseQueryOptions = <TData = Awaited<ReturnType<typeof courseGetCourse>>, TError = unknown>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourse>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCourseQueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCourse>>> = ({ signal }) =>
    courseGetCourse(courseId, signal);

  return { queryKey, queryFn, enabled: !!courseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetCourse>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof courseGetCourse>>>;
export type CourseGetCourseQueryError = unknown;

export function useCourseGetCourse<TData = Awaited<ReturnType<typeof courseGetCourse>>, TError = unknown>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourse>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCourseQueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseCreateCourse = (createCourseCommand: CreateCourseCommand) => {
  return customAxiosInstance<CourseDto>({
    url: `/api/Course/CreateCourse`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createCourseCommand
  });
};

export const getCourseCreateCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourse>>,
    TError,
    { data: CreateCourseCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateCourse>>,
  TError,
  { data: CreateCourseCommand },
  TContext
> => {
  const mutationKey = ['courseCreateCourse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseCreateCourse>>, { data: CreateCourseCommand }> = (
    props
  ) => {
    const { data } = props ?? {};

    return courseCreateCourse(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateCourseMutationResult = NonNullable<Awaited<ReturnType<typeof courseCreateCourse>>>;
export type CourseCreateCourseMutationBody = CreateCourseCommand;
export type CourseCreateCourseMutationError = unknown;

export const useCourseCreateCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourse>>,
    TError,
    { data: CreateCourseCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateCourse>>,
  TError,
  { data: CreateCourseCommand },
  TContext
> => {
  const mutationOptions = getCourseCreateCourseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseUpdate = (courseId: number, updateCourseCommand: UpdateCourseCommand, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({
    url: `/api/Course/Update/${courseId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateCourseCommand,
    signal
  });
};

export const getCourseUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdate>>,
    TError,
    { courseId: number; data: UpdateCourseCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseUpdate>>,
  TError,
  { courseId: number; data: UpdateCourseCommand },
  TContext
> => {
  const mutationKey = ['courseUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseUpdate>>,
    { courseId: number; data: UpdateCourseCommand }
  > = (props) => {
    const { courseId, data } = props ?? {};

    return courseUpdate(courseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof courseUpdate>>>;
export type CourseUpdateMutationBody = UpdateCourseCommand;
export type CourseUpdateMutationError = unknown;

export const useCourseUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdate>>,
    TError,
    { courseId: number; data: UpdateCourseCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseUpdate>>,
  TError,
  { courseId: number; data: UpdateCourseCommand },
  TContext
> => {
  const mutationOptions = getCourseUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseGetCourseAvailableScenes = (courseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto[]>({
    url: `/api/Course/GetCourseAvailableScenes/${courseId}/available-scenes`,
    method: 'GET',
    signal
  });
};

export const getCourseGetCourseAvailableScenesQueryKey = (courseId?: number) => {
  return [`/api/Course/GetCourseAvailableScenes/${courseId}/available-scenes`] as const;
};

export const getCourseGetCourseAvailableScenesQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>,
  TError = unknown
>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCourseAvailableScenesQueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>> = ({ signal }) =>
    courseGetCourseAvailableScenes(courseId, signal);

  return { queryKey, queryFn, enabled: !!courseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetCourseAvailableScenesQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>
>;
export type CourseGetCourseAvailableScenesQueryError = unknown;

export function useCourseGetCourseAvailableScenes<
  TData = Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>,
  TError = unknown
>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCourseAvailableScenesQueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseCreateCourseScene = (courseId: number, scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({
    url: `/api/Course/CreateCourseScene/${courseId}/scene/${scenarioId}`,
    method: 'POST',
    signal
  });
};

export const getCourseCreateCourseSceneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourseScene>>,
    TError,
    { courseId: number; scenarioId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateCourseScene>>,
  TError,
  { courseId: number; scenarioId: number },
  TContext
> => {
  const mutationKey = ['courseCreateCourseScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateCourseScene>>,
    { courseId: number; scenarioId: number }
  > = (props) => {
    const { courseId, scenarioId } = props ?? {};

    return courseCreateCourseScene(courseId, scenarioId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateCourseSceneMutationResult = NonNullable<Awaited<ReturnType<typeof courseCreateCourseScene>>>;

export type CourseCreateCourseSceneMutationError = unknown;

export const useCourseCreateCourseScene = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourseScene>>,
    TError,
    { courseId: number; scenarioId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateCourseScene>>,
  TError,
  { courseId: number; scenarioId: number },
  TContext
> => {
  const mutationOptions = getCourseCreateCourseSceneMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseDeleteCourseScene = (courseId: number, scenarioId: number) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteCourseScene/${courseId}/scene/${scenarioId}`,
    method: 'DELETE'
  });
};

export const getCourseDeleteCourseSceneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteCourseScene>>,
    TError,
    { courseId: number; scenarioId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteCourseScene>>,
  TError,
  { courseId: number; scenarioId: number },
  TContext
> => {
  const mutationKey = ['courseDeleteCourseScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteCourseScene>>,
    { courseId: number; scenarioId: number }
  > = (props) => {
    const { courseId, scenarioId } = props ?? {};

    return courseDeleteCourseScene(courseId, scenarioId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteCourseSceneMutationResult = NonNullable<Awaited<ReturnType<typeof courseDeleteCourseScene>>>;

export type CourseDeleteCourseSceneMutationError = unknown;

export const useCourseDeleteCourseScene = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteCourseScene>>,
    TError,
    { courseId: number; scenarioId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteCourseScene>>,
  TError,
  { courseId: number; scenarioId: number },
  TContext
> => {
  const mutationOptions = getCourseDeleteCourseSceneMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseDeleteCourse = (courseId: number) => {
  return customAxiosInstance<void>({ url: `/api/Course/DeleteCourse/${courseId}`, method: 'DELETE' });
};

export const getCourseDeleteCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof courseDeleteCourse>>, TError, { courseId: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof courseDeleteCourse>>, TError, { courseId: number }, TContext> => {
  const mutationKey = ['courseDeleteCourse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseDeleteCourse>>, { courseId: number }> = (
    props
  ) => {
    const { courseId } = props ?? {};

    return courseDeleteCourse(courseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteCourseMutationResult = NonNullable<Awaited<ReturnType<typeof courseDeleteCourse>>>;

export type CourseDeleteCourseMutationError = unknown;

export const useCourseDeleteCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof courseDeleteCourse>>, TError, { courseId: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof courseDeleteCourse>>, TError, { courseId: number }, TContext> => {
  const mutationOptions = getCourseDeleteCourseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseCreateScheduledCourse = (
  courseId: number,
  createScheduledCourseCommand: CreateScheduledCourseCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/CreateScheduledCourse/schedule/${courseId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduledCourseCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
    TError,
    { courseId: number; data: CreateScheduledCourseCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
  TError,
  { courseId: number; data: CreateScheduledCourseCommand },
  TContext
> => {
  const mutationKey = ['courseCreateScheduledCourse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
    { courseId: number; data: CreateScheduledCourseCommand }
  > = (props) => {
    const { courseId, data } = props ?? {};

    return courseCreateScheduledCourse(courseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourse>>
>;
export type CourseCreateScheduledCourseMutationBody = CreateScheduledCourseCommand;
export type CourseCreateScheduledCourseMutationError = unknown;

export const useCourseCreateScheduledCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
    TError,
    { courseId: number; data: CreateScheduledCourseCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
  TError,
  { courseId: number; data: CreateScheduledCourseCommand },
  TContext
> => {
  const mutationOptions = getCourseCreateScheduledCourseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseUpdateScheduledCourse = (
  scheduledCourseId: number,
  updateScheduledCourseRequestCommand: UpdateScheduledCourseRequestCommand
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/UpdateScheduledCourse/schedule/${scheduledCourseId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScheduledCourseRequestCommand
  });
};

export const getCourseUpdateScheduledCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
    TError,
    { scheduledCourseId: number; data: UpdateScheduledCourseRequestCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
  TError,
  { scheduledCourseId: number; data: UpdateScheduledCourseRequestCommand },
  TContext
> => {
  const mutationKey = ['courseUpdateScheduledCourse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
    { scheduledCourseId: number; data: UpdateScheduledCourseRequestCommand }
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseUpdateScheduledCourse(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpdateScheduledCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseUpdateScheduledCourse>>
>;
export type CourseUpdateScheduledCourseMutationBody = UpdateScheduledCourseRequestCommand;
export type CourseUpdateScheduledCourseMutationError = unknown;

export const useCourseUpdateScheduledCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
    TError,
    { scheduledCourseId: number; data: UpdateScheduledCourseRequestCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
  TError,
  { scheduledCourseId: number; data: UpdateScheduledCourseRequestCommand },
  TContext
> => {
  const mutationOptions = getCourseUpdateScheduledCourseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseDeleteScheduledCourse = (scheduledCourseId: number) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourse/schedule/${scheduledCourseId}`,
    method: 'DELETE'
  });
};

export const getCourseDeleteScheduledCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
    TError,
    { scheduledCourseId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
  TError,
  { scheduledCourseId: number },
  TContext
> => {
  const mutationKey = ['courseDeleteScheduledCourse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
    { scheduledCourseId: number }
  > = (props) => {
    const { scheduledCourseId } = props ?? {};

    return courseDeleteScheduledCourse(scheduledCourseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourse>>
>;

export type CourseDeleteScheduledCourseMutationError = unknown;

export const useCourseDeleteScheduledCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
    TError,
    { scheduledCourseId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
  TError,
  { scheduledCourseId: number },
  TContext
> => {
  const mutationOptions = getCourseDeleteScheduledCourseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseCreateScheduledCourseUser = (
  scheduledCourseId: number,
  scheduledCourseAssignmentCommand: ScheduledCourseAssignmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/CreateScheduledCourseUser/schedule/${scheduledCourseId}/user`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scheduledCourseAssignmentCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
    TError,
    { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
  TError,
  { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
  TContext
> => {
  const mutationKey = ['courseCreateScheduledCourseUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
    { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand }
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseCreateScheduledCourseUser(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>
>;
export type CourseCreateScheduledCourseUserMutationBody = ScheduledCourseAssignmentCommand;
export type CourseCreateScheduledCourseUserMutationError = unknown;

export const useCourseCreateScheduledCourseUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
    TError,
    { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
  TError,
  { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
  TContext
> => {
  const mutationOptions = getCourseCreateScheduledCourseUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseDeleteScheduledCourseUser = (scheduledCourseId: number, userId: number) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourseUser/schedule/${scheduledCourseId}/user/${userId}`,
    method: 'DELETE'
  });
};

export const getCourseDeleteScheduledCourseUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
    TError,
    { scheduledCourseId: number; userId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
  TError,
  { scheduledCourseId: number; userId: number },
  TContext
> => {
  const mutationKey = ['courseDeleteScheduledCourseUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
    { scheduledCourseId: number; userId: number }
  > = (props) => {
    const { scheduledCourseId, userId } = props ?? {};

    return courseDeleteScheduledCourseUser(scheduledCourseId, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>
>;

export type CourseDeleteScheduledCourseUserMutationError = unknown;

export const useCourseDeleteScheduledCourseUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
    TError,
    { scheduledCourseId: number; userId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
  TError,
  { scheduledCourseId: number; userId: number },
  TContext
> => {
  const mutationOptions = getCourseDeleteScheduledCourseUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseCreateScheduledCourseUserGroup = (
  scheduledCourseId: number,
  scheduledCourseAssignmentCommand: ScheduledCourseAssignmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/CreateScheduledCourseUserGroup/schedule/${scheduledCourseId}/user-group`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scheduledCourseAssignmentCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseUserGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
    TError,
    { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
  TError,
  { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
  TContext
> => {
  const mutationKey = ['courseCreateScheduledCourseUserGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
    { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand }
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseCreateScheduledCourseUserGroup(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseUserGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>
>;
export type CourseCreateScheduledCourseUserGroupMutationBody = ScheduledCourseAssignmentCommand;
export type CourseCreateScheduledCourseUserGroupMutationError = unknown;

export const useCourseCreateScheduledCourseUserGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
    TError,
    { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
  TError,
  { scheduledCourseId: number; data: ScheduledCourseAssignmentCommand },
  TContext
> => {
  const mutationOptions = getCourseCreateScheduledCourseUserGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseDeleteScheduledCourseUserGroup = (scheduledCourseId: number, userGroupId: number) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourseUserGroup/schedule/${scheduledCourseId}/user-group/${userGroupId}`,
    method: 'DELETE'
  });
};

export const getCourseDeleteScheduledCourseUserGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
    TError,
    { scheduledCourseId: number; userGroupId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
  TError,
  { scheduledCourseId: number; userGroupId: number },
  TContext
> => {
  const mutationKey = ['courseDeleteScheduledCourseUserGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
    { scheduledCourseId: number; userGroupId: number }
  > = (props) => {
    const { scheduledCourseId, userGroupId } = props ?? {};

    return courseDeleteScheduledCourseUserGroup(scheduledCourseId, userGroupId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseUserGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>
>;

export type CourseDeleteScheduledCourseUserGroupMutationError = unknown;

export const useCourseDeleteScheduledCourseUserGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
    TError,
    { scheduledCourseId: number; userGroupId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
  TError,
  { scheduledCourseId: number; userGroupId: number },
  TContext
> => {
  const mutationOptions = getCourseDeleteScheduledCourseUserGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseGetScheduledCourseAllAssignedUsers = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Course/GetScheduledCourseAllAssignedUsers/schedule/${scheduledCourseId}/all-assigned-users`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseAllAssignedUsersQueryKey = (scheduledCourseId?: number) => {
  return [`/api/Course/GetScheduledCourseAllAssignedUsers/schedule/${scheduledCourseId}/all-assigned-users`] as const;
};

export const getCourseGetScheduledCourseAllAssignedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseAllAssignedUsersQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>> = ({ signal }) =>
    courseGetScheduledCourseAllAssignedUsers(scheduledCourseId, signal);

  return { queryKey, queryFn, enabled: !!scheduledCourseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetScheduledCourseAllAssignedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>
>;
export type CourseGetScheduledCourseAllAssignedUsersQueryError = unknown;

export function useCourseGetScheduledCourseAllAssignedUsers<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseAllAssignedUsersQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetScheduledCourseAvailableUsers = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Course/GetScheduledCourseAvailableUsers/schedule/${scheduledCourseId}/available-users`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseAvailableUsersQueryKey = (scheduledCourseId?: number) => {
  return [`/api/Course/GetScheduledCourseAvailableUsers/schedule/${scheduledCourseId}/available-users`] as const;
};

export const getCourseGetScheduledCourseAvailableUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseAvailableUsersQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>> = ({ signal }) =>
    courseGetScheduledCourseAvailableUsers(scheduledCourseId, signal);

  return { queryKey, queryFn, enabled: !!scheduledCourseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetScheduledCourseAvailableUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>
>;
export type CourseGetScheduledCourseAvailableUsersQueryError = unknown;

export function useCourseGetScheduledCourseAvailableUsers<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseAvailableUsersQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetScheduledCourseAvailableUserGroups = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<UserGroupDto[]>({
    url: `/api/Course/GetScheduledCourseAvailableUserGroups/schedule/${scheduledCourseId}/available-user-groups`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseAvailableUserGroupsQueryKey = (scheduledCourseId?: number) => {
  return [
    `/api/Course/GetScheduledCourseAvailableUserGroups/schedule/${scheduledCourseId}/available-user-groups`
  ] as const;
};

export const getCourseGetScheduledCourseAvailableUserGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseAvailableUserGroupsQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>> = ({
    signal
  }) => courseGetScheduledCourseAvailableUserGroups(scheduledCourseId, signal);

  return { queryKey, queryFn, enabled: !!scheduledCourseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetScheduledCourseAvailableUserGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>
>;
export type CourseGetScheduledCourseAvailableUserGroupsQueryError = unknown;

export function useCourseGetScheduledCourseAvailableUserGroups<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseAvailableUserGroupsQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetCurrentUserScheduledCourses = (signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCourseDto[]>({
    url: `/api/Course/GetCurrentUserScheduledCourses/user/current/schedule`,
    method: 'GET',
    signal
  });
};

export const getCourseGetCurrentUserScheduledCoursesQueryKey = () => {
  return [`/api/Course/GetCurrentUserScheduledCourses/user/current/schedule`] as const;
};

export const getCourseGetCurrentUserScheduledCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCurrentUserScheduledCoursesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>> = ({ signal }) =>
    courseGetCurrentUserScheduledCourses(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetCurrentUserScheduledCoursesQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>
>;
export type CourseGetCurrentUserScheduledCoursesQueryError = unknown;

export function useCourseGetCurrentUserScheduledCourses<
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCurrentUserScheduledCoursesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetCurrentUserScheduledCoursesForDashboard = (signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCourseDto[]>({
    url: `/api/Course/GetCurrentUserScheduledCoursesForDashboard/user/current/schedule/dashboard`,
    method: 'GET',
    signal
  });
};

export const getCourseGetCurrentUserScheduledCoursesForDashboardQueryKey = () => {
  return [`/api/Course/GetCurrentUserScheduledCoursesForDashboard/user/current/schedule/dashboard`] as const;
};

export const getCourseGetCurrentUserScheduledCoursesForDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCurrentUserScheduledCoursesForDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>> = ({
    signal
  }) => courseGetCurrentUserScheduledCoursesForDashboard(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetCurrentUserScheduledCoursesForDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>
>;
export type CourseGetCurrentUserScheduledCoursesForDashboardQueryError = unknown;

export function useCourseGetCurrentUserScheduledCoursesForDashboard<
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCurrentUserScheduledCoursesForDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetUserScheduledCourseResults = (
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseScenarioResultDto[]>({
    url: `/api/Course/GetUserScheduledCourseResults/user/current/schedule/${scheduledCourseId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getCourseGetUserScheduledCourseResultsQueryKey = (
  scheduledCourseId?: number,
  params?: CourseGetUserScheduledCourseResultsParams
) => {
  return [
    `/api/Course/GetUserScheduledCourseResults/user/current/schedule/${scheduledCourseId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getCourseGetUserScheduledCourseResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>,
  TError = unknown
>(
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetUserScheduledCourseResultsQueryKey(scheduledCourseId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>> = ({ signal }) =>
    courseGetUserScheduledCourseResults(scheduledCourseId, params, signal);

  return { queryKey, queryFn, enabled: !!scheduledCourseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetUserScheduledCourseResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>
>;
export type CourseGetUserScheduledCourseResultsQueryError = unknown;

export function useCourseGetUserScheduledCourseResults<
  TData = Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>,
  TError = unknown
>(
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetUserScheduledCourseResultsQueryOptions(scheduledCourseId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseGetScheduledCourseNotifications = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCourseNotificationDto[]>({
    url: `/api/Course/GetScheduledCourseNotifications/schedule/${scheduledCourseId}/notifications`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseNotificationsQueryKey = (scheduledCourseId?: number) => {
  return [`/api/Course/GetScheduledCourseNotifications/schedule/${scheduledCourseId}/notifications`] as const;
};

export const getCourseGetScheduledCourseNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseNotificationsQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>> = ({ signal }) =>
    courseGetScheduledCourseNotifications(scheduledCourseId, signal);

  return { queryKey, queryFn, enabled: !!scheduledCourseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetScheduledCourseNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>
>;
export type CourseGetScheduledCourseNotificationsQueryError = unknown;

export function useCourseGetScheduledCourseNotifications<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseNotificationsQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const courseCreateScheduledCourseNotification = (
  scheduledCourseId: number,
  createScheduledCourseNotificationCommand: CreateScheduledCourseNotificationCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Course/CreateScheduledCourseNotification/schedule/${scheduledCourseId}/notification`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduledCourseNotificationCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
    TError,
    { scheduledCourseId: number; data: CreateScheduledCourseNotificationCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
  TError,
  { scheduledCourseId: number; data: CreateScheduledCourseNotificationCommand },
  TContext
> => {
  const mutationKey = ['courseCreateScheduledCourseNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
    { scheduledCourseId: number; data: CreateScheduledCourseNotificationCommand }
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseCreateScheduledCourseNotification(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>
>;
export type CourseCreateScheduledCourseNotificationMutationBody = CreateScheduledCourseNotificationCommand;
export type CourseCreateScheduledCourseNotificationMutationError = unknown;

export const useCourseCreateScheduledCourseNotification = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
    TError,
    { scheduledCourseId: number; data: CreateScheduledCourseNotificationCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
  TError,
  { scheduledCourseId: number; data: CreateScheduledCourseNotificationCommand },
  TContext
> => {
  const mutationOptions = getCourseCreateScheduledCourseNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseUpdateScheduledCourseNotification = (
  scheduledCourseId: number,
  notificationId: number,
  updateScheduledCourseNotificationCommand: UpdateScheduledCourseNotificationCommand
) => {
  return customAxiosInstance<void>({
    url: `/api/Course/UpdateScheduledCourseNotification/schedule/${scheduledCourseId}/notification/${notificationId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScheduledCourseNotificationCommand
  });
};

export const getCourseUpdateScheduledCourseNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
    TError,
    { scheduledCourseId: number; notificationId: number; data: UpdateScheduledCourseNotificationCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
  TError,
  { scheduledCourseId: number; notificationId: number; data: UpdateScheduledCourseNotificationCommand },
  TContext
> => {
  const mutationKey = ['courseUpdateScheduledCourseNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
    { scheduledCourseId: number; notificationId: number; data: UpdateScheduledCourseNotificationCommand }
  > = (props) => {
    const { scheduledCourseId, notificationId, data } = props ?? {};

    return courseUpdateScheduledCourseNotification(scheduledCourseId, notificationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpdateScheduledCourseNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>
>;
export type CourseUpdateScheduledCourseNotificationMutationBody = UpdateScheduledCourseNotificationCommand;
export type CourseUpdateScheduledCourseNotificationMutationError = unknown;

export const useCourseUpdateScheduledCourseNotification = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
    TError,
    { scheduledCourseId: number; notificationId: number; data: UpdateScheduledCourseNotificationCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
  TError,
  { scheduledCourseId: number; notificationId: number; data: UpdateScheduledCourseNotificationCommand },
  TContext
> => {
  const mutationOptions = getCourseUpdateScheduledCourseNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const courseDeleteScheduledCourseNotification = (scheduledCourseId: number, notificationId: number) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourseNotification/schedule/${scheduledCourseId}/notification/${notificationId}`,
    method: 'DELETE'
  });
};

export const getCourseDeleteScheduledCourseNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
    TError,
    { scheduledCourseId: number; notificationId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
  TError,
  { scheduledCourseId: number; notificationId: number },
  TContext
> => {
  const mutationKey = ['courseDeleteScheduledCourseNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
    { scheduledCourseId: number; notificationId: number }
  > = (props) => {
    const { scheduledCourseId, notificationId } = props ?? {};

    return courseDeleteScheduledCourseNotification(scheduledCourseId, notificationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>
>;

export type CourseDeleteScheduledCourseNotificationMutationError = unknown;

export const useCourseDeleteScheduledCourseNotification = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
    TError,
    { scheduledCourseId: number; notificationId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
  TError,
  { scheduledCourseId: number; notificationId: number },
  TContext
> => {
  const mutationOptions = getCourseDeleteScheduledCourseNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const decisionSupportStartSession = (signal?: AbortSignal) => {
  return customAxiosInstance<DecisionSupportResponse>({
    url: `/api/v2/decision-support/start-session`,
    method: 'GET',
    signal
  });
};

export const getDecisionSupportStartSessionQueryKey = () => {
  return [`/api/v2/decision-support/start-session`] as const;
};

export const getDecisionSupportStartSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof decisionSupportStartSession>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof decisionSupportStartSession>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDecisionSupportStartSessionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof decisionSupportStartSession>>> = ({ signal }) =>
    decisionSupportStartSession(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof decisionSupportStartSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DecisionSupportStartSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof decisionSupportStartSession>>
>;
export type DecisionSupportStartSessionQueryError = unknown;

export function useDecisionSupportStartSession<
  TData = Awaited<ReturnType<typeof decisionSupportStartSession>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof decisionSupportStartSession>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDecisionSupportStartSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const decisionSupportAdvise = (decisionSupportRequest: DecisionSupportRequest, signal?: AbortSignal) => {
  return customAxiosInstance<DecisionSupportStructuredResponseDto>({
    url: `/api/v2/decision-support/advise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: decisionSupportRequest,
    signal
  });
};

export const getDecisionSupportAdviseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportAdvise>>,
    TError,
    { data: DecisionSupportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decisionSupportAdvise>>,
  TError,
  { data: DecisionSupportRequest },
  TContext
> => {
  const mutationKey = ['decisionSupportAdvise'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decisionSupportAdvise>>,
    { data: DecisionSupportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return decisionSupportAdvise(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecisionSupportAdviseMutationResult = NonNullable<Awaited<ReturnType<typeof decisionSupportAdvise>>>;
export type DecisionSupportAdviseMutationBody = DecisionSupportRequest;
export type DecisionSupportAdviseMutationError = unknown;

export const useDecisionSupportAdvise = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportAdvise>>,
    TError,
    { data: DecisionSupportRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof decisionSupportAdvise>>,
  TError,
  { data: DecisionSupportRequest },
  TContext
> => {
  const mutationOptions = getDecisionSupportAdviseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const decisionSupportEndSession = (decisionSupportRequest: DecisionSupportRequest, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/v2/decision-support/end-session`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: decisionSupportRequest,
    signal
  });
};

export const getDecisionSupportEndSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportEndSession>>,
    TError,
    { data: DecisionSupportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decisionSupportEndSession>>,
  TError,
  { data: DecisionSupportRequest },
  TContext
> => {
  const mutationKey = ['decisionSupportEndSession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decisionSupportEndSession>>,
    { data: DecisionSupportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return decisionSupportEndSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecisionSupportEndSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof decisionSupportEndSession>>
>;
export type DecisionSupportEndSessionMutationBody = DecisionSupportRequest;
export type DecisionSupportEndSessionMutationError = unknown;

export const useDecisionSupportEndSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportEndSession>>,
    TError,
    { data: DecisionSupportRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof decisionSupportEndSession>>,
  TError,
  { data: DecisionSupportRequest },
  TContext
> => {
  const mutationOptions = getDecisionSupportEndSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogSessionInitSession = (
  scenarioId: number,
  params?: DialogSessionInitSessionParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/DialogSession/InitSession/${scenarioId}/start`,
    method: 'POST',
    params,
    signal
  });
};

export const getDialogSessionInitSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogSessionInitSession>>,
    TError,
    { scenarioId: number; params?: DialogSessionInitSessionParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogSessionInitSession>>,
  TError,
  { scenarioId: number; params?: DialogSessionInitSessionParams },
  TContext
> => {
  const mutationKey = ['dialogSessionInitSession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogSessionInitSession>>,
    { scenarioId: number; params?: DialogSessionInitSessionParams }
  > = (props) => {
    const { scenarioId, params } = props ?? {};

    return dialogSessionInitSession(scenarioId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogSessionInitSessionMutationResult = NonNullable<Awaited<ReturnType<typeof dialogSessionInitSession>>>;

export type DialogSessionInitSessionMutationError = unknown;

export const useDialogSessionInitSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogSessionInitSession>>,
    TError,
    { scenarioId: number; params?: DialogSessionInitSessionParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogSessionInitSession>>,
  TError,
  { scenarioId: number; params?: DialogSessionInitSessionParams },
  TContext
> => {
  const mutationOptions = getDialogSessionInitSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsListDialogStatisticsService = (
  params?: DialogStatisticsListDialogStatisticsServiceParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PartialListDialogStatisticDto>({
    url: `/api/DialogStatistics/ListDialogStatisticsService`,
    method: 'GET',
    params,
    signal
  });
};

export const getDialogStatisticsListDialogStatisticsServiceQueryKey = (
  params?: DialogStatisticsListDialogStatisticsServiceParams
) => {
  return [`/api/DialogStatistics/ListDialogStatisticsService`, ...(params ? [params] : [])] as const;
};

export const getDialogStatisticsListDialogStatisticsServiceQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>,
  TError = unknown
>(
  params?: DialogStatisticsListDialogStatisticsServiceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsListDialogStatisticsServiceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>> = ({
    signal
  }) => dialogStatisticsListDialogStatisticsService(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsListDialogStatisticsServiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>
>;
export type DialogStatisticsListDialogStatisticsServiceQueryError = unknown;

export function useDialogStatisticsListDialogStatisticsService<
  TData = Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>,
  TError = unknown
>(
  params?: DialogStatisticsListDialogStatisticsServiceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsListDialogStatisticsServiceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsGetDialogStatistic = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<DialogStatisticDto>({
    url: `/api/DialogStatistics/GetDialogStatistic/${id}`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetDialogStatisticQueryKey = (id?: number) => {
  return [`/api/DialogStatistics/GetDialogStatistic/${id}`] as const;
};

export const getDialogStatisticsGetDialogStatisticQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetDialogStatisticQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>> = ({ signal }) =>
    dialogStatisticsGetDialogStatistic(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetDialogStatisticQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>
>;
export type DialogStatisticsGetDialogStatisticQueryError = unknown;

export function useDialogStatisticsGetDialogStatistic<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetDialogStatisticQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsAddDialogStatistic = (
  addDialogStatisticCommand: AddDialogStatisticCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<DialogStatisticDto>({
    url: `/api/DialogStatistics/AddDialogStatistic`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addDialogStatisticCommand,
    signal
  });
};

export const getDialogStatisticsAddDialogStatisticMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
    TError,
    { data: AddDialogStatisticCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
  TError,
  { data: AddDialogStatisticCommand },
  TContext
> => {
  const mutationKey = ['dialogStatisticsAddDialogStatistic'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
    { data: AddDialogStatisticCommand }
  > = (props) => {
    const { data } = props ?? {};

    return dialogStatisticsAddDialogStatistic(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsAddDialogStatisticMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>
>;
export type DialogStatisticsAddDialogStatisticMutationBody = AddDialogStatisticCommand;
export type DialogStatisticsAddDialogStatisticMutationError = unknown;

export const useDialogStatisticsAddDialogStatistic = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
    TError,
    { data: AddDialogStatisticCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
  TError,
  { data: AddDialogStatisticCommand },
  TContext
> => {
  const mutationOptions = getDialogStatisticsAddDialogStatisticMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsDeleteDialogStatistic = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/DialogStatistics/DeleteDialogStatistic/${id}`, method: 'DELETE' });
};

export const getDialogStatisticsDeleteDialogStatisticMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['dialogStatisticsDeleteDialogStatistic'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return dialogStatisticsDeleteDialogStatistic(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsDeleteDialogStatisticMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>
>;

export type DialogStatisticsDeleteDialogStatisticMutationError = unknown;

export const useDialogStatisticsDeleteDialogStatistic = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDialogStatisticsDeleteDialogStatisticMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsDeleteDialogStatistics = (dialogStatisticsDeleteDialogStatisticsBody: number[]) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/DeleteDialogStatistics/deleteDialogStatistics`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: dialogStatisticsDeleteDialogStatisticsBody
  });
};

export const getDialogStatisticsDeleteDialogStatisticsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
    TError,
    { data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationKey = ['dialogStatisticsDeleteDialogStatistics'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
    { data: number[] }
  > = (props) => {
    const { data } = props ?? {};

    return dialogStatisticsDeleteDialogStatistics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsDeleteDialogStatisticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>
>;
export type DialogStatisticsDeleteDialogStatisticsMutationBody = number[];
export type DialogStatisticsDeleteDialogStatisticsMutationError = unknown;

export const useDialogStatisticsDeleteDialogStatistics = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
    TError,
    { data: number[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationOptions = getDialogStatisticsDeleteDialogStatisticsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsGetKpiDetails = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<DialogStatisticKpiDetailsDto>({
    url: `/api/DialogStatistics/GetKpiDetails/${dialogStatisticsId}/kpidetails`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetKpiDetailsQueryKey = (dialogStatisticsId?: number) => {
  return [`/api/DialogStatistics/GetKpiDetails/${dialogStatisticsId}/kpidetails`] as const;
};

export const getDialogStatisticsGetKpiDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetKpiDetailsQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>> = ({ signal }) =>
    dialogStatisticsGetKpiDetails(dialogStatisticsId, signal);

  return { queryKey, queryFn, enabled: !!dialogStatisticsId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetKpiDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>
>;
export type DialogStatisticsGetKpiDetailsQueryError = unknown;

export function useDialogStatisticsGetKpiDetails<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetKpiDetailsQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsGetDialogTranscript = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<string>({
    url: `/api/DialogStatistics/GetDialogTranscript/${dialogStatisticsId}/transcript`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetDialogTranscriptQueryKey = (dialogStatisticsId?: number) => {
  return [`/api/DialogStatistics/GetDialogTranscript/${dialogStatisticsId}/transcript`] as const;
};

export const getDialogStatisticsGetDialogTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetDialogTranscriptQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>> = ({ signal }) =>
    dialogStatisticsGetDialogTranscript(dialogStatisticsId, signal);

  return { queryKey, queryFn, enabled: !!dialogStatisticsId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetDialogTranscriptQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>
>;
export type DialogStatisticsGetDialogTranscriptQueryError = unknown;

export function useDialogStatisticsGetDialogTranscript<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetDialogTranscriptQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsStoreFeedback = (
  sessionId: string,
  conversationFeedback: ConversationFeedback,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/StoreFeedback/StoreFeedback/${sessionId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationFeedback,
    signal
  });
};

export const getDialogStatisticsStoreFeedbackMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
    TError,
    { sessionId: string; data: ConversationFeedback },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
  TError,
  { sessionId: string; data: ConversationFeedback },
  TContext
> => {
  const mutationKey = ['dialogStatisticsStoreFeedback'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
    { sessionId: string; data: ConversationFeedback }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return dialogStatisticsStoreFeedback(sessionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsStoreFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>
>;
export type DialogStatisticsStoreFeedbackMutationBody = ConversationFeedback;
export type DialogStatisticsStoreFeedbackMutationError = unknown;

export const useDialogStatisticsStoreFeedback = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
    TError,
    { sessionId: string; data: ConversationFeedback },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
  TError,
  { sessionId: string; data: ConversationFeedback },
  TContext
> => {
  const mutationOptions = getDialogStatisticsStoreFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsGetDialogFeedbacks = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<DialogFeedbackDto[]>({
    url: `/api/DialogStatistics/GetDialogFeedbacks/${dialogStatisticsId}/feedback`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetDialogFeedbacksQueryKey = (dialogStatisticsId?: number) => {
  return [`/api/DialogStatistics/GetDialogFeedbacks/${dialogStatisticsId}/feedback`] as const;
};

export const getDialogStatisticsGetDialogFeedbacksQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetDialogFeedbacksQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>> = ({ signal }) =>
    dialogStatisticsGetDialogFeedbacks(dialogStatisticsId, signal);

  return { queryKey, queryFn, enabled: !!dialogStatisticsId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetDialogFeedbacksQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>
>;
export type DialogStatisticsGetDialogFeedbacksQueryError = unknown;

export function useDialogStatisticsGetDialogFeedbacks<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetDialogFeedbacksQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsGetScenarioNotes = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioNoteDto>({
    url: `/api/DialogStatistics/${sessionId}/notes`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetScenarioNotesQueryKey = (sessionId?: string) => {
  return [`/api/DialogStatistics/${sessionId}/notes`] as const;
};

export const getDialogStatisticsGetScenarioNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>,
  TError = unknown
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetScenarioNotesQueryKey(sessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>> = ({ signal }) =>
    dialogStatisticsGetScenarioNotes(sessionId, signal);

  return { queryKey, queryFn, enabled: !!sessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetScenarioNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>
>;
export type DialogStatisticsGetScenarioNotesQueryError = unknown;

export function useDialogStatisticsGetScenarioNotes<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>,
  TError = unknown
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetScenarioNotesQueryOptions(sessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsStoreScenarioNotes = (
  sessionId: string,
  scenarioNoteRequest: ScenarioNoteRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioNoteDto>({
    url: `/api/DialogStatistics/${sessionId}/notes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenarioNoteRequest,
    signal
  });
};

export const getDialogStatisticsStoreScenarioNotesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
    TError,
    { sessionId: string; data: ScenarioNoteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
  TError,
  { sessionId: string; data: ScenarioNoteRequest },
  TContext
> => {
  const mutationKey = ['dialogStatisticsStoreScenarioNotes'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
    { sessionId: string; data: ScenarioNoteRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return dialogStatisticsStoreScenarioNotes(sessionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsStoreScenarioNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>
>;
export type DialogStatisticsStoreScenarioNotesMutationBody = ScenarioNoteRequest;
export type DialogStatisticsStoreScenarioNotesMutationError = unknown;

export const useDialogStatisticsStoreScenarioNotes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
    TError,
    { sessionId: string; data: ScenarioNoteRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
  TError,
  { sessionId: string; data: ScenarioNoteRequest },
  TContext
> => {
  const mutationOptions = getDialogStatisticsStoreScenarioNotesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsSubmitScenarioNotes = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioNoteDto>({
    url: `/api/DialogStatistics/${sessionId}/notes/submit`,
    method: 'POST',
    signal
  });
};

export const getDialogStatisticsSubmitScenarioNotesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
    TError,
    { sessionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ['dialogStatisticsSubmitScenarioNotes'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return dialogStatisticsSubmitScenarioNotes(sessionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsSubmitScenarioNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>
>;

export type DialogStatisticsSubmitScenarioNotesMutationError = unknown;

export const useDialogStatisticsSubmitScenarioNotes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
    TError,
    { sessionId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationOptions = getDialogStatisticsSubmitScenarioNotesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dialogStatisticsGetUsageStatistics = (signal?: AbortSignal) => {
  return customAxiosInstance<UsageStatistic[]>({
    url: `/api/DialogStatistics/GetUsageStatistics/usage`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetUsageStatisticsQueryKey = () => {
  return [`/api/DialogStatistics/GetUsageStatistics/usage`] as const;
};

export const getDialogStatisticsGetUsageStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetUsageStatisticsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>> = ({ signal }) =>
    dialogStatisticsGetUsageStatistics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetUsageStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>
>;
export type DialogStatisticsGetUsageStatisticsQueryError = unknown;

export function useDialogStatisticsGetUsageStatistics<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetUsageStatisticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsExportEvaluationsToExcel = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/ExportEvaluationsToExcel/${dialogStatisticsId}/evaluations/export`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsExportEvaluationsToExcelQueryKey = (dialogStatisticsId?: number) => {
  return [`/api/DialogStatistics/ExportEvaluationsToExcel/${dialogStatisticsId}/evaluations/export`] as const;
};

export const getDialogStatisticsExportEvaluationsToExcelQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsExportEvaluationsToExcelQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>> = ({ signal }) =>
    dialogStatisticsExportEvaluationsToExcel(dialogStatisticsId, signal);

  return { queryKey, queryFn, enabled: !!dialogStatisticsId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsExportEvaluationsToExcelQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>
>;
export type DialogStatisticsExportEvaluationsToExcelQueryError = unknown;

export function useDialogStatisticsExportEvaluationsToExcel<
  TData = Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsExportEvaluationsToExcelQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dialogStatisticsTriggerConversationEvaluation = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/TriggerConversationEvaluation/${sessionId}/evaluations/trigger`,
    method: 'POST',
    signal
  });
};

export const getDialogStatisticsTriggerConversationEvaluationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
    TError,
    { sessionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ['dialogStatisticsTriggerConversationEvaluation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return dialogStatisticsTriggerConversationEvaluation(sessionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsTriggerConversationEvaluationMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>
>;

export type DialogStatisticsTriggerConversationEvaluationMutationError = unknown;

export const useDialogStatisticsTriggerConversationEvaluation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
    TError,
    { sessionId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationOptions = getDialogStatisticsTriggerConversationEvaluationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseGetAll = (signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto[]>({ url: `/api/Exercise`, method: 'GET', signal });
};

export const getExerciseGetAllQueryKey = () => {
  return [`/api/Exercise`] as const;
};

export const getExerciseGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof exerciseGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetAll>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExerciseGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exerciseGetAll>>> = ({ signal }) => exerciseGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exerciseGetAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExerciseGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof exerciseGetAll>>>;
export type ExerciseGetAllQueryError = unknown;

export function useExerciseGetAll<TData = Awaited<ReturnType<typeof exerciseGetAll>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetAll>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExerciseGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const exerciseCreate = (createExerciseDto: CreateExerciseDto, signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto>({
    url: `/api/Exercise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createExerciseDto,
    signal
  });
};

export const getExerciseCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseCreate>>,
    TError,
    { data: CreateExerciseDto },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof exerciseCreate>>, TError, { data: CreateExerciseDto }, TContext> => {
  const mutationKey = ['exerciseCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseCreate>>, { data: CreateExerciseDto }> = (
    props
  ) => {
    const { data } = props ?? {};

    return exerciseCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseCreate>>>;
export type ExerciseCreateMutationBody = CreateExerciseDto;
export type ExerciseCreateMutationError = unknown;

export const useExerciseCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseCreate>>,
    TError,
    { data: CreateExerciseDto },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof exerciseCreate>>, TError, { data: CreateExerciseDto }, TContext> => {
  const mutationOptions = getExerciseCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseGetById = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto>({ url: `/api/Exercise/${id}`, method: 'GET', signal });
};

export const getExerciseGetByIdQueryKey = (id?: number) => {
  return [`/api/Exercise/${id}`] as const;
};

export const getExerciseGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof exerciseGetById>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetById>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExerciseGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exerciseGetById>>> = ({ signal }) =>
    exerciseGetById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exerciseGetById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExerciseGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof exerciseGetById>>>;
export type ExerciseGetByIdQueryError = unknown;

export function useExerciseGetById<TData = Awaited<ReturnType<typeof exerciseGetById>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetById>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExerciseGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const exerciseUpdate = (id: number, updateExerciseDto: UpdateExerciseDto) => {
  return customAxiosInstance<ExerciseDto>({
    url: `/api/Exercise/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateExerciseDto
  });
};

export const getExerciseUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdate>>,
    TError,
    { id: number; data: UpdateExerciseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseUpdate>>,
  TError,
  { id: number; data: UpdateExerciseDto },
  TContext
> => {
  const mutationKey = ['exerciseUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseUpdate>>,
    { id: number; data: UpdateExerciseDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return exerciseUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseUpdate>>>;
export type ExerciseUpdateMutationBody = UpdateExerciseDto;
export type ExerciseUpdateMutationError = unknown;

export const useExerciseUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdate>>,
    TError,
    { id: number; data: UpdateExerciseDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseUpdate>>,
  TError,
  { id: number; data: UpdateExerciseDto },
  TContext
> => {
  const mutationOptions = getExerciseUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseDelete = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/Exercise/${id}`, method: 'DELETE' });
};

export const getExerciseDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof exerciseDelete>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof exerciseDelete>>, TError, { id: number }, TContext> => {
  const mutationKey = ['exerciseDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseDelete>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return exerciseDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseDelete>>>;

export type ExerciseDeleteMutationError = unknown;

export const useExerciseDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof exerciseDelete>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof exerciseDelete>>, TError, { id: number }, TContext> => {
  const mutationOptions = getExerciseDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseApplyScheduleChange = (
  exerciseId: number,
  applyExerciseScheduleChangeDto: ApplyExerciseScheduleChangeDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ApplyExerciseScheduleChangeResponseDto>({
    url: `/api/Exercise/${exerciseId}/apply-schedule-change`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: applyExerciseScheduleChangeDto,
    signal
  });
};

export const getExerciseApplyScheduleChangeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
    TError,
    { exerciseId: number; data: ApplyExerciseScheduleChangeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
  TError,
  { exerciseId: number; data: ApplyExerciseScheduleChangeDto },
  TContext
> => {
  const mutationKey = ['exerciseApplyScheduleChange'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
    { exerciseId: number; data: ApplyExerciseScheduleChangeDto }
  > = (props) => {
    const { exerciseId, data } = props ?? {};

    return exerciseApplyScheduleChange(exerciseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseApplyScheduleChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseApplyScheduleChange>>
>;
export type ExerciseApplyScheduleChangeMutationBody = ApplyExerciseScheduleChangeDto;
export type ExerciseApplyScheduleChangeMutationError = unknown;

export const useExerciseApplyScheduleChange = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
    TError,
    { exerciseId: number; data: ApplyExerciseScheduleChangeDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
  TError,
  { exerciseId: number; data: ApplyExerciseScheduleChangeDto },
  TContext
> => {
  const mutationOptions = getExerciseApplyScheduleChangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseClone = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<CloneExerciseResponseDto>({ url: `/api/Exercise/${id}/clone`, method: 'POST', signal });
};

export const getExerciseCloneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof exerciseClone>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof exerciseClone>>, TError, { id: number }, TContext> => {
  const mutationKey = ['exerciseClone'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseClone>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return exerciseClone(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseCloneMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseClone>>>;

export type ExerciseCloneMutationError = unknown;

export const useExerciseClone = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof exerciseClone>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof exerciseClone>>, TError, { id: number }, TContext> => {
  const mutationOptions = getExerciseCloneMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseAddContact = (
  exerciseId: number,
  createExerciseContactDto: CreateExerciseContactDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ExerciseContactDto>({
    url: `/api/Exercise/${exerciseId}/contacts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createExerciseContactDto,
    signal
  });
};

export const getExerciseAddContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddContact>>,
    TError,
    { exerciseId: number; data: CreateExerciseContactDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseAddContact>>,
  TError,
  { exerciseId: number; data: CreateExerciseContactDto },
  TContext
> => {
  const mutationKey = ['exerciseAddContact'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseAddContact>>,
    { exerciseId: number; data: CreateExerciseContactDto }
  > = (props) => {
    const { exerciseId, data } = props ?? {};

    return exerciseAddContact(exerciseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseAddContactMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseAddContact>>>;
export type ExerciseAddContactMutationBody = CreateExerciseContactDto;
export type ExerciseAddContactMutationError = unknown;

export const useExerciseAddContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddContact>>,
    TError,
    { exerciseId: number; data: CreateExerciseContactDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseAddContact>>,
  TError,
  { exerciseId: number; data: CreateExerciseContactDto },
  TContext
> => {
  const mutationOptions = getExerciseAddContactMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseUpdateContact = (
  exerciseId: number,
  contactId: number,
  updateExerciseContactDto: UpdateExerciseContactDto
) => {
  return customAxiosInstance<ExerciseContactDto>({
    url: `/api/Exercise/${exerciseId}/contacts/${contactId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateExerciseContactDto
  });
};

export const getExerciseUpdateContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdateContact>>,
    TError,
    { exerciseId: number; contactId: number; data: UpdateExerciseContactDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseUpdateContact>>,
  TError,
  { exerciseId: number; contactId: number; data: UpdateExerciseContactDto },
  TContext
> => {
  const mutationKey = ['exerciseUpdateContact'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseUpdateContact>>,
    { exerciseId: number; contactId: number; data: UpdateExerciseContactDto }
  > = (props) => {
    const { exerciseId, contactId, data } = props ?? {};

    return exerciseUpdateContact(exerciseId, contactId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseUpdateContactMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseUpdateContact>>>;
export type ExerciseUpdateContactMutationBody = UpdateExerciseContactDto;
export type ExerciseUpdateContactMutationError = unknown;

export const useExerciseUpdateContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdateContact>>,
    TError,
    { exerciseId: number; contactId: number; data: UpdateExerciseContactDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseUpdateContact>>,
  TError,
  { exerciseId: number; contactId: number; data: UpdateExerciseContactDto },
  TContext
> => {
  const mutationOptions = getExerciseUpdateContactMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseDeleteContact = (exerciseId: number, contactId: number) => {
  return customAxiosInstance<void>({ url: `/api/Exercise/${exerciseId}/contacts/${contactId}`, method: 'DELETE' });
};

export const getExerciseDeleteContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeleteContact>>,
    TError,
    { exerciseId: number; contactId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseDeleteContact>>,
  TError,
  { exerciseId: number; contactId: number },
  TContext
> => {
  const mutationKey = ['exerciseDeleteContact'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseDeleteContact>>,
    { exerciseId: number; contactId: number }
  > = (props) => {
    const { exerciseId, contactId } = props ?? {};

    return exerciseDeleteContact(exerciseId, contactId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseDeleteContactMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseDeleteContact>>>;

export type ExerciseDeleteContactMutationError = unknown;

export const useExerciseDeleteContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeleteContact>>,
    TError,
    { exerciseId: number; contactId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseDeleteContact>>,
  TError,
  { exerciseId: number; contactId: number },
  TContext
> => {
  const mutationOptions = getExerciseDeleteContactMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseAddPlaybookItem = (
  exerciseId: number,
  createPlaybookItemDto: CreatePlaybookItemDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PlaybookItemDto>({
    url: `/api/Exercise/${exerciseId}/playbook`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPlaybookItemDto,
    signal
  });
};

export const getExerciseAddPlaybookItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
    TError,
    { exerciseId: number; data: CreatePlaybookItemDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
  TError,
  { exerciseId: number; data: CreatePlaybookItemDto },
  TContext
> => {
  const mutationKey = ['exerciseAddPlaybookItem'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
    { exerciseId: number; data: CreatePlaybookItemDto }
  > = (props) => {
    const { exerciseId, data } = props ?? {};

    return exerciseAddPlaybookItem(exerciseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseAddPlaybookItemMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseAddPlaybookItem>>>;
export type ExerciseAddPlaybookItemMutationBody = CreatePlaybookItemDto;
export type ExerciseAddPlaybookItemMutationError = unknown;

export const useExerciseAddPlaybookItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
    TError,
    { exerciseId: number; data: CreatePlaybookItemDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
  TError,
  { exerciseId: number; data: CreatePlaybookItemDto },
  TContext
> => {
  const mutationOptions = getExerciseAddPlaybookItemMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseApplyPlaybookItemTimeChange = (
  exerciseId: number,
  itemId: number,
  applyPlaybookItemTimeChangeDto: ApplyPlaybookItemTimeChangeDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ApplyPlaybookItemTimeChangeResponseDto>({
    url: `/api/Exercise/${exerciseId}/playbook/${itemId}/apply-time-change`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: applyPlaybookItemTimeChangeDto,
    signal
  });
};

export const getExerciseApplyPlaybookItemTimeChangeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
    TError,
    { exerciseId: number; itemId: number; data: ApplyPlaybookItemTimeChangeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
  TError,
  { exerciseId: number; itemId: number; data: ApplyPlaybookItemTimeChangeDto },
  TContext
> => {
  const mutationKey = ['exerciseApplyPlaybookItemTimeChange'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
    { exerciseId: number; itemId: number; data: ApplyPlaybookItemTimeChangeDto }
  > = (props) => {
    const { exerciseId, itemId, data } = props ?? {};

    return exerciseApplyPlaybookItemTimeChange(exerciseId, itemId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseApplyPlaybookItemTimeChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>
>;
export type ExerciseApplyPlaybookItemTimeChangeMutationBody = ApplyPlaybookItemTimeChangeDto;
export type ExerciseApplyPlaybookItemTimeChangeMutationError = unknown;

export const useExerciseApplyPlaybookItemTimeChange = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
    TError,
    { exerciseId: number; itemId: number; data: ApplyPlaybookItemTimeChangeDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
  TError,
  { exerciseId: number; itemId: number; data: ApplyPlaybookItemTimeChangeDto },
  TContext
> => {
  const mutationOptions = getExerciseApplyPlaybookItemTimeChangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseUpdatePlaybookItem = (
  exerciseId: number,
  itemId: number,
  updatePlaybookItemDto: UpdatePlaybookItemDto
) => {
  return customAxiosInstance<PlaybookItemDto>({
    url: `/api/Exercise/${exerciseId}/playbook/${itemId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePlaybookItemDto
  });
};

export const getExerciseUpdatePlaybookItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
    TError,
    { exerciseId: number; itemId: number; data: UpdatePlaybookItemDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
  TError,
  { exerciseId: number; itemId: number; data: UpdatePlaybookItemDto },
  TContext
> => {
  const mutationKey = ['exerciseUpdatePlaybookItem'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
    { exerciseId: number; itemId: number; data: UpdatePlaybookItemDto }
  > = (props) => {
    const { exerciseId, itemId, data } = props ?? {};

    return exerciseUpdatePlaybookItem(exerciseId, itemId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseUpdatePlaybookItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>
>;
export type ExerciseUpdatePlaybookItemMutationBody = UpdatePlaybookItemDto;
export type ExerciseUpdatePlaybookItemMutationError = unknown;

export const useExerciseUpdatePlaybookItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
    TError,
    { exerciseId: number; itemId: number; data: UpdatePlaybookItemDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
  TError,
  { exerciseId: number; itemId: number; data: UpdatePlaybookItemDto },
  TContext
> => {
  const mutationOptions = getExerciseUpdatePlaybookItemMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exerciseDeletePlaybookItem = (exerciseId: number, itemId: number) => {
  return customAxiosInstance<void>({ url: `/api/Exercise/${exerciseId}/playbook/${itemId}`, method: 'DELETE' });
};

export const getExerciseDeletePlaybookItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
    TError,
    { exerciseId: number; itemId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
  TError,
  { exerciseId: number; itemId: number },
  TContext
> => {
  const mutationKey = ['exerciseDeletePlaybookItem'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
    { exerciseId: number; itemId: number }
  > = (props) => {
    const { exerciseId, itemId } = props ?? {};

    return exerciseDeletePlaybookItem(exerciseId, itemId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseDeletePlaybookItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>
>;

export type ExerciseDeletePlaybookItemMutationError = unknown;

export const useExerciseDeletePlaybookItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
    TError,
    { exerciseId: number; itemId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
  TError,
  { exerciseId: number; itemId: number },
  TContext
> => {
  const mutationOptions = getExerciseDeletePlaybookItemMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportExport = (conversationExportFilterDto: ConversationExportFilterDto, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/conversations/export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationExportFilterDto,
    signal
  });
};

export const getExportExportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportExport>>,
    TError,
    { data: ConversationExportFilterDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportExport>>,
  TError,
  { data: ConversationExportFilterDto },
  TContext
> => {
  const mutationKey = ['exportExport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportExport>>,
    { data: ConversationExportFilterDto }
  > = (props) => {
    const { data } = props ?? {};

    return exportExport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportMutationResult = NonNullable<Awaited<ReturnType<typeof exportExport>>>;
export type ExportExportMutationBody = ConversationExportFilterDto;
export type ExportExportMutationError = unknown;

export const useExportExport = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportExport>>,
    TError,
    { data: ConversationExportFilterDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportExport>>,
  TError,
  { data: ConversationExportFilterDto },
  TContext
> => {
  const mutationOptions = getExportExportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsGetCategories = (signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetCategoryDto[]>({
    url: `/api/GlobalAssets/GetCategories`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetCategoriesQueryKey = () => {
  return [`/api/GlobalAssets/GetCategories`] as const;
};

export const getGlobalAssetsGetCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetCategories>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetCategories>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetCategories>>> = ({ signal }) =>
    globalAssetsGetCategories(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsGetCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsGetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsGetCategories>>>;
export type GlobalAssetsGetCategoriesQueryError = unknown;

export function useGlobalAssetsGetCategories<
  TData = Awaited<ReturnType<typeof globalAssetsGetCategories>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetCategories>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetCategoriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const globalAssetsGetFullData = (signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetFullDto[]>({
    url: `/api/GlobalAssets/GetFullData/full`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetFullDataQueryKey = () => {
  return [`/api/GlobalAssets/GetFullData/full`] as const;
};

export const getGlobalAssetsGetFullDataQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetFullData>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetFullData>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetFullDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetFullData>>> = ({ signal }) =>
    globalAssetsGetFullData(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsGetFullData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsGetFullDataQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsGetFullData>>>;
export type GlobalAssetsGetFullDataQueryError = unknown;

export function useGlobalAssetsGetFullData<
  TData = Awaited<ReturnType<typeof globalAssetsGetFullData>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetFullData>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetFullDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const globalAssetsCreateCategory = (
  createGlobalAssetCategoryCommand: CreateGlobalAssetCategoryCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetFullDto>({
    url: `/api/GlobalAssets/CreateCategory`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createGlobalAssetCategoryCommand,
    signal
  });
};

export const getGlobalAssetsCreateCategoryMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
    TError,
    { data: CreateGlobalAssetCategoryCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
  TError,
  { data: CreateGlobalAssetCategoryCommand },
  TContext
> => {
  const mutationKey = ['globalAssetsCreateCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
    { data: CreateGlobalAssetCategoryCommand }
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsCreateCategory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCreateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsCreateCategory>>
>;
export type GlobalAssetsCreateCategoryMutationBody = CreateGlobalAssetCategoryCommand;
export type GlobalAssetsCreateCategoryMutationError = void;

export const useGlobalAssetsCreateCategory = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
    TError,
    { data: CreateGlobalAssetCategoryCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
  TError,
  { data: CreateGlobalAssetCategoryCommand },
  TContext
> => {
  const mutationOptions = getGlobalAssetsCreateCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsUpdateCategory = (
  categoryId: number,
  updateGlobalAssetCategoryCommand: UpdateGlobalAssetCategoryCommand
) => {
  return customAxiosInstance<GlobalAssetFullDto>({
    url: `/api/GlobalAssets/UpdateCategory/${categoryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateGlobalAssetCategoryCommand
  });
};

export const getGlobalAssetsUpdateCategoryMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
    TError,
    { categoryId: number; data: UpdateGlobalAssetCategoryCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
  TError,
  { categoryId: number; data: UpdateGlobalAssetCategoryCommand },
  TContext
> => {
  const mutationKey = ['globalAssetsUpdateCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
    { categoryId: number; data: UpdateGlobalAssetCategoryCommand }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return globalAssetsUpdateCategory(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsUpdateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsUpdateCategory>>
>;
export type GlobalAssetsUpdateCategoryMutationBody = UpdateGlobalAssetCategoryCommand;
export type GlobalAssetsUpdateCategoryMutationError = unknown;

export const useGlobalAssetsUpdateCategory = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
    TError,
    { categoryId: number; data: UpdateGlobalAssetCategoryCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
  TError,
  { categoryId: number; data: UpdateGlobalAssetCategoryCommand },
  TContext
> => {
  const mutationOptions = getGlobalAssetsUpdateCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsDeleteCategories = (
  deleteGlobalAssetCategoriesCommand: DeleteGlobalAssetCategoriesCommand
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/DeleteCategories`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteGlobalAssetCategoriesCommand
  });
};

export const getGlobalAssetsDeleteCategoriesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
    TError,
    { data: DeleteGlobalAssetCategoriesCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
  TError,
  { data: DeleteGlobalAssetCategoriesCommand },
  TContext
> => {
  const mutationKey = ['globalAssetsDeleteCategories'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
    { data: DeleteGlobalAssetCategoriesCommand }
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsDeleteCategories(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsDeleteCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsDeleteCategories>>
>;
export type GlobalAssetsDeleteCategoriesMutationBody = DeleteGlobalAssetCategoriesCommand;
export type GlobalAssetsDeleteCategoriesMutationError = unknown;

export const useGlobalAssetsDeleteCategories = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
    TError,
    { data: DeleteGlobalAssetCategoriesCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
  TError,
  { data: DeleteGlobalAssetCategoriesCommand },
  TContext
> => {
  const mutationOptions = getGlobalAssetsDeleteCategoriesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsGetIntents = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetIntentDto[]>({
    url: `/api/GlobalAssets/GetIntents/${categoryId}/intents`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetIntentsQueryKey = (categoryId?: number) => {
  return [`/api/GlobalAssets/GetIntents/${categoryId}/intents`] as const;
};

export const getGlobalAssetsGetIntentsQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetIntents>>,
  TError = unknown
>(
  categoryId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetIntentsQueryKey(categoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetIntents>>> = ({ signal }) =>
    globalAssetsGetIntents(categoryId, signal);

  return { queryKey, queryFn, enabled: !!categoryId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsGetIntents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsGetIntentsQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsGetIntents>>>;
export type GlobalAssetsGetIntentsQueryError = unknown;

export function useGlobalAssetsGetIntents<TData = Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError = unknown>(
  categoryId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetIntentsQueryOptions(categoryId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const globalAssetsCreateIntent = (
  categoryId: number,
  createGlobalAssetIntentCommand: CreateGlobalAssetIntentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/CreateIntent/${categoryId}/intent`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createGlobalAssetIntentCommand,
    signal
  });
};

export const getGlobalAssetsCreateIntentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
    TError,
    { categoryId: number; data: CreateGlobalAssetIntentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
  TError,
  { categoryId: number; data: CreateGlobalAssetIntentCommand },
  TContext
> => {
  const mutationKey = ['globalAssetsCreateIntent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
    { categoryId: number; data: CreateGlobalAssetIntentCommand }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return globalAssetsCreateIntent(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCreateIntentMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsCreateIntent>>>;
export type GlobalAssetsCreateIntentMutationBody = CreateGlobalAssetIntentCommand;
export type GlobalAssetsCreateIntentMutationError = unknown;

export const useGlobalAssetsCreateIntent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
    TError,
    { categoryId: number; data: CreateGlobalAssetIntentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
  TError,
  { categoryId: number; data: CreateGlobalAssetIntentCommand },
  TContext
> => {
  const mutationOptions = getGlobalAssetsCreateIntentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsUpdateIntent = (
  intentId: number,
  updateGlobalAssetIntentCommand: UpdateGlobalAssetIntentCommand
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/UpdateIntent/intents/${intentId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateGlobalAssetIntentCommand
  });
};

export const getGlobalAssetsUpdateIntentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
    TError,
    { intentId: number; data: UpdateGlobalAssetIntentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
  TError,
  { intentId: number; data: UpdateGlobalAssetIntentCommand },
  TContext
> => {
  const mutationKey = ['globalAssetsUpdateIntent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
    { intentId: number; data: UpdateGlobalAssetIntentCommand }
  > = (props) => {
    const { intentId, data } = props ?? {};

    return globalAssetsUpdateIntent(intentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsUpdateIntentMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsUpdateIntent>>>;
export type GlobalAssetsUpdateIntentMutationBody = UpdateGlobalAssetIntentCommand;
export type GlobalAssetsUpdateIntentMutationError = unknown;

export const useGlobalAssetsUpdateIntent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
    TError,
    { intentId: number; data: UpdateGlobalAssetIntentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
  TError,
  { intentId: number; data: UpdateGlobalAssetIntentCommand },
  TContext
> => {
  const mutationOptions = getGlobalAssetsUpdateIntentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsDeleteIntents = (deleteGlobalAssetIntentCommand: DeleteGlobalAssetIntentCommand) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/DeleteIntents/intents`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteGlobalAssetIntentCommand
  });
};

export const getGlobalAssetsDeleteIntentsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
    TError,
    { data: DeleteGlobalAssetIntentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
  TError,
  { data: DeleteGlobalAssetIntentCommand },
  TContext
> => {
  const mutationKey = ['globalAssetsDeleteIntents'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
    { data: DeleteGlobalAssetIntentCommand }
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsDeleteIntents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsDeleteIntentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsDeleteIntents>>
>;
export type GlobalAssetsDeleteIntentsMutationBody = DeleteGlobalAssetIntentCommand;
export type GlobalAssetsDeleteIntentsMutationError = unknown;

export const useGlobalAssetsDeleteIntents = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
    TError,
    { data: DeleteGlobalAssetIntentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
  TError,
  { data: DeleteGlobalAssetIntentCommand },
  TContext
> => {
  const mutationOptions = getGlobalAssetsDeleteIntentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsCopyIntentToCompany = (
  intentId: number,
  params?: GlobalAssetsCopyIntentToCompanyParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/CopyIntentToCompany/intents/${intentId}`,
    method: 'POST',
    params,
    signal
  });
};

export const getGlobalAssetsCopyIntentToCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
    TError,
    { intentId: number; params?: GlobalAssetsCopyIntentToCompanyParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
  TError,
  { intentId: number; params?: GlobalAssetsCopyIntentToCompanyParams },
  TContext
> => {
  const mutationKey = ['globalAssetsCopyIntentToCompany'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
    { intentId: number; params?: GlobalAssetsCopyIntentToCompanyParams }
  > = (props) => {
    const { intentId, params } = props ?? {};

    return globalAssetsCopyIntentToCompany(intentId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCopyIntentToCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>
>;

export type GlobalAssetsCopyIntentToCompanyMutationError = unknown;

export const useGlobalAssetsCopyIntentToCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
    TError,
    { intentId: number; params?: GlobalAssetsCopyIntentToCompanyParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
  TError,
  { intentId: number; params?: GlobalAssetsCopyIntentToCompanyParams },
  TContext
> => {
  const mutationOptions = getGlobalAssetsCopyIntentToCompanyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsMoveAndMergeIntentToCategory = (
  intentId: number,
  globalAssetsMoveAndMergeIntentToCategoryBody: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/MoveAndMergeIntentToCategory/intents/${intentId}/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: globalAssetsMoveAndMergeIntentToCategoryBody,
    signal
  });
};

export const getGlobalAssetsMoveAndMergeIntentToCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
    TError,
    { intentId: number; data: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
  TError,
  { intentId: number; data: number },
  TContext
> => {
  const mutationKey = ['globalAssetsMoveAndMergeIntentToCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
    { intentId: number; data: number }
  > = (props) => {
    const { intentId, data } = props ?? {};

    return globalAssetsMoveAndMergeIntentToCategory(intentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsMoveAndMergeIntentToCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>
>;
export type GlobalAssetsMoveAndMergeIntentToCategoryMutationBody = number;
export type GlobalAssetsMoveAndMergeIntentToCategoryMutationError = unknown;

export const useGlobalAssetsMoveAndMergeIntentToCategory = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
    TError,
    { intentId: number; data: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
  TError,
  { intentId: number; data: number },
  TContext
> => {
  const mutationOptions = getGlobalAssetsMoveAndMergeIntentToCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsCreateSample = (
  intentId: number,
  globalAssetsCreateSampleBody: string,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/CreateSample/intents/${intentId}/sample`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: globalAssetsCreateSampleBody,
    signal
  });
};

export const getGlobalAssetsCreateSampleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateSample>>,
    TError,
    { intentId: number; data: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCreateSample>>,
  TError,
  { intentId: number; data: string },
  TContext
> => {
  const mutationKey = ['globalAssetsCreateSample'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCreateSample>>,
    { intentId: number; data: string }
  > = (props) => {
    const { intentId, data } = props ?? {};

    return globalAssetsCreateSample(intentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCreateSampleMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsCreateSample>>>;
export type GlobalAssetsCreateSampleMutationBody = string;
export type GlobalAssetsCreateSampleMutationError = unknown;

export const useGlobalAssetsCreateSample = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateSample>>,
    TError,
    { intentId: number; data: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCreateSample>>,
  TError,
  { intentId: number; data: string },
  TContext
> => {
  const mutationOptions = getGlobalAssetsCreateSampleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsUpdateSample = (intentId: number, sampleId: number, globalAssetsUpdateSampleBody: string) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/UpdateSample/intents/${intentId}/${sampleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: globalAssetsUpdateSampleBody
  });
};

export const getGlobalAssetsUpdateSampleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
    TError,
    { intentId: number; sampleId: number; data: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
  TError,
  { intentId: number; sampleId: number; data: string },
  TContext
> => {
  const mutationKey = ['globalAssetsUpdateSample'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
    { intentId: number; sampleId: number; data: string }
  > = (props) => {
    const { intentId, sampleId, data } = props ?? {};

    return globalAssetsUpdateSample(intentId, sampleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsUpdateSampleMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsUpdateSample>>>;
export type GlobalAssetsUpdateSampleMutationBody = string;
export type GlobalAssetsUpdateSampleMutationError = unknown;

export const useGlobalAssetsUpdateSample = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
    TError,
    { intentId: number; sampleId: number; data: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
  TError,
  { intentId: number; sampleId: number; data: string },
  TContext
> => {
  const mutationOptions = getGlobalAssetsUpdateSampleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsDeleteSample = (intentId: number, sampleId: number) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/DeleteSample/intents/${intentId}/${sampleId}`,
    method: 'DELETE'
  });
};

export const getGlobalAssetsDeleteSampleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
    TError,
    { intentId: number; sampleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
  TError,
  { intentId: number; sampleId: number },
  TContext
> => {
  const mutationKey = ['globalAssetsDeleteSample'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
    { intentId: number; sampleId: number }
  > = (props) => {
    const { intentId, sampleId } = props ?? {};

    return globalAssetsDeleteSample(intentId, sampleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsDeleteSampleMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsDeleteSample>>>;

export type GlobalAssetsDeleteSampleMutationError = unknown;

export const useGlobalAssetsDeleteSample = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
    TError,
    { intentId: number; sampleId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
  TError,
  { intentId: number; sampleId: number },
  TContext
> => {
  const mutationOptions = getGlobalAssetsDeleteSampleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsGetTemplatesConnections = (intentId: number, signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetConnection[]>({
    url: `/api/GlobalAssets/GetTemplatesConnections/intents/${intentId}/connections`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetTemplatesConnectionsQueryKey = (intentId?: number) => {
  return [`/api/GlobalAssets/GetTemplatesConnections/intents/${intentId}/connections`] as const;
};

export const getGlobalAssetsGetTemplatesConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>,
  TError = unknown
>(
  intentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetTemplatesConnectionsQueryKey(intentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>> = ({ signal }) =>
    globalAssetsGetTemplatesConnections(intentId, signal);

  return { queryKey, queryFn, enabled: !!intentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsGetTemplatesConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>
>;
export type GlobalAssetsGetTemplatesConnectionsQueryError = unknown;

export function useGlobalAssetsGetTemplatesConnections<
  TData = Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>,
  TError = unknown
>(
  intentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetTemplatesConnectionsQueryOptions(intentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const globalAssetsImportData = (
  globalAssetsImportDataBody: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/ImportData/import`,
    method: 'POST',
    data: globalAssetsImportDataBody,
    signal
  });
};

export const getGlobalAssetsImportDataMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsImportData>>,
    TError,
    { data: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsImportData>>,
  TError,
  { data: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo },
  TContext
> => {
  const mutationKey = ['globalAssetsImportData'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsImportData>>,
    { data: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo }
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsImportData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsImportDataMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsImportData>>>;
export type GlobalAssetsImportDataMutationBody = GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo;
export type GlobalAssetsImportDataMutationError = unknown;

export const useGlobalAssetsImportData = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsImportData>>,
    TError,
    { data: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsImportData>>,
  TError,
  { data: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo },
  TContext
> => {
  const mutationOptions = getGlobalAssetsImportDataMutationOptions(options);

  return useMutation(mutationOptions);
};

export const globalAssetsExportData = (selectedLanguage: string, signal?: AbortSignal) => {
  return customAxiosInstance<Blob>({
    url: `/api/GlobalAssets/ExportData/export/${selectedLanguage}`,
    method: 'GET',
    responseType: 'blob',
    signal
  });
};

export const getGlobalAssetsExportDataQueryKey = (selectedLanguage?: string) => {
  return [`/api/GlobalAssets/ExportData/export/${selectedLanguage}`] as const;
};

export const getGlobalAssetsExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsExportData>>,
  TError = unknown
>(
  selectedLanguage: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsExportData>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsExportDataQueryKey(selectedLanguage);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsExportData>>> = ({ signal }) =>
    globalAssetsExportData(selectedLanguage, signal);

  return { queryKey, queryFn, enabled: !!selectedLanguage, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsExportData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsExportData>>>;
export type GlobalAssetsExportDataQueryError = unknown;

export function useGlobalAssetsExportData<TData = Awaited<ReturnType<typeof globalAssetsExportData>>, TError = unknown>(
  selectedLanguage: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsExportData>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsExportDataQueryOptions(selectedLanguage, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets the status of a job by ID
 */
export const jobStatusGetJobStatus = (jobId: string, signal?: AbortSignal) => {
  return customAxiosInstance<JobStatusDto>({ url: `/api/JobStatus/${jobId}`, method: 'GET', signal });
};

export const getJobStatusGetJobStatusQueryKey = (jobId?: string) => {
  return [`/api/JobStatus/${jobId}`] as const;
};

export const getJobStatusGetJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetJobStatus>>,
  TError = ProblemDetails
>(
  jobId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetJobStatus>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetJobStatusQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetJobStatus>>> = ({ signal }) =>
    jobStatusGetJobStatus(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetJobStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetJobStatus>>>;
export type JobStatusGetJobStatusQueryError = ProblemDetails;

/**
 * @summary Gets the status of a job by ID
 */

export function useJobStatusGetJobStatus<
  TData = Awaited<ReturnType<typeof jobStatusGetJobStatus>>,
  TError = ProblemDetails
>(
  jobId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetJobStatus>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetJobStatusQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets recent jobs that have an error message.
 */
export const jobStatusGetRecentJobsWithErrors = (signal?: AbortSignal) => {
  return customAxiosInstance<JobStatusDto[]>({ url: `/api/JobStatus/errors`, method: 'GET', signal });
};

export const getJobStatusGetRecentJobsWithErrorsQueryKey = () => {
  return [`/api/JobStatus/errors`] as const;
};

export const getJobStatusGetRecentJobsWithErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetRecentJobsWithErrorsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>> = ({ signal }) =>
    jobStatusGetRecentJobsWithErrors(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetRecentJobsWithErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>
>;
export type JobStatusGetRecentJobsWithErrorsQueryError = unknown;

/**
 * @summary Gets recent jobs that have an error message.
 */

export function useJobStatusGetRecentJobsWithErrors<
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetRecentJobsWithErrorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a list of recent jobs, optionally filtered by count.
 */
export const jobStatusGetRecentJobs = (params?: JobStatusGetRecentJobsParams, signal?: AbortSignal) => {
  return customAxiosInstance<JobStatusDto[]>({ url: `/api/JobStatus/recent`, method: 'GET', params, signal });
};

export const getJobStatusGetRecentJobsQueryKey = (params?: JobStatusGetRecentJobsParams) => {
  return [`/api/JobStatus/recent`, ...(params ? [params] : [])] as const;
};

export const getJobStatusGetRecentJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobs>>,
  TError = unknown
>(
  params?: JobStatusGetRecentJobsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetRecentJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>> = ({ signal }) =>
    jobStatusGetRecentJobs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetRecentJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetRecentJobsQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>>;
export type JobStatusGetRecentJobsQueryError = unknown;

/**
 * @summary Gets a list of recent jobs, optionally filtered by count.
 */

export function useJobStatusGetRecentJobs<TData = Awaited<ReturnType<typeof jobStatusGetRecentJobs>>, TError = unknown>(
  params?: JobStatusGetRecentJobsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetRecentJobsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Server-side paged list of recent jobs.
 */
export const jobStatusGetRecentJobsPaged = (params?: JobStatusGetRecentJobsPagedParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoJobStatusDto>({
    url: `/api/JobStatus/recent-paged`,
    method: 'GET',
    params,
    signal
  });
};

export const getJobStatusGetRecentJobsPagedQueryKey = (params?: JobStatusGetRecentJobsPagedParams) => {
  return [`/api/JobStatus/recent-paged`, ...(params ? [params] : [])] as const;
};

export const getJobStatusGetRecentJobsPagedQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>,
  TError = unknown
>(
  params?: JobStatusGetRecentJobsPagedParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetRecentJobsPagedQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>> = ({ signal }) =>
    jobStatusGetRecentJobsPaged(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetRecentJobsPagedQueryResult = NonNullable<
  Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>
>;
export type JobStatusGetRecentJobsPagedQueryError = unknown;

/**
 * @summary Server-side paged list of recent jobs.
 */

export function useJobStatusGetRecentJobsPaged<
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>,
  TError = unknown
>(
  params?: JobStatusGetRecentJobsPagedParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetRecentJobsPagedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets all possible task types that can be used for filtering.
 */
export const jobStatusGetTaskTypes = (signal?: AbortSignal) => {
  return customAxiosInstance<string[]>({ url: `/api/JobStatus/task-types`, method: 'GET', signal });
};

export const getJobStatusGetTaskTypesQueryKey = () => {
  return [`/api/JobStatus/task-types`] as const;
};

export const getJobStatusGetTaskTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetTaskTypes>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetTaskTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>> = ({ signal }) =>
    jobStatusGetTaskTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetTaskTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetTaskTypesQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>>;
export type JobStatusGetTaskTypesQueryError = unknown;

/**
 * @summary Gets all possible task types that can be used for filtering.
 */

export function useJobStatusGetTaskTypes<
  TData = Awaited<ReturnType<typeof jobStatusGetTaskTypes>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetTaskTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Reschedules a failed job.
 */
export const jobStatusRescheduleJob = (jobId: string, signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({ url: `/api/JobStatus/${jobId}/reschedule`, method: 'POST', signal });
};

export const getJobStatusRescheduleJobMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof jobStatusRescheduleJob>>, TError, { jobId: string }, TContext> => {
  const mutationKey = ['jobStatusRescheduleJob'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobStatusRescheduleJob>>, { jobId: string }> = (
    props
  ) => {
    const { jobId } = props ?? {};

    return jobStatusRescheduleJob(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type JobStatusRescheduleJobMutationResult = NonNullable<Awaited<ReturnType<typeof jobStatusRescheduleJob>>>;

export type JobStatusRescheduleJobMutationError = ProblemDetails | ProblemDetails | void;

/**
 * @summary Reschedules a failed job.
 */
export const useJobStatusRescheduleJob = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof jobStatusRescheduleJob>>, TError, { jobId: string }, TContext> => {
  const mutationOptions = getJobStatusRescheduleJobMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Reschedules StoreProvisionalDialogStatistic jobs from a recent window.
Only the most recent job per SessionId is considered.
 */
export const jobStatusRescheduleStoreProvisionalDialogStatistics = (
  bulkRescheduleStoreProvisionalDialogStatisticRequest: BulkRescheduleStoreProvisionalDialogStatisticRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<unknown>({
    url: `/api/JobStatus/reschedule/store-provisional-dialog-statistics`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkRescheduleStoreProvisionalDialogStatisticRequest,
    signal
  });
};

export const getJobStatusRescheduleStoreProvisionalDialogStatisticsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
    TError,
    { data: BulkRescheduleStoreProvisionalDialogStatisticRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
  TError,
  { data: BulkRescheduleStoreProvisionalDialogStatisticRequest },
  TContext
> => {
  const mutationKey = ['jobStatusRescheduleStoreProvisionalDialogStatistics'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
    { data: BulkRescheduleStoreProvisionalDialogStatisticRequest }
  > = (props) => {
    const { data } = props ?? {};

    return jobStatusRescheduleStoreProvisionalDialogStatistics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>
>;
export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationBody =
  BulkRescheduleStoreProvisionalDialogStatisticRequest;
export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationError = ProblemDetails;

/**
 * @summary Reschedules StoreProvisionalDialogStatistic jobs from a recent window.
Only the most recent job per SessionId is considered.
 */
export const useJobStatusRescheduleStoreProvisionalDialogStatistics = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
    TError,
    { data: BulkRescheduleStoreProvisionalDialogStatisticRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
  TError,
  { data: BulkRescheduleStoreProvisionalDialogStatisticRequest },
  TContext
> => {
  const mutationOptions = getJobStatusRescheduleStoreProvisionalDialogStatisticsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const licenseAgreementsGetAll = (signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto[]>({ url: `/api/LicenseAgreements`, method: 'GET', signal });
};

export const getLicenseAgreementsGetAllQueryKey = () => {
  return [`/api/LicenseAgreements`] as const;
};

export const getLicenseAgreementsGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetAll>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetAll>>> = ({ signal }) =>
    licenseAgreementsGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsGetAll>>>;
export type LicenseAgreementsGetAllQueryError = unknown;

export function useLicenseAgreementsGetAll<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetAll>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const licenseAgreementsCreate = (createLicenseAgreementDto: CreateLicenseAgreementDto, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto>({
    url: `/api/LicenseAgreements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createLicenseAgreementDto,
    signal
  });
};

export const getLicenseAgreementsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsCreate>>,
    TError,
    { data: CreateLicenseAgreementDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsCreate>>,
  TError,
  { data: CreateLicenseAgreementDto },
  TContext
> => {
  const mutationKey = ['licenseAgreementsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsCreate>>,
    { data: CreateLicenseAgreementDto }
  > = (props) => {
    const { data } = props ?? {};

    return licenseAgreementsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsCreate>>>;
export type LicenseAgreementsCreateMutationBody = CreateLicenseAgreementDto;
export type LicenseAgreementsCreateMutationError = unknown;

export const useLicenseAgreementsCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsCreate>>,
    TError,
    { data: CreateLicenseAgreementDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsCreate>>,
  TError,
  { data: CreateLicenseAgreementDto },
  TContext
> => {
  const mutationOptions = getLicenseAgreementsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const licenseAgreementsGetById = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto>({ url: `/api/LicenseAgreements/${id}`, method: 'GET', signal });
};

export const getLicenseAgreementsGetByIdQueryKey = (id?: number) => {
  return [`/api/LicenseAgreements/${id}`] as const;
};

export const getLicenseAgreementsGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetById>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetById>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetById>>> = ({ signal }) =>
    licenseAgreementsGetById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsGetById>>>;
export type LicenseAgreementsGetByIdQueryError = unknown;

export function useLicenseAgreementsGetById<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetById>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetById>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const licenseAgreementsUpdate = (id: number, updateLicenseAgreementDto: UpdateLicenseAgreementDto) => {
  return customAxiosInstance<LicenseAgreementDto>({
    url: `/api/LicenseAgreements/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateLicenseAgreementDto
  });
};

export const getLicenseAgreementsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
    TError,
    { id: number; data: UpdateLicenseAgreementDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
  TError,
  { id: number; data: UpdateLicenseAgreementDto },
  TContext
> => {
  const mutationKey = ['licenseAgreementsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
    { id: number; data: UpdateLicenseAgreementDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return licenseAgreementsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsUpdate>>>;
export type LicenseAgreementsUpdateMutationBody = UpdateLicenseAgreementDto;
export type LicenseAgreementsUpdateMutationError = unknown;

export const useLicenseAgreementsUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
    TError,
    { id: number; data: UpdateLicenseAgreementDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
  TError,
  { id: number; data: UpdateLicenseAgreementDto },
  TContext
> => {
  const mutationOptions = getLicenseAgreementsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const licenseAgreementsDelete = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/LicenseAgreements/${id}`, method: 'DELETE' });
};

export const getLicenseAgreementsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof licenseAgreementsDelete>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof licenseAgreementsDelete>>, TError, { id: number }, TContext> => {
  const mutationKey = ['licenseAgreementsDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof licenseAgreementsDelete>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return licenseAgreementsDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsDelete>>>;

export type LicenseAgreementsDeleteMutationError = unknown;

export const useLicenseAgreementsDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof licenseAgreementsDelete>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof licenseAgreementsDelete>>, TError, { id: number }, TContext> => {
  const mutationOptions = getLicenseAgreementsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const licenseAgreementsGetByCompanyId = (companyId: number, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto[]>({
    url: `/api/LicenseAgreements/company/${companyId}`,
    method: 'GET',
    signal
  });
};

export const getLicenseAgreementsGetByCompanyIdQueryKey = (companyId?: number) => {
  return [`/api/LicenseAgreements/company/${companyId}`] as const;
};

export const getLicenseAgreementsGetByCompanyIdQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>,
  TError = unknown
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetByCompanyIdQueryKey(companyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>> = ({ signal }) =>
    licenseAgreementsGetByCompanyId(companyId, signal);

  return { queryKey, queryFn, enabled: !!companyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetByCompanyIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>
>;
export type LicenseAgreementsGetByCompanyIdQueryError = unknown;

export function useLicenseAgreementsGetByCompanyId<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>,
  TError = unknown
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetByCompanyIdQueryOptions(companyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const licenseAgreementsGetByDepartmentId = (departmentId: number, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto[]>({
    url: `/api/LicenseAgreements/department/${departmentId}`,
    method: 'GET',
    signal
  });
};

export const getLicenseAgreementsGetByDepartmentIdQueryKey = (departmentId?: number) => {
  return [`/api/LicenseAgreements/department/${departmentId}`] as const;
};

export const getLicenseAgreementsGetByDepartmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>,
  TError = unknown
>(
  departmentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetByDepartmentIdQueryKey(departmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>> = ({ signal }) =>
    licenseAgreementsGetByDepartmentId(departmentId, signal);

  return { queryKey, queryFn, enabled: !!departmentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetByDepartmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>
>;
export type LicenseAgreementsGetByDepartmentIdQueryError = unknown;

export function useLicenseAgreementsGetByDepartmentId<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>,
  TError = unknown
>(
  departmentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetByDepartmentIdQueryOptions(departmentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const licenseAgreementsGetUsage = (params?: LicenseAgreementsGetUsageParams, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseUsageDto>({ url: `/api/LicenseAgreements/usage`, method: 'GET', params, signal });
};

export const getLicenseAgreementsGetUsageQueryKey = (params?: LicenseAgreementsGetUsageParams) => {
  return [`/api/LicenseAgreements/usage`, ...(params ? [params] : [])] as const;
};

export const getLicenseAgreementsGetUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetUsage>>,
  TError = unknown
>(
  params?: LicenseAgreementsGetUsageParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>> = ({ signal }) =>
    licenseAgreementsGetUsage(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetUsageQueryResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>>;
export type LicenseAgreementsGetUsageQueryError = unknown;

export function useLicenseAgreementsGetUsage<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetUsage>>,
  TError = unknown
>(
  params?: LicenseAgreementsGetUsageParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetUsageQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const licenseAgreementsGetBatchUsage = (
  getLicenseUsageBatchRequest: GetLicenseUsageBatchRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<LicenseUsageDto[]>({
    url: `/api/LicenseAgreements/usage/batch`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getLicenseUsageBatchRequest,
    signal
  });
};

export const getLicenseAgreementsGetBatchUsageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
    TError,
    { data: GetLicenseUsageBatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
  TError,
  { data: GetLicenseUsageBatchRequest },
  TContext
> => {
  const mutationKey = ['licenseAgreementsGetBatchUsage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
    { data: GetLicenseUsageBatchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return licenseAgreementsGetBatchUsage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsGetBatchUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>
>;
export type LicenseAgreementsGetBatchUsageMutationBody = GetLicenseUsageBatchRequest;
export type LicenseAgreementsGetBatchUsageMutationError = unknown;

export const useLicenseAgreementsGetBatchUsage = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
    TError,
    { data: GetLicenseUsageBatchRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
  TError,
  { data: GetLicenseUsageBatchRequest },
  TContext
> => {
  const mutationOptions = getLicenseAgreementsGetBatchUsageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Throws a test exception to verify error reporting (e.g. Application Insights).
Restricted to SuperAdmin role.
 */
export const maintenanceThrowTestException = (testExceptionRequest: TestExceptionRequest, signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({
    url: `/api/maintenance/test-exception`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testExceptionRequest,
    signal
  });
};

export const getMaintenanceThrowTestExceptionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceThrowTestException>>,
    TError,
    { data: TestExceptionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maintenanceThrowTestException>>,
  TError,
  { data: TestExceptionRequest },
  TContext
> => {
  const mutationKey = ['maintenanceThrowTestException'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maintenanceThrowTestException>>,
    { data: TestExceptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return maintenanceThrowTestException(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaintenanceThrowTestExceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof maintenanceThrowTestException>>
>;
export type MaintenanceThrowTestExceptionMutationBody = TestExceptionRequest;
export type MaintenanceThrowTestExceptionMutationError = void;

/**
 * @summary Throws a test exception to verify error reporting (e.g. Application Insights).
Restricted to SuperAdmin role.
 */
export const useMaintenanceThrowTestException = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceThrowTestException>>,
    TError,
    { data: TestExceptionRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof maintenanceThrowTestException>>,
  TError,
  { data: TestExceptionRequest },
  TContext
> => {
  const mutationOptions = getMaintenanceThrowTestExceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lists available task types with example payload templates to prefill the UI.
 */
export const maintenanceGetTaskTemplates = (signal?: AbortSignal) => {
  return customAxiosInstance<TaskTemplateDto[]>({ url: `/api/maintenance/tasks`, method: 'GET', signal });
};

export const getMaintenanceGetTaskTemplatesQueryKey = () => {
  return [`/api/maintenance/tasks`] as const;
};

export const getMaintenanceGetTaskTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMaintenanceGetTaskTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>> = ({ signal }) =>
    maintenanceGetTaskTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MaintenanceGetTaskTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>
>;
export type MaintenanceGetTaskTemplatesQueryError = unknown;

/**
 * @summary Lists available task types with example payload templates to prefill the UI.
 */

export function useMaintenanceGetTaskTemplates<
  TData = Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMaintenanceGetTaskTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Triggers any task by taskType with an arbitrary JSON payload.
 */
export const maintenanceTrigger = (triggerJobRequest: TriggerJobRequest, signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({
    url: `/api/maintenance/trigger`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerJobRequest,
    signal
  });
};

export const getMaintenanceTriggerMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceTrigger>>,
    TError,
    { data: TriggerJobRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maintenanceTrigger>>,
  TError,
  { data: TriggerJobRequest },
  TContext
> => {
  const mutationKey = ['maintenanceTrigger'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof maintenanceTrigger>>, { data: TriggerJobRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return maintenanceTrigger(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaintenanceTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof maintenanceTrigger>>>;
export type MaintenanceTriggerMutationBody = TriggerJobRequest;
export type MaintenanceTriggerMutationError = ProblemDetails;

/**
 * @summary Triggers any task by taskType with an arbitrary JSON payload.
 */
export const useMaintenanceTrigger = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceTrigger>>,
    TError,
    { data: TriggerJobRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof maintenanceTrigger>>,
  TError,
  { data: TriggerJobRequest },
  TContext
> => {
  const mutationOptions = getMaintenanceTriggerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const personaGenerateMagicPersonaPrompt = (
  generateMagicPersonaPromptCommand: GenerateMagicPersonaPromptCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/personas/GenerateMagicPersonaPrompt`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateMagicPersonaPromptCommand,
    signal
  });
};

export const getPersonaGenerateMagicPersonaPromptMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
    TError,
    { data: GenerateMagicPersonaPromptCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
  TError,
  { data: GenerateMagicPersonaPromptCommand },
  TContext
> => {
  const mutationKey = ['personaGenerateMagicPersonaPrompt'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
    { data: GenerateMagicPersonaPromptCommand }
  > = (props) => {
    const { data } = props ?? {};

    return personaGenerateMagicPersonaPrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaGenerateMagicPersonaPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>
>;
export type PersonaGenerateMagicPersonaPromptMutationBody = GenerateMagicPersonaPromptCommand;
export type PersonaGenerateMagicPersonaPromptMutationError = unknown;

export const usePersonaGenerateMagicPersonaPrompt = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
    TError,
    { data: GenerateMagicPersonaPromptCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
  TError,
  { data: GenerateMagicPersonaPromptCommand },
  TContext
> => {
  const mutationOptions = getPersonaGenerateMagicPersonaPromptMutationOptions(options);

  return useMutation(mutationOptions);
};

export const personaInitPersonaSession = (
  initPersonaSessionCommand: InitPersonaSessionCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PersonaSessionInitResult>({
    url: `/api/personas/InitPersonaSession`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: initPersonaSessionCommand,
    signal
  });
};

export const getPersonaInitPersonaSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaInitPersonaSession>>,
    TError,
    { data: InitPersonaSessionCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaInitPersonaSession>>,
  TError,
  { data: InitPersonaSessionCommand },
  TContext
> => {
  const mutationKey = ['personaInitPersonaSession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaInitPersonaSession>>,
    { data: InitPersonaSessionCommand }
  > = (props) => {
    const { data } = props ?? {};

    return personaInitPersonaSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaInitPersonaSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaInitPersonaSession>>
>;
export type PersonaInitPersonaSessionMutationBody = InitPersonaSessionCommand;
export type PersonaInitPersonaSessionMutationError = unknown;

export const usePersonaInitPersonaSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaInitPersonaSession>>,
    TError,
    { data: InitPersonaSessionCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaInitPersonaSession>>,
  TError,
  { data: InitPersonaSessionCommand },
  TContext
> => {
  const mutationOptions = getPersonaInitPersonaSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const personaRespondWithPersonaAudio = (
  respondWithPersonaAudioCommand: RespondWithPersonaAudioCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PersonaAudioResponse>({
    url: `/api/personas/RespondWithPersonaAudio`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: respondWithPersonaAudioCommand,
    signal
  });
};

export const getPersonaRespondWithPersonaAudioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
    TError,
    { data: RespondWithPersonaAudioCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
  TError,
  { data: RespondWithPersonaAudioCommand },
  TContext
> => {
  const mutationKey = ['personaRespondWithPersonaAudio'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
    { data: RespondWithPersonaAudioCommand }
  > = (props) => {
    const { data } = props ?? {};

    return personaRespondWithPersonaAudio(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaRespondWithPersonaAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>
>;
export type PersonaRespondWithPersonaAudioMutationBody = RespondWithPersonaAudioCommand;
export type PersonaRespondWithPersonaAudioMutationError = unknown;

export const usePersonaRespondWithPersonaAudio = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
    TError,
    { data: RespondWithPersonaAudioCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
  TError,
  { data: RespondWithPersonaAudioCommand },
  TContext
> => {
  const mutationOptions = getPersonaRespondWithPersonaAudioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const personaGeneratePersonaSentence = (
  generatePersonaSentenceRequestDto: GeneratePersonaSentenceRequestDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GeneratePersonaSentenceResponseDto>({
    url: `/api/personas/generate-sentence`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generatePersonaSentenceRequestDto,
    signal
  });
};

export const getPersonaGeneratePersonaSentenceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
    TError,
    { data: GeneratePersonaSentenceRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
  TError,
  { data: GeneratePersonaSentenceRequestDto },
  TContext
> => {
  const mutationKey = ['personaGeneratePersonaSentence'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
    { data: GeneratePersonaSentenceRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return personaGeneratePersonaSentence(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaGeneratePersonaSentenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaGeneratePersonaSentence>>
>;
export type PersonaGeneratePersonaSentenceMutationBody = GeneratePersonaSentenceRequestDto;
export type PersonaGeneratePersonaSentenceMutationError = unknown;

export const usePersonaGeneratePersonaSentence = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
    TError,
    { data: GeneratePersonaSentenceRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
  TError,
  { data: GeneratePersonaSentenceRequestDto },
  TContext
> => {
  const mutationOptions = getPersonaGeneratePersonaSentenceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Creates a new persona with the specified properties.
 */
export const personaCreatePersona = (createPersonaDto: CreatePersonaDto, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto | void>({
    url: `/api/personas`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPersonaDto,
    signal
  });
};

export const getPersonaCreatePersonaMutationOptions = <TError = void | void | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaCreatePersona>>,
    TError,
    { data: CreatePersonaDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaCreatePersona>>,
  TError,
  { data: CreatePersonaDto },
  TContext
> => {
  const mutationKey = ['personaCreatePersona'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof personaCreatePersona>>, { data: CreatePersonaDto }> = (
    props
  ) => {
    const { data } = props ?? {};

    return personaCreatePersona(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaCreatePersonaMutationResult = NonNullable<Awaited<ReturnType<typeof personaCreatePersona>>>;
export type PersonaCreatePersonaMutationBody = CreatePersonaDto;
export type PersonaCreatePersonaMutationError = void | void | void;

/**
 * @summary Creates a new persona with the specified properties.
 */
export const usePersonaCreatePersona = <TError = void | void | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaCreatePersona>>,
    TError,
    { data: CreatePersonaDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaCreatePersona>>,
  TError,
  { data: CreatePersonaDto },
  TContext
> => {
  const mutationOptions = getPersonaCreatePersonaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Retrieves all personas accessible to the current user's company.
 */
export const personaGetPersonas = (signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto[]>({ url: `/api/personas`, method: 'GET', signal });
};

export const getPersonaGetPersonasQueryKey = () => {
  return [`/api/personas`] as const;
};

export const getPersonaGetPersonasQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonas>>,
  TError = void | void
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonas>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonasQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonas>>> = ({ signal }) =>
    personaGetPersonas(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonasQueryResult = NonNullable<Awaited<ReturnType<typeof personaGetPersonas>>>;
export type PersonaGetPersonasQueryError = void | void;

/**
 * @summary Retrieves all personas accessible to the current user's company.
 */

export function usePersonaGetPersonas<
  TData = Awaited<ReturnType<typeof personaGetPersonas>>,
  TError = void | void
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonas>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonasQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Retrieves a specific persona by ID.
 */
export const personaGetPersona = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto>({ url: `/api/personas/${id}`, method: 'GET', signal });
};

export const getPersonaGetPersonaQueryKey = (id?: number) => {
  return [`/api/personas/${id}`] as const;
};

export const getPersonaGetPersonaQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersona>>,
  TError = void | void | void
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersona>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersona>>> = ({ signal }) =>
    personaGetPersona(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersona>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonaQueryResult = NonNullable<Awaited<ReturnType<typeof personaGetPersona>>>;
export type PersonaGetPersonaQueryError = void | void | void;

/**
 * @summary Retrieves a specific persona by ID.
 */

export function usePersonaGetPersona<
  TData = Awaited<ReturnType<typeof personaGetPersona>>,
  TError = void | void | void
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersona>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonaQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates an existing persona with the specified properties.
 */
export const personaUpdatePersona = (id: number, updatePersonaDto: UpdatePersonaDto) => {
  return customAxiosInstance<PersonaDto>({
    url: `/api/personas/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePersonaDto
  });
};

export const getPersonaUpdatePersonaMutationOptions = <
  TError = void | void | void | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersona>>,
    TError,
    { id: number; data: UpdatePersonaDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaUpdatePersona>>,
  TError,
  { id: number; data: UpdatePersonaDto },
  TContext
> => {
  const mutationKey = ['personaUpdatePersona'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaUpdatePersona>>,
    { id: number; data: UpdatePersonaDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return personaUpdatePersona(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaUpdatePersonaMutationResult = NonNullable<Awaited<ReturnType<typeof personaUpdatePersona>>>;
export type PersonaUpdatePersonaMutationBody = UpdatePersonaDto;
export type PersonaUpdatePersonaMutationError = void | void | void | void;

/**
 * @summary Updates an existing persona with the specified properties.
 */
export const usePersonaUpdatePersona = <TError = void | void | void | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersona>>,
    TError,
    { id: number; data: UpdatePersonaDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaUpdatePersona>>,
  TError,
  { id: number; data: UpdatePersonaDto },
  TContext
> => {
  const mutationOptions = getPersonaUpdatePersonaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Deletes a persona by ID. Performs validation before deletion.
 */
export const personaDeletePersona = (id: number) => {
  return customAxiosInstance<void | void>({ url: `/api/personas/${id}`, method: 'DELETE' });
};

export const getPersonaDeletePersonaMutationOptions = <
  TError = void | void | void | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof personaDeletePersona>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof personaDeletePersona>>, TError, { id: number }, TContext> => {
  const mutationKey = ['personaDeletePersona'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof personaDeletePersona>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return personaDeletePersona(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaDeletePersonaMutationResult = NonNullable<Awaited<ReturnType<typeof personaDeletePersona>>>;

export type PersonaDeletePersonaMutationError = void | void | void | void;

/**
 * @summary Deletes a persona by ID. Performs validation before deletion.
 */
export const usePersonaDeletePersona = <TError = void | void | void | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof personaDeletePersona>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof personaDeletePersona>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPersonaDeletePersonaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Shares a persona with additional companies and their access levels.
 */
export const personaSharePersonaWithCompanies = (
  id: number,
  personaCompanyAccessDto: PersonaCompanyAccessDto[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/personas/${id}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: personaCompanyAccessDto,
    signal
  });
};

export const getPersonaSharePersonaWithCompaniesMutationOptions = <
  TError = void | void | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
    TError,
    { id: number; data: PersonaCompanyAccessDto[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
  TError,
  { id: number; data: PersonaCompanyAccessDto[] },
  TContext
> => {
  const mutationKey = ['personaSharePersonaWithCompanies'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
    { id: number; data: PersonaCompanyAccessDto[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return personaSharePersonaWithCompanies(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaSharePersonaWithCompaniesMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>
>;
export type PersonaSharePersonaWithCompaniesMutationBody = PersonaCompanyAccessDto[];
export type PersonaSharePersonaWithCompaniesMutationError = void | void | void;

/**
 * @summary Shares a persona with additional companies and their access levels.
 */
export const usePersonaSharePersonaWithCompanies = <TError = void | void | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
    TError,
    { id: number; data: PersonaCompanyAccessDto[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
  TError,
  { id: number; data: PersonaCompanyAccessDto[] },
  TContext
> => {
  const mutationOptions = getPersonaSharePersonaWithCompaniesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const personaUnsharePersonaFromCompanies = (
  id: number,
  personaUnsharePersonaFromCompaniesBody: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/personas/${id}/unshare`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: personaUnsharePersonaFromCompaniesBody,
    signal
  });
};

export const getPersonaUnsharePersonaFromCompaniesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
    TError,
    { id: number; data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
  TError,
  { id: number; data: number[] },
  TContext
> => {
  const mutationKey = ['personaUnsharePersonaFromCompanies'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
    { id: number; data: number[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return personaUnsharePersonaFromCompanies(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaUnsharePersonaFromCompaniesMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>
>;
export type PersonaUnsharePersonaFromCompaniesMutationBody = number[];
export type PersonaUnsharePersonaFromCompaniesMutationError = unknown;

export const usePersonaUnsharePersonaFromCompanies = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
    TError,
    { id: number; data: number[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
  TError,
  { id: number; data: number[] },
  TContext
> => {
  const mutationOptions = getPersonaUnsharePersonaFromCompaniesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const personaGetPersonaCompanies = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaCompanyDto[]>({ url: `/api/personas/${id}/companies`, method: 'GET', signal });
};

export const getPersonaGetPersonaCompaniesQueryKey = (id?: number) => {
  return [`/api/personas/${id}/companies`] as const;
};

export const getPersonaGetPersonaCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonaCompanies>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaCompanies>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonaCompaniesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonaCompanies>>> = ({ signal }) =>
    personaGetPersonaCompanies(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonaCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonaCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof personaGetPersonaCompanies>>>;
export type PersonaGetPersonaCompaniesQueryError = unknown;

export function usePersonaGetPersonaCompanies<
  TData = Awaited<ReturnType<typeof personaGetPersonaCompanies>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaCompanies>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonaCompaniesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const personaUpdatePersonaCompanyAccess = (personaId: number, companyId: number, accessLevel: AccessLevel) => {
  return customAxiosInstance<void>({
    url: `/api/personas/${personaId}/companies/${companyId}/access`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: accessLevel
  });
};

export const getPersonaUpdatePersonaCompanyAccessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
    TError,
    { personaId: number; companyId: number; data: AccessLevel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
  TError,
  { personaId: number; companyId: number; data: AccessLevel },
  TContext
> => {
  const mutationKey = ['personaUpdatePersonaCompanyAccess'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
    { personaId: number; companyId: number; data: AccessLevel }
  > = (props) => {
    const { personaId, companyId, data } = props ?? {};

    return personaUpdatePersonaCompanyAccess(personaId, companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaUpdatePersonaCompanyAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>
>;
export type PersonaUpdatePersonaCompanyAccessMutationBody = AccessLevel;
export type PersonaUpdatePersonaCompanyAccessMutationError = unknown;

export const usePersonaUpdatePersonaCompanyAccess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
    TError,
    { personaId: number; companyId: number; data: AccessLevel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
  TError,
  { personaId: number; companyId: number; data: AccessLevel },
  TContext
> => {
  const mutationOptions = getPersonaUpdatePersonaCompanyAccessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Retrieves all personas accessible to a specific company.
 */
export const personaGetPersonasByCompany = (companyId: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto[]>({ url: `/api/personas/by-company/${companyId}`, method: 'GET', signal });
};

export const getPersonaGetPersonasByCompanyQueryKey = (companyId?: number) => {
  return [`/api/personas/by-company/${companyId}`] as const;
};

export const getPersonaGetPersonasByCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonasByCompany>>,
  TError = void | void
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonasByCompany>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonasByCompanyQueryKey(companyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonasByCompany>>> = ({ signal }) =>
    personaGetPersonasByCompany(companyId, signal);

  return { queryKey, queryFn, enabled: !!companyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonasByCompany>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonasByCompanyQueryResult = NonNullable<
  Awaited<ReturnType<typeof personaGetPersonasByCompany>>
>;
export type PersonaGetPersonasByCompanyQueryError = void | void;

/**
 * @summary Retrieves all personas accessible to a specific company.
 */

export function usePersonaGetPersonasByCompany<
  TData = Awaited<ReturnType<typeof personaGetPersonasByCompany>>,
  TError = void | void
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonasByCompany>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonasByCompanyQueryOptions(companyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns whether the persona can be deleted and why/why not, plus list of scenarios referencing it.
 */
export const personaGetPersonaDeletionValidation = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDeletionValidationDto>({
    url: `/api/personas/${id}/deletion-validation`,
    method: 'GET',
    signal
  });
};

export const getPersonaGetPersonaDeletionValidationQueryKey = (id?: number) => {
  return [`/api/personas/${id}/deletion-validation`] as const;
};

export const getPersonaGetPersonaDeletionValidationQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>,
  TError = void | void | void
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonaDeletionValidationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>> = ({ signal }) =>
    personaGetPersonaDeletionValidation(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonaDeletionValidationQueryResult = NonNullable<
  Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>
>;
export type PersonaGetPersonaDeletionValidationQueryError = void | void | void;

/**
 * @summary Returns whether the persona can be deleted and why/why not, plus list of scenarios referencing it.
 */

export function usePersonaGetPersonaDeletionValidation<
  TData = Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>,
  TError = void | void | void
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonaDeletionValidationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const processProcessDialog = (processDialogCommand: ProcessDialogCommand, signal?: AbortSignal) => {
  return customAxiosInstance<ProcessResultDto>({
    url: `/api/Process/ProcessDialog`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processDialogCommand,
    signal
  });
};

export const getProcessProcessDialogMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessDialog>>,
    TError,
    { data: ProcessDialogCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processProcessDialog>>,
  TError,
  { data: ProcessDialogCommand },
  TContext
> => {
  const mutationKey = ['processProcessDialog'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processProcessDialog>>,
    { data: ProcessDialogCommand }
  > = (props) => {
    const { data } = props ?? {};

    return processProcessDialog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessProcessDialogMutationResult = NonNullable<Awaited<ReturnType<typeof processProcessDialog>>>;
export type ProcessProcessDialogMutationBody = ProcessDialogCommand;
export type ProcessProcessDialogMutationError = unknown;

export const useProcessProcessDialog = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessDialog>>,
    TError,
    { data: ProcessDialogCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processProcessDialog>>,
  TError,
  { data: ProcessDialogCommand },
  TContext
> => {
  const mutationOptions = getProcessProcessDialogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const processRespondToUser = (processDialogCommand: ProcessDialogCommand, signal?: AbortSignal) => {
  return customAxiosInstance<AudioResponseDto>({
    url: `/api/Process/RespondToUser`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processDialogCommand,
    signal
  });
};

export const getProcessRespondToUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processRespondToUser>>,
    TError,
    { data: ProcessDialogCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processRespondToUser>>,
  TError,
  { data: ProcessDialogCommand },
  TContext
> => {
  const mutationKey = ['processRespondToUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processRespondToUser>>,
    { data: ProcessDialogCommand }
  > = (props) => {
    const { data } = props ?? {};

    return processRespondToUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessRespondToUserMutationResult = NonNullable<Awaited<ReturnType<typeof processRespondToUser>>>;
export type ProcessRespondToUserMutationBody = ProcessDialogCommand;
export type ProcessRespondToUserMutationError = unknown;

export const useProcessRespondToUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processRespondToUser>>,
    TError,
    { data: ProcessDialogCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processRespondToUser>>,
  TError,
  { data: ProcessDialogCommand },
  TContext
> => {
  const mutationOptions = getProcessRespondToUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const processProcessCall = (textToSpeechCommand: TextToSpeechCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Process/ProcessCall`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: textToSpeechCommand,
    signal
  });
};

export const getProcessProcessCallMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessCall>>,
    TError,
    { data: TextToSpeechCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processProcessCall>>,
  TError,
  { data: TextToSpeechCommand },
  TContext
> => {
  const mutationKey = ['processProcessCall'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof processProcessCall>>, { data: TextToSpeechCommand }> = (
    props
  ) => {
    const { data } = props ?? {};

    return processProcessCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessProcessCallMutationResult = NonNullable<Awaited<ReturnType<typeof processProcessCall>>>;
export type ProcessProcessCallMutationBody = TextToSpeechCommand;
export type ProcessProcessCallMutationError = unknown;

export const useProcessProcessCall = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessCall>>,
    TError,
    { data: TextToSpeechCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processProcessCall>>,
  TError,
  { data: TextToSpeechCommand },
  TContext
> => {
  const mutationOptions = getProcessProcessCallMutationOptions(options);

  return useMutation(mutationOptions);
};

export const processEndCall = (endCallCommand: EndCallCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Process/EndCall`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: endCallCommand,
    signal
  });
};

export const getProcessEndCallMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof processEndCall>>, TError, { data: EndCallCommand }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof processEndCall>>, TError, { data: EndCallCommand }, TContext> => {
  const mutationKey = ['processEndCall'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof processEndCall>>, { data: EndCallCommand }> = (
    props
  ) => {
    const { data } = props ?? {};

    return processEndCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessEndCallMutationResult = NonNullable<Awaited<ReturnType<typeof processEndCall>>>;
export type ProcessEndCallMutationBody = EndCallCommand;
export type ProcessEndCallMutationError = unknown;

export const useProcessEndCall = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof processEndCall>>, TError, { data: EndCallCommand }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof processEndCall>>, TError, { data: EndCallCommand }, TContext> => {
  const mutationOptions = getProcessEndCallMutationOptions(options);

  return useMutation(mutationOptions);
};

export const processStartInboundCall = (
  processStartInboundCallBody: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Process/StartInboundCall`,
    method: 'POST',
    data: processStartInboundCallBody,
    signal
  });
};

export const getProcessStartInboundCallMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStartInboundCall>>,
    TError,
    { data: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processStartInboundCall>>,
  TError,
  { data: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo },
  TContext
> => {
  const mutationKey = ['processStartInboundCall'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStartInboundCall>>,
    { data: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo }
  > = (props) => {
    const { data } = props ?? {};

    return processStartInboundCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessStartInboundCallMutationResult = NonNullable<Awaited<ReturnType<typeof processStartInboundCall>>>;
export type ProcessStartInboundCallMutationBody = ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo;
export type ProcessStartInboundCallMutationError = unknown;

export const useProcessStartInboundCall = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStartInboundCall>>,
    TError,
    { data: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processStartInboundCall>>,
  TError,
  { data: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo },
  TContext
> => {
  const mutationOptions = getProcessStartInboundCallMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesGenerateMagicRolePrompt = (
  generateMagicRolePromptCommand: GenerateMagicRolePromptCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/Roles/GenerateMagicRolePrompt`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateMagicRolePromptCommand,
    signal
  });
};

export const getRolesGenerateMagicRolePromptMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
    TError,
    { data: GenerateMagicRolePromptCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
  TError,
  { data: GenerateMagicRolePromptCommand },
  TContext
> => {
  const mutationKey = ['rolesGenerateMagicRolePrompt'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
    { data: GenerateMagicRolePromptCommand }
  > = (props) => {
    const { data } = props ?? {};

    return rolesGenerateMagicRolePrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesGenerateMagicRolePromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>
>;
export type RolesGenerateMagicRolePromptMutationBody = GenerateMagicRolePromptCommand;
export type RolesGenerateMagicRolePromptMutationError = unknown;

export const useRolesGenerateMagicRolePrompt = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
    TError,
    { data: GenerateMagicRolePromptCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
  TError,
  { data: GenerateMagicRolePromptCommand },
  TContext
> => {
  const mutationOptions = getRolesGenerateMagicRolePromptMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesGetRoles = (params?: RolesGetRolesParams, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto[]>({ url: `/api/Roles`, method: 'GET', params, signal });
};

export const getRolesGetRolesQueryKey = (params?: RolesGetRolesParams) => {
  return [`/api/Roles`, ...(params ? [params] : [])] as const;
};

export const getRolesGetRolesQueryOptions = <TData = Awaited<ReturnType<typeof rolesGetRoles>>, TError = unknown>(
  params?: RolesGetRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoles>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRolesGetRolesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesGetRoles>>> = ({ signal }) =>
    rolesGetRoles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rolesGetRoles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RolesGetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof rolesGetRoles>>>;
export type RolesGetRolesQueryError = unknown;

export function useRolesGetRoles<TData = Awaited<ReturnType<typeof rolesGetRoles>>, TError = unknown>(
  params?: RolesGetRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoles>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRolesGetRolesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rolesCreateRole = (createRoleDto: CreateRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createRoleDto,
    signal
  });
};

export const getRolesCreateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof rolesCreateRole>>, TError, { data: CreateRoleDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof rolesCreateRole>>, TError, { data: CreateRoleDto }, TContext> => {
  const mutationKey = ['rolesCreateRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesCreateRole>>, { data: CreateRoleDto }> = (
    props
  ) => {
    const { data } = props ?? {};

    return rolesCreateRole(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesCreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesCreateRole>>>;
export type RolesCreateRoleMutationBody = CreateRoleDto;
export type RolesCreateRoleMutationError = unknown;

export const useRolesCreateRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof rolesCreateRole>>, TError, { data: CreateRoleDto }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof rolesCreateRole>>, TError, { data: CreateRoleDto }, TContext> => {
  const mutationOptions = getRolesCreateRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesGetRoleCompanies = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<RoleCompanyDto[]>({ url: `/api/Roles/${id}/companies`, method: 'GET', signal });
};

export const getRolesGetRoleCompaniesQueryKey = (id?: number) => {
  return [`/api/Roles/${id}/companies`] as const;
};

export const getRolesGetRoleCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof rolesGetRoleCompanies>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoleCompanies>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRolesGetRoleCompaniesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesGetRoleCompanies>>> = ({ signal }) =>
    rolesGetRoleCompanies(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rolesGetRoleCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RolesGetRoleCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof rolesGetRoleCompanies>>>;
export type RolesGetRoleCompaniesQueryError = unknown;

export function useRolesGetRoleCompanies<TData = Awaited<ReturnType<typeof rolesGetRoleCompanies>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoleCompanies>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRolesGetRoleCompaniesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rolesUpdateRole = (id: number, updateRoleDto: UpdateRoleDto) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateRoleDto
  });
};

export const getRolesUpdateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRole>>,
    TError,
    { id: number; data: UpdateRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesUpdateRole>>,
  TError,
  { id: number; data: UpdateRoleDto },
  TContext
> => {
  const mutationKey = ['rolesUpdateRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesUpdateRole>>,
    { id: number; data: UpdateRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return rolesUpdateRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesUpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesUpdateRole>>>;
export type RolesUpdateRoleMutationBody = UpdateRoleDto;
export type RolesUpdateRoleMutationError = unknown;

export const useRolesUpdateRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRole>>,
    TError,
    { id: number; data: UpdateRoleDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesUpdateRole>>,
  TError,
  { id: number; data: UpdateRoleDto },
  TContext
> => {
  const mutationOptions = getRolesUpdateRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesDeleteRole = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/Roles/${id}`, method: 'DELETE' });
};

export const getRolesDeleteRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof rolesDeleteRole>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof rolesDeleteRole>>, TError, { id: number }, TContext> => {
  const mutationKey = ['rolesDeleteRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesDeleteRole>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return rolesDeleteRole(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesDeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesDeleteRole>>>;

export type RolesDeleteRoleMutationError = unknown;

export const useRolesDeleteRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof rolesDeleteRole>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof rolesDeleteRole>>, TError, { id: number }, TContext> => {
  const mutationOptions = getRolesDeleteRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesShareRole = (id: number, shareRoleDto: ShareRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles/${id}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shareRoleDto,
    signal
  });
};

export const getRolesShareRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesShareRole>>,
    TError,
    { id: number; data: ShareRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesShareRole>>,
  TError,
  { id: number; data: ShareRoleDto },
  TContext
> => {
  const mutationKey = ['rolesShareRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesShareRole>>, { id: number; data: ShareRoleDto }> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return rolesShareRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesShareRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesShareRole>>>;
export type RolesShareRoleMutationBody = ShareRoleDto;
export type RolesShareRoleMutationError = unknown;

export const useRolesShareRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesShareRole>>,
    TError,
    { id: number; data: ShareRoleDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesShareRole>>,
  TError,
  { id: number; data: ShareRoleDto },
  TContext
> => {
  const mutationOptions = getRolesShareRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesUnshareRole = (id: number, unshareRoleDto: UnshareRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles/${id}/unshare`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unshareRoleDto,
    signal
  });
};

export const getRolesUnshareRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUnshareRole>>,
    TError,
    { id: number; data: UnshareRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesUnshareRole>>,
  TError,
  { id: number; data: UnshareRoleDto },
  TContext
> => {
  const mutationKey = ['rolesUnshareRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesUnshareRole>>,
    { id: number; data: UnshareRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return rolesUnshareRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesUnshareRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesUnshareRole>>>;
export type RolesUnshareRoleMutationBody = UnshareRoleDto;
export type RolesUnshareRoleMutationError = unknown;

export const useRolesUnshareRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUnshareRole>>,
    TError,
    { id: number; data: UnshareRoleDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesUnshareRole>>,
  TError,
  { id: number; data: UnshareRoleDto },
  TContext
> => {
  const mutationOptions = getRolesUnshareRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rolesUpdateRoleCompanyAccess = (id: number, companyId: number, accessLevel: AccessLevel) => {
  return customAxiosInstance<RoleCompanyDto>({
    url: `/api/Roles/${id}/companies/${companyId}/access`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: accessLevel
  });
};

export const getRolesUpdateRoleCompanyAccessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
    TError,
    { id: number; companyId: number; data: AccessLevel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
  TError,
  { id: number; companyId: number; data: AccessLevel },
  TContext
> => {
  const mutationKey = ['rolesUpdateRoleCompanyAccess'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
    { id: number; companyId: number; data: AccessLevel }
  > = (props) => {
    const { id, companyId, data } = props ?? {};

    return rolesUpdateRoleCompanyAccess(id, companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesUpdateRoleCompanyAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>
>;
export type RolesUpdateRoleCompanyAccessMutationBody = AccessLevel;
export type RolesUpdateRoleCompanyAccessMutationError = unknown;

export const useRolesUpdateRoleCompanyAccess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
    TError,
    { id: number; companyId: number; data: AccessLevel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
  TError,
  { id: number; companyId: number; data: AccessLevel },
  TContext
> => {
  const mutationOptions = getRolesUpdateRoleCompanyAccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenarioGroupGetScenarioGroups = (signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioGroupDto[]>({ url: `/api/Scene/GetScenarioGroups/groups`, method: 'GET', signal });
};

export const getScenarioGroupGetScenarioGroupsQueryKey = () => {
  return [`/api/Scene/GetScenarioGroups/groups`] as const;
};

export const getScenarioGroupGetScenarioGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenarioGroupGetScenarioGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>> = ({ signal }) =>
    scenarioGroupGetScenarioGroups(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenarioGroupGetScenarioGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>
>;
export type ScenarioGroupGetScenarioGroupsQueryError = unknown;

export function useScenarioGroupGetScenarioGroups<
  TData = Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenarioGroupGetScenarioGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenarioGroupCreateGroup = (
  scenarioGroupCreateGroupBody: string,
  params?: ScenarioGroupCreateGroupParams
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/CreateGroup/groups`,
    method: 'PUT',
    headers: { 'Content-Type': 'text/plain' },
    data: scenarioGroupCreateGroupBody,
    params
  });
};

export const getScenarioGroupCreateGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
    TError,
    { data: string; params?: ScenarioGroupCreateGroupParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
  TError,
  { data: string; params?: ScenarioGroupCreateGroupParams },
  TContext
> => {
  const mutationKey = ['scenarioGroupCreateGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
    { data: string; params?: ScenarioGroupCreateGroupParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return scenarioGroupCreateGroup(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupCreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof scenarioGroupCreateGroup>>>;
export type ScenarioGroupCreateGroupMutationBody = string;
export type ScenarioGroupCreateGroupMutationError = unknown;

export const useScenarioGroupCreateGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
    TError,
    { data: string; params?: ScenarioGroupCreateGroupParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
  TError,
  { data: string; params?: ScenarioGroupCreateGroupParams },
  TContext
> => {
  const mutationOptions = getScenarioGroupCreateGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenarioGroupAddScenarioToGroup = (
  groupId: number,
  params?: ScenarioGroupAddScenarioToGroupParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/AddScenarioToGroup/groups/${groupId}`,
    method: 'POST',
    params,
    signal
  });
};

export const getScenarioGroupAddScenarioToGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
    TError,
    { groupId: number; params?: ScenarioGroupAddScenarioToGroupParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
  TError,
  { groupId: number; params?: ScenarioGroupAddScenarioToGroupParams },
  TContext
> => {
  const mutationKey = ['scenarioGroupAddScenarioToGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
    { groupId: number; params?: ScenarioGroupAddScenarioToGroupParams }
  > = (props) => {
    const { groupId, params } = props ?? {};

    return scenarioGroupAddScenarioToGroup(groupId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupAddScenarioToGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>
>;

export type ScenarioGroupAddScenarioToGroupMutationError = unknown;

export const useScenarioGroupAddScenarioToGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
    TError,
    { groupId: number; params?: ScenarioGroupAddScenarioToGroupParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
  TError,
  { groupId: number; params?: ScenarioGroupAddScenarioToGroupParams },
  TContext
> => {
  const mutationOptions = getScenarioGroupAddScenarioToGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenarioGroupDeleteGroup = (groupId: number) => {
  return customAxiosInstance<void>({ url: `/api/Scene/DeleteGroup/groups/${groupId}`, method: 'DELETE' });
};

export const getScenarioGroupDeleteGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
    TError,
    { groupId: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>, TError, { groupId: number }, TContext> => {
  const mutationKey = ['scenarioGroupDeleteGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>, { groupId: number }> = (
    props
  ) => {
    const { groupId } = props ?? {};

    return scenarioGroupDeleteGroup(groupId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupDeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>>;

export type ScenarioGroupDeleteGroupMutationError = unknown;

export const useScenarioGroupDeleteGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
    TError,
    { groupId: number },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>, TError, { groupId: number }, TContext> => {
  const mutationOptions = getScenarioGroupDeleteGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenarioGroupUpdateGroup = (groupId: number, updateScenarioGroupCommand: UpdateScenarioGroupCommand) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/UpdateGroup/groups/${groupId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScenarioGroupCommand
  });
};

export const getScenarioGroupUpdateGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
    TError,
    { groupId: number; data: UpdateScenarioGroupCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
  TError,
  { groupId: number; data: UpdateScenarioGroupCommand },
  TContext
> => {
  const mutationKey = ['scenarioGroupUpdateGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
    { groupId: number; data: UpdateScenarioGroupCommand }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return scenarioGroupUpdateGroup(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupUpdateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>>;
export type ScenarioGroupUpdateGroupMutationBody = UpdateScenarioGroupCommand;
export type ScenarioGroupUpdateGroupMutationError = unknown;

export const useScenarioGroupUpdateGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
    TError,
    { groupId: number; data: UpdateScenarioGroupCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
  TError,
  { groupId: number; data: UpdateScenarioGroupCommand },
  TContext
> => {
  const mutationOptions = getScenarioGroupUpdateGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenarioGroupRemoveScenesFromGroup = (
  groupId: number,
  params?: ScenarioGroupRemoveScenesFromGroupParams
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/RemoveScenesFromGroup/groups/${groupId}/scenes`,
    method: 'DELETE',
    params
  });
};

export const getScenarioGroupRemoveScenesFromGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
    TError,
    { groupId: number; params?: ScenarioGroupRemoveScenesFromGroupParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
  TError,
  { groupId: number; params?: ScenarioGroupRemoveScenesFromGroupParams },
  TContext
> => {
  const mutationKey = ['scenarioGroupRemoveScenesFromGroup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
    { groupId: number; params?: ScenarioGroupRemoveScenesFromGroupParams }
  > = (props) => {
    const { groupId, params } = props ?? {};

    return scenarioGroupRemoveScenesFromGroup(groupId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupRemoveScenesFromGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>
>;

export type ScenarioGroupRemoveScenesFromGroupMutationError = unknown;

export const useScenarioGroupRemoveScenesFromGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
    TError,
    { groupId: number; params?: ScenarioGroupRemoveScenesFromGroupParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
  TError,
  { groupId: number; params?: ScenarioGroupRemoveScenesFromGroupParams },
  TContext
> => {
  const mutationOptions = getScenarioGroupRemoveScenesFromGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosFilterScenarios = (signal?: AbortSignal) => {
  return customAxiosInstance<SimpleScenarioDto[]>({ url: `/api/Scenarios/FilterScenarios`, method: 'GET', signal });
};

export const getScenariosFilterScenariosQueryKey = () => {
  return [`/api/Scenarios/FilterScenarios`] as const;
};

export const getScenariosFilterScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosFilterScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosFilterScenarios>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosFilterScenariosQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosFilterScenarios>>> = ({ signal }) =>
    scenariosFilterScenarios(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosFilterScenarios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosFilterScenariosQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosFilterScenarios>>>;
export type ScenariosFilterScenariosQueryError = unknown;

export function useScenariosFilterScenarios<
  TData = Awaited<ReturnType<typeof scenariosFilterScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosFilterScenarios>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosFilterScenariosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosAddScenario = (addScenarioCommand: AddScenarioCommand, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/AddScenario`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addScenarioCommand,
    signal
  });
};

export const getScenariosAddScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddScenario>>,
    TError,
    { data: AddScenarioCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosAddScenario>>,
  TError,
  { data: AddScenarioCommand },
  TContext
> => {
  const mutationKey = ['scenariosAddScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof scenariosAddScenario>>, { data: AddScenarioCommand }> = (
    props
  ) => {
    const { data } = props ?? {};

    return scenariosAddScenario(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosAddScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof scenariosAddScenario>>>;
export type ScenariosAddScenarioMutationBody = AddScenarioCommand;
export type ScenariosAddScenarioMutationError = unknown;

export const useScenariosAddScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddScenario>>,
    TError,
    { data: AddScenarioCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosAddScenario>>,
  TError,
  { data: AddScenarioCommand },
  TContext
> => {
  const mutationOptions = getScenariosAddScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosEditScenarioContent = (updateScenarioContentCommand: UpdateScenarioContentCommand) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/EditScenarioContent/editContent`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScenarioContentCommand
  });
};

export const getScenariosEditScenarioContentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
    TError,
    { data: UpdateScenarioContentCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
  TError,
  { data: UpdateScenarioContentCommand },
  TContext
> => {
  const mutationKey = ['scenariosEditScenarioContent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
    { data: UpdateScenarioContentCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scenariosEditScenarioContent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosEditScenarioContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosEditScenarioContent>>
>;
export type ScenariosEditScenarioContentMutationBody = UpdateScenarioContentCommand;
export type ScenariosEditScenarioContentMutationError = unknown;

export const useScenariosEditScenarioContent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
    TError,
    { data: UpdateScenarioContentCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
  TError,
  { data: UpdateScenarioContentCommand },
  TContext
> => {
  const mutationOptions = getScenariosEditScenarioContentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosEditScenarioInfo = (updateScenarioSettingsCommand: UpdateScenarioSettingsCommand) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/EditScenarioInfo/info`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScenarioSettingsCommand
  });
};

export const getScenariosEditScenarioInfoMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
    TError,
    { data: UpdateScenarioSettingsCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
  TError,
  { data: UpdateScenarioSettingsCommand },
  TContext
> => {
  const mutationKey = ['scenariosEditScenarioInfo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
    { data: UpdateScenarioSettingsCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scenariosEditScenarioInfo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosEditScenarioInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosEditScenarioInfo>>
>;
export type ScenariosEditScenarioInfoMutationBody = UpdateScenarioSettingsCommand;
export type ScenariosEditScenarioInfoMutationError = unknown;

export const useScenariosEditScenarioInfo = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
    TError,
    { data: UpdateScenarioSettingsCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
  TError,
  { data: UpdateScenarioSettingsCommand },
  TContext
> => {
  const mutationOptions = getScenariosEditScenarioInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosRestoreScenarioVersion = (
  restoreScenarioVersionCommand: RestoreScenarioVersionCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/RestoreScenarioVersion/restoreScenario`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: restoreScenarioVersionCommand,
    signal
  });
};

export const getScenariosRestoreScenarioVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
    TError,
    { data: RestoreScenarioVersionCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
  TError,
  { data: RestoreScenarioVersionCommand },
  TContext
> => {
  const mutationKey = ['scenariosRestoreScenarioVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
    { data: RestoreScenarioVersionCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scenariosRestoreScenarioVersion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRestoreScenarioVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>
>;
export type ScenariosRestoreScenarioVersionMutationBody = RestoreScenarioVersionCommand;
export type ScenariosRestoreScenarioVersionMutationError = unknown;

export const useScenariosRestoreScenarioVersion = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
    TError,
    { data: RestoreScenarioVersionCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
  TError,
  { data: RestoreScenarioVersionCommand },
  TContext
> => {
  const mutationOptions = getScenariosRestoreScenarioVersionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosRemoveScenario = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/Scenarios/RemoveScenario/${id}`, method: 'DELETE' });
};

export const getScenariosRemoveScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof scenariosRemoveScenario>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof scenariosRemoveScenario>>, TError, { id: number }, TContext> => {
  const mutationKey = ['scenariosRemoveScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof scenariosRemoveScenario>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return scenariosRemoveScenario(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRemoveScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof scenariosRemoveScenario>>>;

export type ScenariosRemoveScenarioMutationError = unknown;

export const useScenariosRemoveScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof scenariosRemoveScenario>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof scenariosRemoveScenario>>, TError, { id: number }, TContext> => {
  const mutationOptions = getScenariosRemoveScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosGetScenario = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto>({ url: `/api/Scenarios/GetScenario/${id}`, method: 'GET', signal });
};

export const getScenariosGetScenarioQueryKey = (id?: number) => {
  return [`/api/Scenarios/GetScenario/${id}`] as const;
};

export const getScenariosGetScenarioQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenario>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenario>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenario>>> = ({ signal }) =>
    scenariosGetScenario(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenario>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenarioQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosGetScenario>>>;
export type ScenariosGetScenarioQueryError = unknown;

export function useScenariosGetScenario<TData = Awaited<ReturnType<typeof scenariosGetScenario>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenario>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetMissingPersonaCompanyAccess = (
  scenarioId: number,
  personaId: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PersonaCompanyAccessInfoDto>({
    url: `/api/Scenarios/GetMissingPersonaCompanyAccess/${scenarioId}/personas/${personaId}/missing-companies`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetMissingPersonaCompanyAccessQueryKey = (scenarioId?: number, personaId?: number) => {
  return [
    `/api/Scenarios/GetMissingPersonaCompanyAccess/${scenarioId}/personas/${personaId}/missing-companies`
  ] as const;
};

export const getScenariosGetMissingPersonaCompanyAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>,
  TError = unknown
>(
  scenarioId: number,
  personaId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetMissingPersonaCompanyAccessQueryKey(scenarioId, personaId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>> = ({ signal }) =>
    scenariosGetMissingPersonaCompanyAccess(scenarioId, personaId, signal);

  return { queryKey, queryFn, enabled: !!(scenarioId && personaId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetMissingPersonaCompanyAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>
>;
export type ScenariosGetMissingPersonaCompanyAccessQueryError = unknown;

export function useScenariosGetMissingPersonaCompanyAccess<
  TData = Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>,
  TError = unknown
>(
  scenarioId: number,
  personaId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetMissingPersonaCompanyAccessQueryOptions(scenarioId, personaId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetScenarioVersion = (scenarioId: number, versionId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/GetScenarioVersion/${scenarioId}/${versionId}`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetScenarioVersionQueryKey = (scenarioId?: number, versionId?: number) => {
  return [`/api/Scenarios/GetScenarioVersion/${scenarioId}/${versionId}`] as const;
};

export const getScenariosGetScenarioVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioVersionQueryKey(scenarioId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>> = ({ signal }) =>
    scenariosGetScenarioVersion(scenarioId, versionId, signal);

  return { queryKey, queryFn, enabled: !!(scenarioId && versionId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenarioVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenarioVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetScenarioVersion>>
>;
export type ScenariosGetScenarioVersionQueryError = unknown;

export function useScenariosGetScenarioVersion<
  TData = Awaited<ReturnType<typeof scenariosGetScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioVersionQueryOptions(scenarioId, versionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetDialogStatisticScenarioVersion = (
  scenarioId: number,
  versionId: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDialogStatisticDto>({
    url: `/api/Scenarios/GetDialogStatisticScenarioVersion/${scenarioId}/${versionId}/dialogStatistic`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetDialogStatisticScenarioVersionQueryKey = (scenarioId?: number, versionId?: number) => {
  return [`/api/Scenarios/GetDialogStatisticScenarioVersion/${scenarioId}/${versionId}/dialogStatistic`] as const;
};

export const getScenariosGetDialogStatisticScenarioVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getScenariosGetDialogStatisticScenarioVersionQueryKey(scenarioId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>> = ({ signal }) =>
    scenariosGetDialogStatisticScenarioVersion(scenarioId, versionId, signal);

  return { queryKey, queryFn, enabled: !!(scenarioId && versionId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetDialogStatisticScenarioVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>
>;
export type ScenariosGetDialogStatisticScenarioVersionQueryError = unknown;

export function useScenariosGetDialogStatisticScenarioVersion<
  TData = Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetDialogStatisticScenarioVersionQueryOptions(scenarioId, versionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetScenarioUpdates = (scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioUpdateDto[]>({
    url: `/api/Scenarios/GetScenarioUpdates/updates/${scenarioId}`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetScenarioUpdatesQueryKey = (scenarioId?: number) => {
  return [`/api/Scenarios/GetScenarioUpdates/updates/${scenarioId}`] as const;
};

export const getScenariosGetScenarioUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>,
  TError = unknown
>(
  scenarioId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioUpdatesQueryKey(scenarioId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>> = ({ signal }) =>
    scenariosGetScenarioUpdates(scenarioId, signal);

  return { queryKey, queryFn, enabled: !!scenarioId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenarioUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>
>;
export type ScenariosGetScenarioUpdatesQueryError = unknown;

export function useScenariosGetScenarioUpdates<
  TData = Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>,
  TError = unknown
>(
  scenarioId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioUpdatesQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetLatestVersionForDeletedScenario = (scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<number>({
    url: `/api/Scenarios/GetLatestVersionForDeletedScenario/deleted/${scenarioId}/latestVersion`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetLatestVersionForDeletedScenarioQueryKey = (scenarioId?: number) => {
  return [`/api/Scenarios/GetLatestVersionForDeletedScenario/deleted/${scenarioId}/latestVersion`] as const;
};

export const getScenariosGetLatestVersionForDeletedScenarioQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>,
  TError = ProblemDetails
>(
  scenarioId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetLatestVersionForDeletedScenarioQueryKey(scenarioId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>> = ({
    signal
  }) => scenariosGetLatestVersionForDeletedScenario(scenarioId, signal);

  return { queryKey, queryFn, enabled: !!scenarioId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetLatestVersionForDeletedScenarioQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>
>;
export type ScenariosGetLatestVersionForDeletedScenarioQueryError = ProblemDetails;

export function useScenariosGetLatestVersionForDeletedScenario<
  TData = Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>,
  TError = ProblemDetails
>(
  scenarioId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetLatestVersionForDeletedScenarioQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosCopyScenario = (copyScenarioCommand: CopyScenarioCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/CopyScenario/copy`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: copyScenarioCommand,
    signal
  });
};

export const getScenariosCopyScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosCopyScenario>>,
    TError,
    { data: CopyScenarioCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosCopyScenario>>,
  TError,
  { data: CopyScenarioCommand },
  TContext
> => {
  const mutationKey = ['scenariosCopyScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosCopyScenario>>,
    { data: CopyScenarioCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scenariosCopyScenario(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosCopyScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof scenariosCopyScenario>>>;
export type ScenariosCopyScenarioMutationBody = CopyScenarioCommand;
export type ScenariosCopyScenarioMutationError = unknown;

export const useScenariosCopyScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosCopyScenario>>,
    TError,
    { data: CopyScenarioCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosCopyScenario>>,
  TError,
  { data: CopyScenarioCommand },
  TContext
> => {
  const mutationOptions = getScenariosCopyScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosConvertScenarioToSharedScenario = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/ConvertScenarioToSharedScenario/${id}/convertToShared`,
    method: 'POST',
    signal
  });
};

export const getScenariosConvertScenarioToSharedScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['scenariosConvertScenarioToSharedScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return scenariosConvertScenarioToSharedScenario(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosConvertScenarioToSharedScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>
>;

export type ScenariosConvertScenarioToSharedScenarioMutationError = unknown;

export const useScenariosConvertScenarioToSharedScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getScenariosConvertScenarioToSharedScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosConvertSharedScenarioToScenario = (
  id: number,
  convertFromSharedScenarioCommand: ConvertFromSharedScenarioCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/ConvertSharedScenarioToScenario/${id}/convertFromShared`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: convertFromSharedScenarioCommand,
    signal
  });
};

export const getScenariosConvertSharedScenarioToScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
    TError,
    { id: number; data: ConvertFromSharedScenarioCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
  TError,
  { id: number; data: ConvertFromSharedScenarioCommand },
  TContext
> => {
  const mutationKey = ['scenariosConvertSharedScenarioToScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
    { id: number; data: ConvertFromSharedScenarioCommand }
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosConvertSharedScenarioToScenario(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosConvertSharedScenarioToScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>
>;
export type ScenariosConvertSharedScenarioToScenarioMutationBody = ConvertFromSharedScenarioCommand;
export type ScenariosConvertSharedScenarioToScenarioMutationError = unknown;

export const useScenariosConvertSharedScenarioToScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
    TError,
    { id: number; data: ConvertFromSharedScenarioCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
  TError,
  { id: number; data: ConvertFromSharedScenarioCommand },
  TContext
> => {
  const mutationOptions = getScenariosConvertSharedScenarioToScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosAddCompaniesToSharedScenario = (
  id: number,
  scenariosAddCompaniesToSharedScenarioBody: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/AddCompaniesToSharedScenario/${id}/sharedCompany`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenariosAddCompaniesToSharedScenarioBody,
    signal
  });
};

export const getScenariosAddCompaniesToSharedScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
    TError,
    { id: number; data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
  TError,
  { id: number; data: number[] },
  TContext
> => {
  const mutationKey = ['scenariosAddCompaniesToSharedScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
    { id: number; data: number[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosAddCompaniesToSharedScenario(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosAddCompaniesToSharedScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>
>;
export type ScenariosAddCompaniesToSharedScenarioMutationBody = number[];
export type ScenariosAddCompaniesToSharedScenarioMutationError = unknown;

export const useScenariosAddCompaniesToSharedScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
    TError,
    { id: number; data: number[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
  TError,
  { id: number; data: number[] },
  TContext
> => {
  const mutationOptions = getScenariosAddCompaniesToSharedScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosRemoveCompaniesFromSharedScenario = (
  id: number,
  scenariosRemoveCompaniesFromSharedScenarioBody: number[]
) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/RemoveCompaniesFromSharedScenario/${id}/sharedCompany`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: scenariosRemoveCompaniesFromSharedScenarioBody
  });
};

export const getScenariosRemoveCompaniesFromSharedScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
    TError,
    { id: number; data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
  TError,
  { id: number; data: number[] },
  TContext
> => {
  const mutationKey = ['scenariosRemoveCompaniesFromSharedScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
    { id: number; data: number[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosRemoveCompaniesFromSharedScenario(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRemoveCompaniesFromSharedScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>
>;
export type ScenariosRemoveCompaniesFromSharedScenarioMutationBody = number[];
export type ScenariosRemoveCompaniesFromSharedScenarioMutationError = unknown;

export const useScenariosRemoveCompaniesFromSharedScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
    TError,
    { id: number; data: number[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
  TError,
  { id: number; data: number[] },
  TContext
> => {
  const mutationOptions = getScenariosRemoveCompaniesFromSharedScenarioMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosGetDefaultScenarioGender = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<Gender>({
    url: `/api/Scenarios/GetDefaultScenarioGender/${id}/gender`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetDefaultScenarioGenderQueryKey = (id?: number) => {
  return [`/api/Scenarios/GetDefaultScenarioGender/${id}/gender`] as const;
};

export const getScenariosGetDefaultScenarioGenderQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetDefaultScenarioGenderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>> = ({ signal }) =>
    scenariosGetDefaultScenarioGender(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetDefaultScenarioGenderQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>
>;
export type ScenariosGetDefaultScenarioGenderQueryError = unknown;

export function useScenariosGetDefaultScenarioGender<
  TData = Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetDefaultScenarioGenderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetTrendingScenarioIds = (
  trendingScenariosCommand: TrendingScenariosCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<number[]>({
    url: `/api/Scenarios/GetTrendingScenarioIds/trending`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: trendingScenariosCommand,
    signal
  });
};

export const getScenariosGetTrendingScenarioIdsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
    TError,
    { data: TrendingScenariosCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
  TError,
  { data: TrendingScenariosCommand },
  TContext
> => {
  const mutationKey = ['scenariosGetTrendingScenarioIds'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
    { data: TrendingScenariosCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scenariosGetTrendingScenarioIds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosGetTrendingScenarioIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>
>;
export type ScenariosGetTrendingScenarioIdsMutationBody = TrendingScenariosCommand;
export type ScenariosGetTrendingScenarioIdsMutationError = unknown;

export const useScenariosGetTrendingScenarioIds = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
    TError,
    { data: TrendingScenariosCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
  TError,
  { data: TrendingScenariosCommand },
  TContext
> => {
  const mutationOptions = getScenariosGetTrendingScenarioIdsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosUpdateScenarioPdf = (
  id: number,
  scenariosUpdateScenarioPdfBody: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo
) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/UpdateScenarioPdf/${id}/pdf`,
    method: 'PUT',
    data: scenariosUpdateScenarioPdfBody
  });
};

export const getScenariosUpdateScenarioPdfMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
    TError,
    { id: number; data: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
  TError,
  { id: number; data: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo },
  TContext
> => {
  const mutationKey = ['scenariosUpdateScenarioPdf'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
    { id: number; data: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo }
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosUpdateScenarioPdf(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosUpdateScenarioPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>
>;
export type ScenariosUpdateScenarioPdfMutationBody =
  | ScenariosUpdateScenarioPdfBodyOne
  | ScenariosUpdateScenarioPdfBodyTwo;
export type ScenariosUpdateScenarioPdfMutationError = unknown;

export const useScenariosUpdateScenarioPdf = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
    TError,
    { id: number; data: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
  TError,
  { id: number; data: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo },
  TContext
> => {
  const mutationOptions = getScenariosUpdateScenarioPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosRemoveScenarioPdf = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/Scenarios/RemoveScenarioPdf/${id}/pdf`, method: 'DELETE' });
};

export const getScenariosRemoveScenarioPdfMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>, TError, { id: number }, TContext> => {
  const mutationKey = ['scenariosRemoveScenarioPdf'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return scenariosRemoveScenarioPdf(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRemoveScenarioPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>
>;

export type ScenariosRemoveScenarioPdfMutationError = unknown;

export const useScenariosRemoveScenarioPdf = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>, TError, { id: number }, TContext> => {
  const mutationOptions = getScenariosRemoveScenarioPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scenariosGetScenarioPdf = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<AttachmentDto>({ url: `/api/Scenarios/GetScenarioPdf/${id}/pdf`, method: 'GET', signal });
};

export const getScenariosGetScenarioPdfQueryKey = (id?: number) => {
  return [`/api/Scenarios/GetScenarioPdf/${id}/pdf`] as const;
};

export const getScenariosGetScenarioPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenarioPdf>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioPdfQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>> = ({ signal }) =>
    scenariosGetScenarioPdf(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenarioPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenarioPdfQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>>;
export type ScenariosGetScenarioPdfQueryError = unknown;

export function useScenariosGetScenarioPdf<
  TData = Awaited<ReturnType<typeof scenariosGetScenarioPdf>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioPdfQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scenariosGetRecommendedScenarios = (signal?: AbortSignal) => {
  return customAxiosInstance<number[]>({
    url: `/api/Scenarios/GetRecommendedScenarios/recommendations`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetRecommendedScenariosQueryKey = () => {
  return [`/api/Scenarios/GetRecommendedScenarios/recommendations`] as const;
};

export const getScenariosGetRecommendedScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetRecommendedScenariosQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>> = ({ signal }) =>
    scenariosGetRecommendedScenarios(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetRecommendedScenariosQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>
>;
export type ScenariosGetRecommendedScenariosQueryError = unknown;

export function useScenariosGetRecommendedScenarios<
  TData = Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetRecommendedScenariosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scheduledCallsGet = (params?: ScheduledCallsGetParams, signal?: AbortSignal) => {
  return customAxiosInstance<PartialListScheduledCallDto>({
    url: `/api/ScheduledCalls/Get`,
    method: 'GET',
    params,
    signal
  });
};

export const getScheduledCallsGetQueryKey = (params?: ScheduledCallsGetParams) => {
  return [`/api/ScheduledCalls/Get`, ...(params ? [params] : [])] as const;
};

export const getScheduledCallsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof scheduledCallsGet>>,
  TError = unknown
>(
  params?: ScheduledCallsGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scheduledCallsGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScheduledCallsGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scheduledCallsGet>>> = ({ signal }) =>
    scheduledCallsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scheduledCallsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScheduledCallsGetQueryResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsGet>>>;
export type ScheduledCallsGetQueryError = unknown;

export function useScheduledCallsGet<TData = Awaited<ReturnType<typeof scheduledCallsGet>>, TError = unknown>(
  params?: ScheduledCallsGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scheduledCallsGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScheduledCallsGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const scheduledCallsCreate = (createScheduledCallCommand: CreateScheduledCallCommand, signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCallDto>({
    url: `/api/ScheduledCalls/Create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduledCallCommand,
    signal
  });
};

export const getScheduledCallsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsCreate>>,
    TError,
    { data: CreateScheduledCallCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsCreate>>,
  TError,
  { data: CreateScheduledCallCommand },
  TContext
> => {
  const mutationKey = ['scheduledCallsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsCreate>>,
    { data: CreateScheduledCallCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scheduledCallsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsCreate>>>;
export type ScheduledCallsCreateMutationBody = CreateScheduledCallCommand;
export type ScheduledCallsCreateMutationError = void;

export const useScheduledCallsCreate = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsCreate>>,
    TError,
    { data: CreateScheduledCallCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsCreate>>,
  TError,
  { data: CreateScheduledCallCommand },
  TContext
> => {
  const mutationOptions = getScheduledCallsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scheduledCallsUpdate = (
  scheduledCallId: number,
  updateScheduledCallCommand: UpdateScheduledCallCommand
) => {
  return customAxiosInstance<ScheduledCallDto>({
    url: `/api/ScheduledCalls/Update/${scheduledCallId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScheduledCallCommand
  });
};

export const getScheduledCallsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdate>>,
    TError,
    { scheduledCallId: number; data: UpdateScheduledCallCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsUpdate>>,
  TError,
  { scheduledCallId: number; data: UpdateScheduledCallCommand },
  TContext
> => {
  const mutationKey = ['scheduledCallsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsUpdate>>,
    { scheduledCallId: number; data: UpdateScheduledCallCommand }
  > = (props) => {
    const { scheduledCallId, data } = props ?? {};

    return scheduledCallsUpdate(scheduledCallId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsUpdate>>>;
export type ScheduledCallsUpdateMutationBody = UpdateScheduledCallCommand;
export type ScheduledCallsUpdateMutationError = unknown;

export const useScheduledCallsUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdate>>,
    TError,
    { scheduledCallId: number; data: UpdateScheduledCallCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsUpdate>>,
  TError,
  { scheduledCallId: number; data: UpdateScheduledCallCommand },
  TContext
> => {
  const mutationOptions = getScheduledCallsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scheduledCallsUpdateStatus = (scheduledCallId: number, params?: ScheduledCallsUpdateStatusParams) => {
  return customAxiosInstance<ScheduledCallDto>({
    url: `/api/ScheduledCalls/UpdateStatus/${scheduledCallId}/status`,
    method: 'PUT',
    params
  });
};

export const getScheduledCallsUpdateStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
    TError,
    { scheduledCallId: number; params?: ScheduledCallsUpdateStatusParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
  TError,
  { scheduledCallId: number; params?: ScheduledCallsUpdateStatusParams },
  TContext
> => {
  const mutationKey = ['scheduledCallsUpdateStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
    { scheduledCallId: number; params?: ScheduledCallsUpdateStatusParams }
  > = (props) => {
    const { scheduledCallId, params } = props ?? {};

    return scheduledCallsUpdateStatus(scheduledCallId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsUpdateStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>
>;

export type ScheduledCallsUpdateStatusMutationError = unknown;

export const useScheduledCallsUpdateStatus = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
    TError,
    { scheduledCallId: number; params?: ScheduledCallsUpdateStatusParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
  TError,
  { scheduledCallId: number; params?: ScheduledCallsUpdateStatusParams },
  TContext
> => {
  const mutationOptions = getScheduledCallsUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

export const scheduledCallsDelete = (deleteScheduledCallsCommand: DeleteScheduledCallsCommand) => {
  return customAxiosInstance<void>({
    url: `/api/ScheduledCalls/Delete`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteScheduledCallsCommand
  });
};

export const getScheduledCallsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsDelete>>,
    TError,
    { data: DeleteScheduledCallsCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsDelete>>,
  TError,
  { data: DeleteScheduledCallsCommand },
  TContext
> => {
  const mutationKey = ['scheduledCallsDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsDelete>>,
    { data: DeleteScheduledCallsCommand }
  > = (props) => {
    const { data } = props ?? {};

    return scheduledCallsDelete(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsDelete>>>;
export type ScheduledCallsDeleteMutationBody = DeleteScheduledCallsCommand;
export type ScheduledCallsDeleteMutationError = unknown;

export const useScheduledCallsDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsDelete>>,
    TError,
    { data: DeleteScheduledCallsCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsDelete>>,
  TError,
  { data: DeleteScheduledCallsCommand },
  TContext
> => {
  const mutationOptions = getScheduledCallsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const speechSynthesizeSpeech = (synthesizeSpeechCommand: SynthesizeSpeechCommand, signal?: AbortSignal) => {
  return customAxiosInstance<string>({
    url: `/api/Speech/SynthesizeSpeech/synthesizeSpeech`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: synthesizeSpeechCommand,
    signal
  });
};

export const getSpeechSynthesizeSpeechMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
    TError,
    { data: SynthesizeSpeechCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
  TError,
  { data: SynthesizeSpeechCommand },
  TContext
> => {
  const mutationKey = ['speechSynthesizeSpeech'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
    { data: SynthesizeSpeechCommand }
  > = (props) => {
    const { data } = props ?? {};

    return speechSynthesizeSpeech(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpeechSynthesizeSpeechMutationResult = NonNullable<Awaited<ReturnType<typeof speechSynthesizeSpeech>>>;
export type SpeechSynthesizeSpeechMutationBody = SynthesizeSpeechCommand;
export type SpeechSynthesizeSpeechMutationError = unknown;

export const useSpeechSynthesizeSpeech = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
    TError,
    { data: SynthesizeSpeechCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
  TError,
  { data: SynthesizeSpeechCommand },
  TContext
> => {
  const mutationOptions = getSpeechSynthesizeSpeechMutationOptions(options);

  return useMutation(mutationOptions);
};

export const speechRecognizeSpeech = (
  speechRecognizeSpeechBody: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo,
  params?: SpeechRecognizeSpeechParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/Speech/RecognizeSpeech/stt`,
    method: 'POST',
    data: speechRecognizeSpeechBody,
    params,
    signal
  });
};

export const getSpeechRecognizeSpeechMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechRecognizeSpeech>>,
    TError,
    { data: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo; params?: SpeechRecognizeSpeechParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof speechRecognizeSpeech>>,
  TError,
  { data: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo; params?: SpeechRecognizeSpeechParams },
  TContext
> => {
  const mutationKey = ['speechRecognizeSpeech'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof speechRecognizeSpeech>>,
    { data: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo; params?: SpeechRecognizeSpeechParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return speechRecognizeSpeech(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpeechRecognizeSpeechMutationResult = NonNullable<Awaited<ReturnType<typeof speechRecognizeSpeech>>>;
export type SpeechRecognizeSpeechMutationBody = SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo;
export type SpeechRecognizeSpeechMutationError = unknown;

export const useSpeechRecognizeSpeech = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechRecognizeSpeech>>,
    TError,
    { data: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo; params?: SpeechRecognizeSpeechParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof speechRecognizeSpeech>>,
  TError,
  { data: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo; params?: SpeechRecognizeSpeechParams },
  TContext
> => {
  const mutationOptions = getSpeechRecognizeSpeechMutationOptions(options);

  return useMutation(mutationOptions);
};

export const speechGetVoiceList = (signal?: AbortSignal) => {
  return customAxiosInstance<Speaker[]>({ url: `/api/Speech/GetVoiceList/voices`, method: 'GET', signal });
};

export const getSpeechGetVoiceListQueryKey = () => {
  return [`/api/Speech/GetVoiceList/voices`] as const;
};

export const getSpeechGetVoiceListQueryOptions = <
  TData = Awaited<ReturnType<typeof speechGetVoiceList>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof speechGetVoiceList>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSpeechGetVoiceListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof speechGetVoiceList>>> = ({ signal }) =>
    speechGetVoiceList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof speechGetVoiceList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpeechGetVoiceListQueryResult = NonNullable<Awaited<ReturnType<typeof speechGetVoiceList>>>;
export type SpeechGetVoiceListQueryError = unknown;

export function useSpeechGetVoiceList<
  TData = Awaited<ReturnType<typeof speechGetVoiceList>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof speechGetVoiceList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSpeechGetVoiceListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const ttsAdminRefreshVoices = (signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({ url: `/api/admin/tts/elevenlabs/refresh-voices`, method: 'POST', signal });
};

export const getTtsAdminRefreshVoicesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext> => {
  const mutationKey = ['ttsAdminRefreshVoices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, void> = () => {
    return ttsAdminRefreshVoices();
  };

  return { mutationFn, ...mutationOptions };
};

export type TtsAdminRefreshVoicesMutationResult = NonNullable<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>>;

export type TtsAdminRefreshVoicesMutationError = unknown;

export const useTtsAdminRefreshVoices = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext> => {
  const mutationOptions = getTtsAdminRefreshVoicesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const twilioGetPhoneNumbers = (signal?: AbortSignal) => {
  return customAxiosInstance<TwilioPhoneNumberDto[]>({ url: `/api/Twilio/GetPhoneNumbers`, method: 'GET', signal });
};

export const getTwilioGetPhoneNumbersQueryKey = () => {
  return [`/api/Twilio/GetPhoneNumbers`] as const;
};

export const getTwilioGetPhoneNumbersQueryOptions = <
  TData = Awaited<ReturnType<typeof twilioGetPhoneNumbers>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwilioGetPhoneNumbersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>> = ({ signal }) =>
    twilioGetPhoneNumbers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof twilioGetPhoneNumbers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TwilioGetPhoneNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>>;
export type TwilioGetPhoneNumbersQueryError = unknown;

export function useTwilioGetPhoneNumbers<
  TData = Awaited<ReturnType<typeof twilioGetPhoneNumbers>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTwilioGetPhoneNumbersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const usageStatisticsStatistics = (usageStatisticsQuery: UsageStatisticsQuery, signal?: AbortSignal) => {
  return customAxiosInstance<UsageStatisticsDto>({
    url: `/api/UsageStatistics/Statistics/statistics`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: usageStatisticsQuery,
    signal
  });
};

export const getUsageStatisticsStatisticsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usageStatisticsStatistics>>,
    TError,
    { data: UsageStatisticsQuery },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usageStatisticsStatistics>>,
  TError,
  { data: UsageStatisticsQuery },
  TContext
> => {
  const mutationKey = ['usageStatisticsStatistics'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usageStatisticsStatistics>>,
    { data: UsageStatisticsQuery }
  > = (props) => {
    const { data } = props ?? {};

    return usageStatisticsStatistics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsageStatisticsStatisticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof usageStatisticsStatistics>>
>;
export type UsageStatisticsStatisticsMutationBody = UsageStatisticsQuery;
export type UsageStatisticsStatisticsMutationError = unknown;

export const useUsageStatisticsStatistics = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usageStatisticsStatistics>>,
    TError,
    { data: UsageStatisticsQuery },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof usageStatisticsStatistics>>,
  TError,
  { data: UsageStatisticsQuery },
  TContext
> => {
  const mutationOptions = getUsageStatisticsStatisticsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userGetUsers = (signal?: AbortSignal) => {
  return customAxiosInstance<UserDto[]>({ url: `/api/User/GetUsers/filter`, method: 'GET', signal });
};

export const getUserGetUsersQueryKey = () => {
  return [`/api/User/GetUsers/filter`] as const;
};

export const getUserGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetUsers>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetUsers>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGetUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUsers>>> = ({ signal }) => userGetUsers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUsers>>>;
export type UserGetUsersQueryError = unknown;

export function useUserGetUsers<TData = Awaited<ReturnType<typeof userGetUsers>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetUsers>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGetUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const userDeleteUser = (id: number) => {
  return customAxiosInstance<void>({ url: `/api/User/DeleteUser/${id}`, method: 'DELETE' });
};

export const getUserDeleteUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof userDeleteUser>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof userDeleteUser>>, TError, { id: number }, TContext> => {
  const mutationKey = ['userDeleteUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteUser>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return userDeleteUser(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteUser>>>;

export type UserDeleteUserMutationError = unknown;

export const useUserDeleteUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof userDeleteUser>>, TError, { id: number }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof userDeleteUser>>, TError, { id: number }, TContext> => {
  const mutationOptions = getUserDeleteUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userDeleteUsers = (userDeleteUsersBody: number[]) => {
  return customAxiosInstance<void>({
    url: `/api/User/DeleteUsers/deleteUsers`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: userDeleteUsersBody
  });
};

export const getUserDeleteUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof userDeleteUsers>>, TError, { data: number[] }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof userDeleteUsers>>, TError, { data: number[] }, TContext> => {
  const mutationKey = ['userDeleteUsers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteUsers>>, { data: number[] }> = (props) => {
    const { data } = props ?? {};

    return userDeleteUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteUsers>>>;
export type UserDeleteUsersMutationBody = number[];
export type UserDeleteUsersMutationError = unknown;

export const useUserDeleteUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof userDeleteUsers>>, TError, { data: number[] }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof userDeleteUsers>>, TError, { data: number[] }, TContext> => {
  const mutationOptions = getUserDeleteUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userCreateOrganizationInvitation = (
  createOrganizationInvitationCommand: CreateOrganizationInvitationCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/User/CreateOrganizationInvitation/invite`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOrganizationInvitationCommand,
    signal
  });
};

export const getUserCreateOrganizationInvitationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
    TError,
    { data: CreateOrganizationInvitationCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
  TError,
  { data: CreateOrganizationInvitationCommand },
  TContext
> => {
  const mutationKey = ['userCreateOrganizationInvitation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
    { data: CreateOrganizationInvitationCommand }
  > = (props) => {
    const { data } = props ?? {};

    return userCreateOrganizationInvitation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserCreateOrganizationInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof userCreateOrganizationInvitation>>
>;
export type UserCreateOrganizationInvitationMutationBody = CreateOrganizationInvitationCommand;
export type UserCreateOrganizationInvitationMutationError = unknown;

export const useUserCreateOrganizationInvitation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
    TError,
    { data: CreateOrganizationInvitationCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
  TError,
  { data: CreateOrganizationInvitationCommand },
  TContext
> => {
  const mutationOptions = getUserCreateOrganizationInvitationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userInviteMultipleUsers = (
  inviteMultipleUsersCommand: InviteMultipleUsersCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/User/InviteMultipleUsers/inviteMultiple`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: inviteMultipleUsersCommand,
    signal
  });
};

export const getUserInviteMultipleUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userInviteMultipleUsers>>,
    TError,
    { data: InviteMultipleUsersCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userInviteMultipleUsers>>,
  TError,
  { data: InviteMultipleUsersCommand },
  TContext
> => {
  const mutationKey = ['userInviteMultipleUsers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userInviteMultipleUsers>>,
    { data: InviteMultipleUsersCommand }
  > = (props) => {
    const { data } = props ?? {};

    return userInviteMultipleUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserInviteMultipleUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userInviteMultipleUsers>>>;
export type UserInviteMultipleUsersMutationBody = InviteMultipleUsersCommand;
export type UserInviteMultipleUsersMutationError = unknown;

export const useUserInviteMultipleUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userInviteMultipleUsers>>,
    TError,
    { data: InviteMultipleUsersCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userInviteMultipleUsers>>,
  TError,
  { data: InviteMultipleUsersCommand },
  TContext
> => {
  const mutationOptions = getUserInviteMultipleUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userDeleteInvitation = (email: string) => {
  return customAxiosInstance<void>({ url: `/api/User/DeleteInvitation/invitation/${email}`, method: 'DELETE' });
};

export const getUserDeleteInvitationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof userDeleteInvitation>>, TError, { email: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof userDeleteInvitation>>, TError, { email: string }, TContext> => {
  const mutationKey = ['userDeleteInvitation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteInvitation>>, { email: string }> = (props) => {
    const { email } = props ?? {};

    return userDeleteInvitation(email);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteInvitation>>>;

export type UserDeleteInvitationMutationError = unknown;

export const useUserDeleteInvitation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof userDeleteInvitation>>, TError, { email: string }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof userDeleteInvitation>>, TError, { email: string }, TContext> => {
  const mutationOptions = getUserDeleteInvitationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userGetCurrentUser = (signal?: AbortSignal) => {
  return customAxiosInstance<UserDto>({ url: `/api/User/GetCurrentUser/current`, method: 'GET', signal });
};

export const getUserGetCurrentUserQueryKey = () => {
  return [`/api/User/GetCurrentUser/current`] as const;
};

export const getUserGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetCurrentUser>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetCurrentUser>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetCurrentUser>>> = ({ signal }) =>
    userGetCurrentUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof userGetCurrentUser>>>;
export type UserGetCurrentUserQueryError = unknown;

export function useUserGetCurrentUser<
  TData = Awaited<ReturnType<typeof userGetCurrentUser>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetCurrentUser>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const userGetTenants = (signal?: AbortSignal) => {
  return customAxiosInstance<TenantDto[]>({ url: `/api/User/GetTenants/tenants`, method: 'GET', signal });
};

export const getUserGetTenantsQueryKey = () => {
  return [`/api/User/GetTenants/tenants`] as const;
};

export const getUserGetTenantsQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetTenants>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetTenants>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGetTenantsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetTenants>>> = ({ signal }) => userGetTenants(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetTenants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGetTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetTenants>>>;
export type UserGetTenantsQueryError = unknown;

export function useUserGetTenants<TData = Awaited<ReturnType<typeof userGetTenants>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetTenants>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGetTenantsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const userGroupGet = (params?: UserGroupGetParams, signal?: AbortSignal) => {
  return customAxiosInstance<PartialListUserGroupDto>({ url: `/api/UserGroup/Get`, method: 'GET', params, signal });
};

export const getUserGroupGetQueryKey = (params?: UserGroupGetParams) => {
  return [`/api/UserGroup/Get`, ...(params ? [params] : [])] as const;
};

export const getUserGroupGetQueryOptions = <TData = Awaited<ReturnType<typeof userGroupGet>>, TError = unknown>(
  params?: UserGroupGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof userGroupGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGroupGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGroupGet>>> = ({ signal }) => userGroupGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGroupGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGroupGetQueryResult = NonNullable<Awaited<ReturnType<typeof userGroupGet>>>;
export type UserGroupGetQueryError = unknown;

export function useUserGroupGet<TData = Awaited<ReturnType<typeof userGroupGet>>, TError = unknown>(
  params?: UserGroupGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof userGroupGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGroupGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const userGroupCreate = (createUserGroupCommand: CreateUserGroupCommand) => {
  return customAxiosInstance<UserGroupDto>({
    url: `/api/UserGroup/Create`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createUserGroupCommand
  });
};

export const getUserGroupCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupCreate>>,
    TError,
    { data: CreateUserGroupCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupCreate>>,
  TError,
  { data: CreateUserGroupCommand },
  TContext
> => {
  const mutationKey = ['userGroupCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userGroupCreate>>, { data: CreateUserGroupCommand }> = (
    props
  ) => {
    const { data } = props ?? {};

    return userGroupCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupCreate>>>;
export type UserGroupCreateMutationBody = CreateUserGroupCommand;
export type UserGroupCreateMutationError = void;

export const useUserGroupCreate = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupCreate>>,
    TError,
    { data: CreateUserGroupCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupCreate>>,
  TError,
  { data: CreateUserGroupCommand },
  TContext
> => {
  const mutationOptions = getUserGroupCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userGroupUpdate = (
  groupId: number,
  updateUserGroupCommand: UpdateUserGroupCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserGroupDto>({
    url: `/api/UserGroup/Update/${groupId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateUserGroupCommand,
    signal
  });
};

export const getUserGroupUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupUpdate>>,
    TError,
    { groupId: number; data: UpdateUserGroupCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupUpdate>>,
  TError,
  { groupId: number; data: UpdateUserGroupCommand },
  TContext
> => {
  const mutationKey = ['userGroupUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupUpdate>>,
    { groupId: number; data: UpdateUserGroupCommand }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return userGroupUpdate(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupUpdate>>>;
export type UserGroupUpdateMutationBody = UpdateUserGroupCommand;
export type UserGroupUpdateMutationError = unknown;

export const useUserGroupUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupUpdate>>,
    TError,
    { groupId: number; data: UpdateUserGroupCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupUpdate>>,
  TError,
  { groupId: number; data: UpdateUserGroupCommand },
  TContext
> => {
  const mutationOptions = getUserGroupUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userGroupAddUsers = (
  groupId: number,
  addUsersToGroupCommand: AddUsersToGroupCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserGroupDto>({
    url: `/api/UserGroup/AddUsers/${groupId}/users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addUsersToGroupCommand,
    signal
  });
};

export const getUserGroupAddUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupAddUsers>>,
    TError,
    { groupId: number; data: AddUsersToGroupCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupAddUsers>>,
  TError,
  { groupId: number; data: AddUsersToGroupCommand },
  TContext
> => {
  const mutationKey = ['userGroupAddUsers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupAddUsers>>,
    { groupId: number; data: AddUsersToGroupCommand }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return userGroupAddUsers(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupAddUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupAddUsers>>>;
export type UserGroupAddUsersMutationBody = AddUsersToGroupCommand;
export type UserGroupAddUsersMutationError = unknown;

export const useUserGroupAddUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupAddUsers>>,
    TError,
    { groupId: number; data: AddUsersToGroupCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupAddUsers>>,
  TError,
  { groupId: number; data: AddUsersToGroupCommand },
  TContext
> => {
  const mutationOptions = getUserGroupAddUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userGroupDeleteUsers = (groupId: number, deleteUsersFromGroupCommand: DeleteUsersFromGroupCommand) => {
  return customAxiosInstance<void>({
    url: `/api/UserGroup/DeleteUsers/${groupId}/users`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteUsersFromGroupCommand
  });
};

export const getUserGroupDeleteUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteUsers>>,
    TError,
    { groupId: number; data: DeleteUsersFromGroupCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupDeleteUsers>>,
  TError,
  { groupId: number; data: DeleteUsersFromGroupCommand },
  TContext
> => {
  const mutationKey = ['userGroupDeleteUsers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupDeleteUsers>>,
    { groupId: number; data: DeleteUsersFromGroupCommand }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return userGroupDeleteUsers(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupDeleteUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupDeleteUsers>>>;
export type UserGroupDeleteUsersMutationBody = DeleteUsersFromGroupCommand;
export type UserGroupDeleteUsersMutationError = unknown;

export const useUserGroupDeleteUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteUsers>>,
    TError,
    { groupId: number; data: DeleteUsersFromGroupCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupDeleteUsers>>,
  TError,
  { groupId: number; data: DeleteUsersFromGroupCommand },
  TContext
> => {
  const mutationOptions = getUserGroupDeleteUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userGroupDeleteGroups = (deleteUserGroupCommand: DeleteUserGroupCommand) => {
  return customAxiosInstance<void>({
    url: `/api/UserGroup/DeleteGroups`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteUserGroupCommand
  });
};

export const getUserGroupDeleteGroupsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteGroups>>,
    TError,
    { data: DeleteUserGroupCommand },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupDeleteGroups>>,
  TError,
  { data: DeleteUserGroupCommand },
  TContext
> => {
  const mutationKey = ['userGroupDeleteGroups'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupDeleteGroups>>,
    { data: DeleteUserGroupCommand }
  > = (props) => {
    const { data } = props ?? {};

    return userGroupDeleteGroups(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupDeleteGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupDeleteGroups>>>;
export type UserGroupDeleteGroupsMutationBody = DeleteUserGroupCommand;
export type UserGroupDeleteGroupsMutationError = unknown;

export const useUserGroupDeleteGroups = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteGroups>>,
    TError,
    { data: DeleteUserGroupCommand },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupDeleteGroups>>,
  TError,
  { data: DeleteUserGroupCommand },
  TContext
> => {
  const mutationOptions = getUserGroupDeleteGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const voicesGetVoice = (id: string, signal?: AbortSignal) => {
  return customAxiosInstance<string>({ url: `/api/Voices/GetVoice/${id}`, method: 'GET', signal });
};

export const getVoicesGetVoiceQueryKey = (id?: string) => {
  return [`/api/Voices/GetVoice/${id}`] as const;
};

export const getVoicesGetVoiceQueryOptions = <TData = Awaited<ReturnType<typeof voicesGetVoice>>, TError = unknown>(
  id: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof voicesGetVoice>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVoicesGetVoiceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof voicesGetVoice>>> = ({ signal }) => voicesGetVoice(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof voicesGetVoice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type VoicesGetVoiceQueryResult = NonNullable<Awaited<ReturnType<typeof voicesGetVoice>>>;
export type VoicesGetVoiceQueryError = unknown;

export function useVoicesGetVoice<TData = Awaited<ReturnType<typeof voicesGetVoice>>, TError = unknown>(
  id: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof voicesGetVoice>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getVoicesGetVoiceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const voicesDeleteVoice = (id: string) => {
  return customAxiosInstance<void>({ url: `/api/Voices/DeleteVoice/${id}`, method: 'DELETE' });
};

export const getVoicesDeleteVoiceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof voicesDeleteVoice>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof voicesDeleteVoice>>, TError, { id: string }, TContext> => {
  const mutationKey = ['voicesDeleteVoice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof voicesDeleteVoice>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return voicesDeleteVoice(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoicesDeleteVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof voicesDeleteVoice>>>;

export type VoicesDeleteVoiceMutationError = unknown;

export const useVoicesDeleteVoice = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof voicesDeleteVoice>>, TError, { id: string }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof voicesDeleteVoice>>, TError, { id: string }, TContext> => {
  const mutationOptions = getVoicesDeleteVoiceMutationOptions(options);

  return useMutation(mutationOptions);
};
